export const translations = {
  fr: {
    // Confirm delete dialog
    confirmDelete: {
      title: 'Confirmer la suppression',
      description: 'Cette action est irréversible.',
      confirm: 'Supprimer',
      cancel: 'Annuler'
    },
    // Navigation
    nav: {
      login: 'Connexion',
      signup: 'Créer mon compte',
      dashboard: 'Tableau de bord',
      transactions: 'Relevé d\'opérations',
      budget: 'Budgets',
      portfolio: 'Portefeuille',
      market: 'Marché',
      reports: 'Rapports',
      archive: 'Archive',
      settings: 'Paramètres',
      logout: 'Déconnexion'
    },
    // Landing Page
    landing: {
      title: 'Maîtrisez vos finances et investissements en un seul endroit',
      subtitle: 'Une plateforme complète pour gérer votre budget, suivre vos dépenses et optimiser votre portefeuille d\'investissements.',
      getStarted: 'Commencer gratuitement',
      tryDemo: '🎬 Essayer la démo — sans inscription',
      demoLoading: 'Ouverture de la démo…',
      demoSubtext: 'Explorez l\'application complète avec des données fictives, sans créer de compte.',
      demoBannerText: 'Mode démo — données fictives partagées, remises à zéro chaque jour.',
      demoBannerCta: 'Créer mon compte gratuit',
      trackingOnlyTitle: 'Plateforme de suivi uniquement',
      trackingOnlyBody: 'Auto-Gère n\'exécute aucune transaction financière : aucun achat ou vente de titres, aucun lien avec vos comptes bancaires ou de courtage. Vous saisissez vos données, l\'application les organise et les suit pour vous — vos fonds restent toujours chez votre institution.',
      launchCounter: 'Offre de lancement : déjà {count} abonnés — plus que {left} places au prix réduit, gelé à vie !',
      launchPriceHero: 'Prix de lancement : {monthly} $/mois ou {yearly} $/an — gelé à vie !',
      midCtaTitle: 'Convaincu ? Votre compte gratuit est prêt en 30 secondes.',
      pricingBadge: 'Tarifs',
      pricingTitle: 'Un prix simple, sans surprise',
      pricingSubtitle: 'Commencez gratuitement, passez à Premium quand vous êtes prêt. Annulable en tout temps.',
      pricingFreeTitle: 'Gratuit',
      pricingFreeSub: 'Sans carte de crédit',
      pricingFree1: 'Tableau de bord et budget complets',
      pricingFree2: '2 actifs en portefeuille',
      pricingFree3: '1 import de relevé (CSV/Excel)',
      pricingFreeCta: 'Créer mon compte gratuit',
      pricingLaunchBadge: 'Offre de lancement — 100 premiers',
      pricingMonthlyTitle: 'Premium mensuel',
      pricingPerMonth: '/mois',
      pricingPerYear: '/an',
      pricingFrozen: 'Prix gelé à vie tant que vous restez abonné',
      pricingPrem1: 'Actifs et imports illimités',
      pricingPrem2: 'Suivi complet des dividendes (calendrier, historique, totaux)',
      pricingPrem3: 'Alertes email et rapports mensuels PDF',
      pricingPrem4: 'Marchés en temps réel et multi-devises',
      pricingPremiumCta: 'Devenir membre fondateur',
      pricingYearlyTitle: 'Premium annuel',
      pricingYearlySave: '2 mois gratuits par rapport au mensuel',
      pricingNote: 'Prix en dollars canadiens (CAD). Paiement sécurisé par PayPal. Annulation en un clic, sans frais cachés.',
      launchPriceHeroSub: 'Réservé aux 100 premiers abonnés (prix régulier : {standard} $/mois ensuite). Essai gratuit inclus.',
      learnMore: 'En savoir plus',
      features: 'Fonctionnalités puissantes pour votre réussite financière',
      feature1Title: 'Suivi des dépenses',
      feature1Desc: 'Suivez toutes vos transactions et catégorisez vos dépenses automatiquement.',
      feature2Title: 'Gestion de budget',
      feature2Desc: 'Créez des budgets personnalisés et recevez des alertes avant de les dépasser.',
      feature3Title: 'Portefeuille d\'investissement',
      feature3Desc: 'Gérez vos actions et cryptomonnaies avec des prix en temps réel.',
      feature4Title: 'Alertes intelligentes',
      feature4Desc: 'Recevez des notifications pour les événements financiers importants.',
      feature5Title: 'Sécurité maximale',
      feature5Desc: 'Vos données sont cryptées et protégées selon les normes bancaires.',
      feature6Title: 'Rapports détaillés',
      feature6Desc: 'Visualisez vos finances avec des graphiques et rapports complets.',
      cta: 'Prêt à prendre le contrôle de vos finances ?',
      ctaSubtitle: 'Commencez gratuitement dès aujourd\'hui. Aucune carte bancaire requise.',
      ctaButton: 'Créer mon compte gratuit',
      footer: '© 2026 Auto-Gère. Tous droits réservés.',
      // === Landing page v2 (refonte 2026) ===
      heroBadge: 'Nouveautés 2026 · Import auto · Multi-devises · Budget Excel',
      heroTitleMain: 'Maîtrisez vos finances et investissements',
      heroTitleAccent: 'en un seul endroit',
      heroSubtitle: 'Suivi des dépenses, budget style Excel, portefeuille multi-devises et rapports PDF — importez vos relevés (CSV/Excel) en un clic, aucune connexion bancaire requise.',
      reassureEncryption: 'Chiffrement bancaire',
      reassureEncryptionSub: 'JWT + 2FA TOTP',
      reassureRealtime: 'Données en temps réel',
      reassureRealtimeSub: 'Yahoo Finance · CoinGecko',
      reassureAlerts: 'Alertes par email',
      reassureAlertsSub: 'Watchlist & seuils',
      reassureFree: 'Gratuit pour démarrer',
      reassureFreeSub: '1 téléchargement de relevé · 2 actifs',
      slidesBadge: 'Visite guidée',
      slidesTitle: "Découvrez Auto-Gère écran par écran",
      slidesSubtitle: "Un aperçu réel de chaque onglet du logiciel — tableau de bord, budget, portefeuille, marché et plus encore.",
      slide_dashboard: 'Tableau de bord — toutes vos finances en un coup d\'œil',
      slide_transactions: 'Relevé d\'opérations — revenus et dépenses classés',
      slide_budget: 'Budgets — dates de paiement, rappels et progression en direct',
      slide_portfolio: 'Portefeuille — actions et crypto en temps réel, multi-devises',
      slide_market: 'Marché — surveillance, alertes de prix et capitalisation',
      slide_reports: 'Rapports — exports PDF/Excel sur mesure',
      slide_archive: 'Archive — 7 ans d\'historique PDF, envoi par email',
      slide_settings: 'Paramètres — sécurité 2FA et abonnement flexible',
      videoBadge: 'Démo vidéo',
      videoTitle: 'Découvrez Auto-Gère en vidéo',
      videoSubtitle: "Une visite guidée du logiciel : tableau de bord, budget, portefeuille, rapports — voyez tout ce qu'Auto-Gère peut faire pour vos finances.",
      videoTabFull: 'Présentation complète',
      videoTabTransactions: 'Le relevé d\'opérations',
      videoPlayCta: 'Lancer la vidéo',
      videoNoSound: 'Démonstration visuelle · sans narration',
      sectionTitle: 'Toutes les fonctionnalités, sans compromis',
      sectionSubtitle: 'Découvrez ce qui rend Auto-Gère unique : automatisation intelligente, multi-devises natif et outils dignes d\'un tableur — le tout dans une seule interface fluide.',
      badgeNew: 'Nouveau',
      featAiImportTitle: 'Import de relevés bancaires',
      featAiImportDesc: 'Glissez votre relevé PDF, CSV, OFX, QFX ou même une photo : Auto-Gère extrait automatiquement vos transactions, détecte la devise et la catégorie. Le document source n\'est jamais conservé sur nos serveurs.',
      featBudgetExcelTitle: 'Budget Excel-style détaillé',
      featBudgetExcelDesc: 'Vue tableur avec colonnes "Auto-paid" (vert / rouge), dates de paiement par paye, calculs dynamiques et périodes personnalisables. Le confort d\'Excel, la fluidité du web.',
      featMultiCurrencyTitle: 'Portefeuille multi-devises',
      featMultiCurrencyDesc: 'Suivez vos actions US, canadiennes (.TO / .UN), européennes et indiennes (.NS) avec leur drapeau national et leur devise native (USD, CAD, EUR, INR…). Conversion automatique vers le dollar canadien (devise principale par défaut).',
      featDashboardTitle: 'Tableau de bord enrichi',
      featDashboardDesc: 'Trois graphiques camemberts repositionnables (Total, US, Canada), suivi des dividendes mensuels, profit non réalisé en temps réel et résumé "Montant à virer par paye".',
      featDividendsTitle: 'Suivi des dividendes',
      featDividendsDesc: 'Calendrier des prochains détachements, fréquence visuelle (Mensuel / Trimestriel / Semestriel / Annuel), overrides manuels et total annuel cumulé par position.',
      featAnalysisTitle: 'Analyse de portefeuille avec notes A→F',
      featAnalysisDesc: 'Pour chaque action détenue : score qualité Auto-Gère de A à F basé sur 4 axes (P/E, ROE, dette, marge), consensus des analystes (Achat / Conservé / Vendre), résumé synthétique. Pour les titres sans couverture analyste, une recherche approfondie est générée automatiquement.',
      featToolsTitle: 'Outils financiers intégrés',
      featToolsDesc: 'Convertisseur de devises en temps réel (CAD · USD · EUR · GBP · CHF · JPY · INR) avec taux quotidien, calculateurs intelligents et plus à venir. Tout est disponible directement dans l\'onglet Marché → Outils.',
      featReportsTitle: 'Rapports & archivage annuel',
      featReportsDesc: 'Exportez vos transactions, budgets et portefeuille en PDF / Excel à tout moment. Recevez un rapport mensuel de performance par email. Archivez vos années passées en un clic.',
      portfolioBadge: 'Bourse mondiale',
      portfolioTitlePart1: 'Vos actions,',
      portfolioTitleAccent: 'leur devise',
      portfolioTitlePart2: ', votre vue d\'ensemble.',
      portfolioBullet1Strong: '200+ marchés',
      portfolioBullet1Rest: ' supportés : NYSE, NASDAQ, TSX, Euronext, LSE, NSE, Tokyo…',
      portfolioBullet2Strong: 'Drapeaux nationaux',
      portfolioBullet2Rest: ' pour reconnaître d\'un coup d\'œil l\'origine de chaque titre',
      portfolioBullet3Strong: 'Tri par colonne',
      portfolioBullet3Rest: ' : prix, valeur, gain, dividende — montez ou descendez en un clic',
      portfolioBullet4Strong: 'Dividendes automatiques',
      portfolioBullet4Rest: ' : prochaine date, fréquence, total mensuel cumulé',
      portfolioCaption: 'Prix dans la devise native · Valeur convertie en CAD',
      ctaTitleNew: 'Prêt à reprendre le contrôle de vos finances ?',
      ctaSubtitleNew: 'Démarrez gratuitement en moins d\'une minute. Aucune carte bancaire requise — passez Premium uniquement quand vous serez convaincu.',
      ctaButtonNew: 'Créer mon compte gratuit',
      ctaTrust: '1 téléchargement de relevé · 2 actifs · 0 $ pour démarrer',
      footerFaq: 'FAQ',
      footerRefund: 'Politique de remboursement',
      footerPrivacy: 'Politique de confidentialité',
      footerContact: 'Contact'
    },
    // Auth Page
    auth: {
      welcome: 'Bon retour !',
      emailPlaceholder: 'vous@exemple.com',
      createAccount: 'Créer un compte',
      loginSubtitle: 'Connectez-vous pour accéder à votre tableau de bord',
      registerSubtitle: 'Commencez à gérer vos finances dès maintenant',
      fullName: 'Nom complet',
      email: 'Email',
      password: 'Mot de passe',
      loginButton: 'Se connecter',
      registerButton: 'Créer un compte',
      legalConsentLabel: 'J\'ai lu et j\'accepte',
      legalConsentLink: 'les conditions légales',
      legalConsentRequired: 'Vous devez accepter les conditions légales pour créer un compte.',
      privacyConsentLabel: 'Je consens à la collecte et à l\'utilisation de mes renseignements personnels tels que décrits dans la',
      privacyConsentLink: 'Politique de confidentialité',
      privacyConsentLaw: 'Loi 25, Québec',
      privacyConsentRequired: 'Vous devez consentir à la Politique de confidentialité (Loi 25) pour créer un compte.',
      legalConsentSale: 'J\'ai lu et j\'accepte les conditions générales de vente (CGV)',
      legalConsentSaleRequired: 'Vous devez accepter les CGV pour souscrire.',
      loading: 'Chargement...',
      noAccount: 'Pas encore de compte ? S\'inscrire',
      hasAccount: 'Déjà un compte ? Se connecter',
      loginSuccess: 'Connexion réussie !',
      registerSuccess: 'Compte créé avec succès ! Veuillez vous connecter.',
      heroTitle: 'Vos finances en sécurité',
      heroSubtitle: 'Chiffrement bancaire et authentification à deux facteurs',
      twoFactorTitle: 'Vérification 2FA',
      twoFactorSubtitle: 'Entrez le code à 6 chiffres de votre application d\'authentification',
      twoFactorCodeLabel: 'Code 2FA',
      twoFactorHint: 'Vous pouvez aussi utiliser un code de récupération',
      twoFactorVerify: 'Vérifier',
      twoFactorVerifying: 'Vérification...',
      twoFactorBack: 'Retour à la connexion',
      twoFactorPrompt: 'Entrez votre code d\'authentification à deux facteurs',
      error: 'Une erreur est survenue',
      trustBannerTitle: 'Connexion chiffrée — standard bancaire',
      trustBannerDesc: 'Votre session est sécurisée par cookie httpOnly, invisible aux scripts et extensions tierces — protection conforme aux pratiques des grandes institutions financières.',
      cookieHttpOnly: 'cookie httpOnly',
      activationEmailSent: 'Email d\'activation envoyé à :',
      activationSpamWarning: 'Si vous ne le voyez pas :',
      activationSpamBody: 'Vérifiez votre dossier spam / courrier indésirable. Si rien après quelques minutes, cliquez sur « Renvoyer l\'email » ci-dessous pour continuer.',
      resendActivation: 'Renvoyer l\'email',
      forgotPassword: 'Mot de passe oublié ?',
      forgotPasswordTitle: 'Réinitialiser le mot de passe',
      forgotPasswordDesc: 'Nous vous enverrons un lien pour créer un nouveau mot de passe.',
      forgotEmailLabel: 'Adresse email',
      forgotSubmit: 'Envoyer le lien',
      forgotSuccess: 'Si un compte existe, un email de réinitialisation a été envoyé.',
      forgotError: 'Impossible d\'envoyer l\'email de réinitialisation.',
      forgotRateLimit: 'Limite : 3 tentatives par heure et par adresse email.',
      forgotSentTitle: '📨 Email envoyé',
      forgotSentBody: 'Vérifiez votre boîte de réception (et le dossier spam / courrier indésirable). Le lien expire dans 1 heure.',
      cancel: 'Annuler'
    },
    // Dashboard
    dashboard: {
      title: 'Tableau de bord',
      welcome: 'Bienvenue',
      balance: 'Solde mensuel',
      income: 'Revenus',
      expenses: 'Dépenses',
      portfolioValue: 'Portefeuille',
      assetIncome: 'Revenu des actifs',
      alerts: 'Alertes',
      recentTransactions: 'Transactions récentes',
      noTransactions: 'Aucune transaction',
      subscription: 'Abonnement',
      currentPlan: 'Formule actuelle',
      upgradeToPremium: 'Passez à Premium pour débloquer toutes les fonctionnalités avancées.',
      upgradeButton: 'Passer à Premium',
      loading: 'Chargement...',
      totalIncome: 'Total revenu',
      totalSpent: 'Total dépensé',
      txDistribution: 'Répartition des opérations',
      portfolioDistribution: 'Répartition Portefeuille',
      // v1.03.02 - i18n audit (Dashboard.jsx)
      amountPerPay: 'Montant à virer par paye',
      accordingToPeriod: 'Selon votre période',
      projectedAssetIncome: 'Revenu prévu des actifs',
      netBalance: 'Solde net (revenu − dépenses)',
      rentalDeficit: 'Déficit locatif détecté',
      distributionByAccount: 'Répartition par compte',
      mergeTables: 'Fusionner les tableaux',
      checkingAccount: 'Compte chèque',
      account: 'Compte',
      income: 'Revenus',
      expenses: 'Dépenses',
      netBalanceShort: 'Solde net',
      txCountShort: '# TX',
      welcomeTitle: 'Bienvenue sur Auto-Gère !',
      welcomeBody: 'Votre tableau de bord regroupe toutes vos finances. Cliquez sur Actualiser en haut à droite pour synchroniser les cours en temps réel, et cochez Fusionner les tableaux dans la Répartition par compte pour voir un total global.',
      rentalDeficitBody: 'Un ou plusieurs paiements attendus dans Revenu des Actifs ne sont pas encore reçus (échéance passée). Ce montant est déduit du revenu net réel — comme une dépense.',
      deficitGoTo: 'Voir dans Revenu des Actifs',
      dismissAlert: 'Masquer cet avertissement',
      payPeriodWeekly: 'Hebdomadaire (×52)',
      payPeriodBiweekly: 'Aux 2 semaines (×26)',
      payPeriodSemimonthly: 'Bi-mensuel (×24)',
      payPeriodMonthly: 'Mensuel (×12)',
      payLabel: 'payes',
      noAsset: 'Aucun actif',
      budgetAlert: 'Vous avez atteint 90 % de votre budget pour {category}',
      savingGoalReached: 'Objectif d\'épargne atteint pour {category} !',
      clearAllAlerts: 'Tout effacer',
      confirmClearAlerts: 'Supprimer toutes les alertes ?',
      refresh: 'Actualiser',
      typeCol: 'Type',
      totalRow: 'Total',
      moveUp: 'Déplacer vers le haut',
      moveDown: 'Déplacer vers le bas',
      noUsStocks: 'Aucune action US'
    },
    // Transactions
    transactions: {
      title: 'Relevé d\'opérations',
      subtitle: 'Gérez vos revenus et dépenses',
      // v1.03.07 - Traductions Transactions.jsx + AccountTabs
      checkingAccount: 'Compte chèque',
      addCard: 'Ajouter une carte',
      addCardBtn: '+ Ajouter une carte',
      editCard: 'Modifier la carte',
      addCreditCard: 'Ajouter une carte de crédit',
      allTab: 'Toutes',
      uncategorized: 'Non catégorisé',
      allPeriods: 'Toutes les périodes',
      importBtn: 'Importer',
      exportBtn: 'Exporter',
      resetBtn: 'Réinitialiser',
      selectedCard: 'Carte sélectionnée',
      addTransaction: 'Ajouter une transaction',
      newTransaction: 'Nouvelle transaction',
      type: 'Type',
      income: 'Revenu',
      expense: 'Dépense',
      saving: 'Épargne',
      reimbursement: 'Remboursement',
      amount: 'Montant',
      category: 'Catégorie',
      categoryPlaceholder: 'Ex: Alimentation, Salaire, Transport',
      description: 'Description',
      add: 'Ajouter',
      date: 'Date',
      noTransactions: 'Aucune transaction enregistrée',
      addFirstTransaction: 'Ajouter votre première transaction',
      success: 'Transaction ajoutée avec succès',
      error: 'Erreur lors de l\'ajout de la transaction',
      scanReceipt: 'Scanner une facture',
      scanInProgress: 'Analyse en cours…',
      scanSuccess: 'Facture analysée ! Vérifiez les champs avant de valider.',
      scanError: 'Impossible de scanner cette image',
      scanInvalidType: 'Format non supporté (JPEG, PNG ou WEBP uniquement)',
      scanTooLarge: 'Image trop volumineuse (max 8 Mo)',
      raz: 'RAZ',
      razTooltip: 'Remise à zéro de toutes les transactions',
      razConfirm: '⚠️ ATTENTION : Cette action va supprimer définitivement TOUTES vos transactions et remettre vos budgets à zéro.\n\nVoulez-vous vraiment continuer ?',
      razSuccess: 'Toutes les transactions ont été supprimées',
      razError: 'Erreur lors de la remise à zéro',
      cardName: 'Nom de la carte',
      currencyLabel: 'Devise',
      creditLimit: 'Limite de crédit',
      creditLimitTip: 'Saisissez la limite telle qu\'inscrite sur votre relevé — Auto-Gère convertira automatiquement pour les comparaisons multi-devises.',
      cycleDay: 'Jour de fin de cycle (1-31)',
      cycleDayTip: 'Le solde affiché correspond aux transactions du cycle en cours.',
      updateBtn: 'Mettre à jour',
      deleteCardTitle: 'Supprimer cette carte ?',
      deleteCardBody: 'Les transactions associées seront ré-affectées au compte chèque et non supprimées.',
      nameRequired: 'Le nom est requis',
      cycleDayRange: 'Jour de cycle entre 1 et 31',
      cardUpdated: 'Carte mise à jour',
      cardAdded: 'Carte ajoutée',
      cardDeleted: 'Carte supprimée — transactions ré-affectées au compte chèque',
      cardDeleteError: 'Erreur lors de la suppression',
      useBtn: 'Utiliser',
      balanceDue: 'Solde à payer',
      actionsCol: 'Actions',
      introTitle: 'Vos transactions, en un clin d\'œil',
      introBody: 'Cliquez sur Importer pour téléverser un relevé PDF / CSV / OFX (le scanner IA détecte les transactions automatiquement). Utilisez le filtre Non catégorisé + le sélecteur de mois pour rattraper vos imports rapidement. Quand vous changez une catégorie manuellement, Auto-Gère propose d\'appliquer la même catégorie aux doublons.',
      deleteTxConfirm: 'Supprimer cette transaction ?',
      inCur: 'en'
    },
    // Budget
    budget: {
      title: 'Budgets',
      subtitle: 'Définissez et suivez vos budgets',
      // v1.03.07 - Budget.jsx traductions
      tabPersonal: 'Budget personnel',
      tabAssetIncome: 'Revenu des Actifs',
      tabSavings: 'Épargne / Dépense',
      tabEmailAlerts: 'Alertes email',
      rolloverBtn: "Passer à l'année suivante",
      rolloverTitle: "Passer le Budget à l'année suivante",
      rolloverSubtitle: "Archive l'année qui se termine puis remet la progression à zéro — votre nomenclature (sections, lignes, montants) est conservée.",
      rolloverYearLabel: 'Année à clôturer',
      rolloverStep1: "Un PDF « photo » du Budget personnel {year} est créé et stocké dans Archive",
      rolloverStep2: 'Toutes les dates de paiement sont décalées de {year} vers {next}',
      rolloverStep3: "Les cases « fait » sont décochées (progression remise à 0 %) — sections, lignes et montants conservés",
      rolloverWarning: "Action irréversible (sauf le PDF archivé). Les onglets Budget personnel ET Revenu des Actifs sont traités.",
      rolloverConfirmLabel: 'Pour confirmer, tapez {year} ci-dessous :',
      rolloverGo: "Passer à l'année suivante",
      rolloverRunning: 'Traitement…',
      rolloverSuccess: 'Budget {year} archivé — bienvenue en {next} ! Progression remise à zéro.',
      rolloverError: "Erreur lors du passage à l'année suivante.",
      payPeriodTitle: 'Ma période de paie',
      payPeriodSub: 'Change la base de calcul du tableau et du montant à virer.',
      emailReminderTitle: 'Rappel par email · paiements à venir',
      emailReminderSub: 'Un seul email regroupant tous les paiements (auto ou manuels) prévus à la même date — envoyé à 9h du matin (heure de l\'Est).',
      testEmailBtn: 'Tester l\'envoi',
      newSection: 'Nouvelle section (ex : maison, automobile, assurances…)',
      calcAsIncome: 'Calculée en revenu',
      calcAsExpense: 'Calculée en dépense',
      sectionNamePlaceholder: 'Nom de section…',
      addSection: 'Ajouter',
      colDescription: 'Description',
      colAutoPaid: 'Auto payé',
      colPaymentDates: 'Dates de paiement',
      colAnnual: 'Année',
      colProgressionLive: 'Progression live',
      colActions: 'Actions',
      yes: 'Oui',
      no: 'Non',
      reminderDays1: '1 jour avant',
      reminderDays2: '2 jours avant',
      reminderDays3: '3 jours avant',
      reminderDays7: '7 jours avant',
      reminderNever: 'Jamais',
      reminderDisabled: 'Désactivé (aucun email)',
      reminderSameDay: 'Le jour même',
      total: 'Total',
      expense: 'Dépense',
      income: 'Revenu',
      tooltipIncomeSection: 'Section comptée comme REVENU',
      tooltipExpenseSection: 'Section comptée comme DÉPENSE',
      addBudget: 'Créer un budget',
      newBudget: 'Nouveau budget',
      category: 'Catégorie',
      limit: 'Limite',
      period: 'Période',
      monthly: 'Mensuel',
      spent: 'Dépensé',
      remaining: 'Restant',
      noBudgets: 'Aucun budget défini',
      createFirstBudget: 'Créer votre premier budget',
      success: 'Budget créé avec succès',
      error: 'Erreur lors de la création du budget',
      tipDetailTitle: 'Budget en pourcentage',
      tipDetailBody: 'Définissez le pourcentage de votre revenu mensuel que vous voulez allouer à chaque catégorie (logement, alimentation, épargne…). Auto-Gère calcule automatiquement les montants et vous alerte quand vous dépassez.',
      tipIncomeTitle: 'Revenu des Actifs',
      tipIncomeBody: 'Dédié à vos actifs immobiliers personnels (appartements en location, multilogements…). Inscrivez ici les revenus (loyers encaissés) ET les dépenses encourues (taxes municipales, entretien, hypothèque, assurances…). Le solde net est affiché en bas du tableau pour chaque actif.'
    },
    // Portfolio
    portfolio: {
      title: 'Portefeuille',
      subtitle: 'Gérez vos investissements',
      addAsset: 'Ajouter un actif',
      newAsset: 'Nouvel actif',
      assetType: 'Type d\'actif',
      nextDividendDate: 'Prochain dividende',
      noDividend: '—',
      stock: 'Action',
      crypto: 'Cryptomonnaie',
      symbol: 'Symbole',
      symbolPlaceholder: 'Ex: AAPL, bitcoin',
      quantity: 'Quantité',
      targetQty: 'Objectif',
      targetQtyOptional: 'optionnel — nombre visé (ex : 100)',
      sortByTargetQty: "Trier par objectif d'achat",
      purchasePrice: 'Prix d\'achat',
      totalReceived: 'Total reçu ({year})',
      grandTotalReceived: 'Total des dividendes reçus en {year}',
      importHistory: "Importer l'historique",
      importHistoryTip: "Importe les dividendes déjà versés depuis la date d'achat de chaque actif (estimation : versement/action × quantité actuelle)",
      importHistoryLoading: 'Import en cours…',
      importHistoryConfirm: "Importer les dividendes versés depuis la date d'achat de chaque actif ? L'estimation utilise la quantité actuelle. Vous pourrez annuler l'import à tout moment.",
      importHistoryDone: '{n} versements importés dans l\'historique',
      undoImport: "Annuler l'import",
      undoImportTip: "Supprime tous les versements importés automatiquement (les clics « Dividende reçu » manuels sont conservés)",
      undoImportConfirm: "Supprimer tous les versements importés de l'historique ? Les clics manuels « Dividende reçu » seront conservés.",
      undoImportDone: '{n} versements importés supprimés',
      yieldOnCost: 'RSC',
      currentPrice: 'Prix actuel',
      totalValue: 'Valeur totale',
      gainLoss: 'Gain/Perte',
      noAssets: 'Aucun actif dans votre portefeuille',
      addFirstAsset: 'Ajouter votre premier actif',
      delete: 'Supprimer',
      success: 'Actif ajouté avec succès',
      deleteSuccess: 'Actif supprimé',
      error: 'Erreur lors de l\'ajout de l\'actif',
      dividendYield: 'Rendement dividende annuel',
      dividendYieldPlaceholder: 'Ex: 3.5 (laisser vide si pas de dividende)',
      monthlyDividend: 'Dividende mensuel',
      annualDividend: 'Annuel',
      unrealizedProfits: 'Profits non réalisés',
      slowGrowth: 'Variation lente (< 5 %)',
      totalMovement: 'Total gains + pertes',
      assetsShort: 'titre(s)',
      gains: 'Gains',
      losses: 'Pertes',
      netLatent: 'net latent',
      vsSp500: 'Performance vs S&P 500',
      vsSp500Empty: 'Pas assez de données historiques. Ajoutez des actifs au portefeuille.',
      vsSp500Note: 'Performance pondérée par la valeur de chaque actif. Base 100 au début de la période.',
      // v1.03.02 - Traductions audit i18n (Portfolio.jsx)
      stocksBought: 'Actions achetées',
      titlesTotal: 'titres au total',
      cryptoHeld: 'Crypto détenues',
      unitsTotal: 'unités au total',
      totalPurchase: 'Total prix d\'achat',
      capitalInvested: 'capital investi',
      currentValue: 'Valeur actuelle',
      freqMonthlyShort: 'Mensuel (M)',
      freqQuarterlyShort: 'Trimestriel (T)',
      freqSemiAnnualShort: 'Semestriel (S)',
      freqAnnualShort: 'Annuel (A)',
      dividendConfirm: 'Confirmation de dividende',
      dividendReceived: 'reçu ?',
      globalDividendSharing: 'Partage global des dividendes',
      totalCap: 'TOTAL',
      refresh: 'Actualiser',
      cancel: 'Annuler',
      save: 'Enregistrer',
      close: 'Fermer',
      disable: 'Désactiver',
      sharingBreakdownTitle: 'Répartition détaillée des dividendes mensuels',
      titleCol: 'Titre',
      grossMonthly: 'Mensuel brut',
      monthlyTotal: 'Total mensuel',
      annualTotal: 'Total annuel',
      buildYourPortfolio: 'Construisez votre portefeuille',
      forceUpdatePrices: 'Forcer la mise à jour des prix et dividendes depuis Yahoo Finance',
      manageCoOwnership: 'Gérer les copropriétés et le partage de dividendes avec vos associés',
      yourPortfolio: 'Votre portefeuille',
      outperforms: 'Surperformance',
      underperforms: 'Sous-performance',
      distribution: 'Répartition du portefeuille',
      totalValueLabel: 'Valeur totale',
      tabAll: 'Tous',
      tabStocks: 'Actions',
      tabCrypto: 'Crypto',
      tabDividends: 'Dividendes',
      noDividendAssets: 'Aucun actif à dividende. Ajoutez un rendement > 0 lors de la création.',
      colYield: 'Rendement',
      colDivMonthly: 'Div. mensuel',
      colDivAnnual: 'Div. annuel',
      actions: 'Actions',
      alsoInWatchlist: 'Aussi suivi dans Marché — voir la watchlist pour compléter sa fiche',
      inWatchlistShort: 'Marché',
      toComplete: 'À compléter',
      completeFieldsTooltip: 'Ajouté depuis Marché — renseignez la quantité et le prix d\'achat',
      refreshing: 'Actualisation…',
      sharingBtn: 'Partage',
      yieldDetected: 'Rendement {dy}% détecté pour {symbol}',
      noDividendFor: '{symbol} : aucun dividende',
      specialDividendToast: '🎁 {symbol} : dividende spécial de {amount}$ détecté le {date}. Non inclus dans le calcul annuel récurrent.',
      yieldFetchError: 'Impossible de récupérer le rendement',
      specialDividendDetected: 'Dividende spécial détecté',
      specialDividendNote: 'Ces paiements exceptionnels ne sont pas inclus dans le calcul du dividende annuel récurrent affiché ci-dessous.',
      dividendFrequency: 'Fréquence du dividende',
      autoDetecting: 'Détection auto…',
      detectedLabel: 'Détecté',
      fetchAuto: 'Récupérer auto',
      freqAutoOption: 'Automatique (selon Yahoo Finance)',
      freqMonthly: 'Mensuel',
      freqQuarterly: 'Trimestriel',
      freqSemiAnnual: 'Semestriel',
      freqAnnual: 'Annuel',
      freqSemiAnnualLong: 'Semestriel (S — au 6 mois)',
      semiAnnualNote: '(au 6 mois)',
      freqHelp: 'Laissez sur Automatique pour utiliser la fréquence détectée par Yahoo Finance. Forcez une valeur uniquement si la détection est erronée.',
      dpsLabel: 'Dividende par action',
      dpsAuto: 'Auto',
      dpsForced: 'Forcé par vous',
      dpsRevertAuto: 'Revenir auto',
      dpsPlaceholderAuto: 'Laisser vide pour utiliser auto : {value}',
      dpsPlaceholder: 'Laisser vide pour valeur Yahoo automatique',
      dpsHelp: 'Saisissez une valeur uniquement si la donnée Yahoo Finance est erronée pour ce titre. Sinon laissez vide.',
      nextDivDateLabel: 'Date du prochain dividende',
      editableIfError: '— modifiable si erreur',
      restoreYahooTooltip: 'Restaurer la date détectée automatiquement par Yahoo Finance',
      autoYahooBtn: 'Auto Yahoo',
      nextDivDateHelp: 'Si la date détectée par Yahoo Finance est incorrecte, vous pouvez la corriger ici. Laissez vide pour utiliser la valeur auto.',
      enterSymbolFirst: 'Saisissez d\'abord un symbole',
      yahooDateRestored: 'Date Yahoo restaurée : {date}',
      yahooNoDate: 'Yahoo Finance ne fournit pas de date pour ce titre',
      yahooDateError: 'Impossible de récupérer la date Yahoo',
      quarterlyDividend: 'Dividende trimestriel',
      annualDividendFull: 'Dividende annuel',
      dividendPeriodAria: 'Période d\'affichage du dividende',
      sharingActiveTooltip: 'Partage global actif — cliquez pour modifier',
      sharingBreakdownTooltip: 'Cliquez pour voir la répartition détaillée par titre',
      paymentTrackingTab: 'Suivi paiements',
      paymentTrackingTooltip: 'Liste des dividendes dont la date prévue est passée — cochez pour confirmer la réception',
      noPendingConfirmations: '🎉 Aucun dividende en attente de confirmation ! Toutes vos dates sont à venir.',
      inFunction: 'en fonction',
      dividendWord: 'Dividende',
      totalAnnualDividends: 'Total dividendes annuels :',
      sharingDesc: 'Cette répartition s\'applique au TOTAL de vos dividendes (tous titres confondus). La 1re ligne = votre part. Ex : dividende total 100 $/mois, Paul 75 % → vous voyez 75 $/mois.',
      coOwnership: 'Copropriété',
      enableSharing: '+ Activer le partage',
      disableSharing: '× Désactiver',
      sharingDefaultNote: 'Par défaut vous touchez 100 %. Activez pour partager avec des associés (ex : « Paul 75 %, Fils 25 % »).',
      yourNamePlaceholder: 'Votre nom (ex: Paul)',
      associateNamePlaceholder: 'Nom de l\'associé',
      removeAssociate: 'Retirer cet associé',
      addAssociate: '+ Ajouter un associé',
      sumComplete: 'Somme complète ✓',
      sumOver: 'Dépassement : +{value} %',
      sumRemaining: 'Reste : {value} % à distribuer',
      needAtLeastTwo: 'Ajoutez au moins 2 associés (vous + 1 autre)',
      sumMustBe100: 'La somme doit être 100 (actuellement {sum})',
      eachNeedsName: 'Chaque associé doit avoir un nom',
      sharingSaved: 'Partage de dividendes enregistré',
      noDividendPayers: 'Aucun titre ne verse actuellement de dividendes dans votre portefeuille.',
      breakdownDesc: 'Ventilation du dividende mensuel brut de chaque titre selon vos parts globales configurées. La 1re colonne = votre part, les suivantes = associés.',
      recipientLabel: 'Destinataire',
      exampleEmail: 'comptable@exemple.com',
      sending: 'Envoi...',
      send: 'Envoyer',
      exportPdf: 'Exporter en PDF',
      sendByEmail: 'Envoyer par email',
      emailSentTo: 'Email envoyé à {email}',
      sendFailed: 'Échec de l\'envoi',
      pdfExported: 'PDF exporté',
      dateRestored: 'Date restaurée',
      dateRestoreFailed: 'Impossible de restaurer la date précédente',
      nextDateSet: '{symbol} → {date} (utilisez ↶ pour annuler si erreur)',
      noNextDateFound: 'Aucune prochaine date trouvée pour {symbol}',
      refreshFailed: 'Erreur lors du rafraîchissement',
      noPrevDateForAsset: 'Aucune date précédente à restaurer pour cet actif',
      dateRestoredFor: 'Date restaurée pour {symbol}',
      restoreFailed: 'Échec de la restauration',
      restorePrevDate: '↶ Restaurer la date précédente ({date})',
      noPrevDate: 'Aucune date précédente à restaurer',
      calcByFreq: 'Calculées selon la fréquence "{freq}"',
      next3Dates: '🔮 3 prochaines dates estimées :',
      portfolioIntroTip: 'Ajoutez vos actions et cryptomonnaies pour suivre la valeur en temps réel, les dividendes attendus, et les recommandations d\'analystes. Cliquez sur Actualiser pour synchroniser les cours boursiers (Yahoo Finance) et les prix crypto (CoinGecko).',
      refreshedToast: 'Portefeuille actualisé ({n} actifs)',
      completeQtyPrice: 'Complétez la quantité et le prix pour {symbol}',
      byNationality: 'par nationalité',
      tsxTipLabel: 'Astuce :',
      tsxTipBody: 'pour une action canadienne (TSX), ajoutez .TO à la fin du symbole (ex : JEPI.TO, H.TO). Sans suffixe, le symbole sera traité comme une action américaine.',
      nativeCurrencyNote: 'devise native de l\'actif',
      priceNativeTip: 'Saisissez le prix en {native} (pas en {cur}) — la conversion vers {cur} sera faite automatiquement par l\'application.',
      priceModeNative: '{native} (native)',
      priceModeUser: '{cur} (ma devise)',
      priceUserModeTip: 'Saisissez le prix payé en {cur}, tel que fourni par votre banque — la conversion vers {native} sera faite et le taux gelé à l\'enregistrement.',
      pricePreviewConverted: '≈ {price} {native} · taux actuel : 1 {native} = {rate} {cur} — sera gelé à l\'enregistrement',
      priceFrozenRate: 'Taux gelé : 1 {native} = {rate} {cur} · prix natif conservé : {price} {native}',
      sortBySymbol: 'Trier par symbole',
      sortByNextDate: 'Trier par prochaine date de dividende',
      sortByFreq: 'Trier par fréquence (M→T→S→A)',
      sortByQty: 'Trier par quantité',
      sortByBuyPrice: 'Trier par prix d\'achat',
      sortByCurPrice: 'Trier par prix actuel',
      sortByTotalValue: 'Trier par valeur totale (devise utilisateur)',
      sortByDps: 'Trier par dividende par action',
      sortByMonthlyDiv: 'Trier par dividende mensuel moyen',
      sortByGain: 'Trier par gain / perte',
      receivedHeaderTip: 'Cochez quand vous venez de recevoir votre dividende — Auto-Gère cherchera la prochaine date à venir',
      confirmedTip: 'Dividendes confirmés pour cet actif',
      validateOnceTip: 'Cliquez UNE FOIS pour valider que les dividendes sont bien détectés par Yahoo Finance',
      receivedCheckTip: 'Cochez quand vous venez de recevoir votre dividende pour que la prochaine date soit recherchée',
      firstCheckTip: 'Cliquez sur "À vérifier" la première fois pour activer le suivi du dividende'
    },
    // Market
    market: {
      title: 'Données de marché',
      subtitle: 'Suivez vos symboles favoris en temps réel',
      tabWatchlist: 'Surveillance',
      tabAnalysis: 'Analyse',
      tabTools: 'Outils',
      tabBasket: 'Panier',
      tabIdeas: 'Recherche',
      importPortfolio: 'Importer Portefeuille',
      importing: 'Import…',
      search: 'Rechercher',
      searchPlaceholder: 'Rechercher dans la watchlist...',
      trending: 'Tendances',
      price: 'Prix',
      change24h: 'Variation 24h',
      marketCap: 'Capitalisation',
      volume: 'Volume',
      noData: 'Aucune donnée disponible',
      newTitle: 'Nouveau suivi',
      editTitle: 'Modifier le suivi',
      addBtn: 'Ajouter à la watchlist',
      errorLoading: 'Erreur lors du chargement de la watchlist',
      testSent: 'Email de test envoyé',
      testError: 'Erreur lors de l\'envoi du test',
      checkOk: 'Vérification terminée',
      checkNoneTriggered: 'Aucun nouveau seuil franchi pour le moment',
      checkError: 'Erreur lors de la vérification',
      symbolRequired: 'Symbole requis',
      saveError: 'Erreur lors de l\'enregistrement',
      empty: 'Aucun symbole suivi. Ajoutez votre premier symbole à la watchlist.',
      noResults: 'Aucun résultat pour cette recherche.',
      testEmailBtn: 'Test email',
      testEmailTooltip: 'Envoyer un email de test à mon adresse',
      checkAlertsBtn: 'Vérifier alertes',
      checkAlertsTooltip: 'Vérifier les seuils maintenant et envoyer les emails si déclenchés',
      refreshBtn: 'Actualiser',
      alertAbove: 'Alerte si prix ≥',
      alertBelow: 'Alerte si prix ≤',
      alertPctAbove: 'Alerte si hausse ≥',
      alertPctBelow: 'Alerte si baisse ≤',
      alertPctHint: 'Calculé depuis le prix au moment de la sauvegarde de l\'alerte. Laissez vide pour désactiver.',
      alertPctTriggered: 'Variation depuis l\'alerte :',
      setAlert: 'Alerte',
      setAlertTooltip: 'Configurer une alerte de prix ou de variation %',
      alertsConfigured: 'Alertes',
      alertsConfiguredTooltip: 'Alertes actives — cliquez pour modifier',
      sinceAlert: 'Depuis l\'alerte :',
      resetReference: 'Réinitialiser',
      resetReferenceTooltip: 'Remettre la référence au prix actuel',
      optional: 'Optionnel',
      personalNote: 'Note personnelle',
      notePlaceholder: 'Ex: À acheter sous 150$, surveille les résultats Q4...',
      cryptoPlaceholder: 'Ex: bitcoin, ethereum',
      stockPlaceholder: 'Ex: AAPL, TSLA',
      legendCap: 'Capitalisation boursière (Cap.)',
      capSuffix_T: 'T$',
      capSuffix_B: 'Md$',
      capSuffix_M: 'M$',
      capLegend_T: 'Billions de dollars (1 T$ = 1 000 milliards)',
      capLegend_B: 'Milliards de dollars (1 Md$ = 1 000 millions)',
      capLegend_M: 'Millions de dollars',
      importEmptyPortfolio: "Votre portefeuille est vide. Ajoutez d'abord des actifs.",
      importAllPresent: 'Surveillance déjà synchronisée avec le portefeuille.',
      importAdded: '{n} actif(s) ajouté(s) à la surveillance',
      importFailedSome: '({n} échec(s))',
      importNoneAdded: "Aucun actif n'a pu être ajouté (limite plan gratuit ?)",
      importLoadError: 'Impossible de charger le portefeuille',
      cleanupTitle: 'Titres retirés du portefeuille',
      cleanupDesc: "Ces titres de votre surveillance ne sont plus dans votre portefeuille. Voulez-vous les retirer du Marché ? (Gardez-les si vous les surveillez volontairement.)",
      cleanupRemoveBtn: 'Retirer {n} titre(s)',
      cleanupKeepBtn: 'Garder',
      cleanupDone: '{n} titre(s) retiré(s) de la surveillance',
      alertCurrencyLabel: 'Devise des seuils',
      alertOneShotHint: "Chaque alerte n'envoie qu'un seul courriel. Ré-enregistrez l'alerte pour la réarmer.",
      alertCurrencyHint: 'Vos seuils haut/bas seront comparés au prix converti dans cette devise.',
      sortLabel: 'Trier',
      sortDefault: 'Par défaut (alertes en premier)',
      sortCapDesc: 'Capitalisation : élevée → basse',
      sortCapAsc: 'Capitalisation : basse → élevée',
      capLabel: 'Cap. :',
      capTooltip: 'Capitalisation boursière (valeur totale de l\'entreprise en bourse)',
      priceUnavailable: 'Prix indisponible',
      removeTooltip: 'Retirer',
      alertTriggered: 'Alerte déclenchée :',
      alertAboveMsg: 'Au-dessus de',
      alertBelowMsg: 'En-dessous de',
      thresholdHigh: 'Seuil haut :',
      thresholdLow: 'Seuil bas :',
      noteLabel: 'Note',
      removeTitle: 'Retirer ce symbole ?',
      removeDesc: 'Le symbole sera retiré de votre watchlist. Vous pourrez l\'ajouter à nouveau plus tard.',
      removeConfirm: 'Retirer',
      alsoInPortfolio: 'Ce titre est aussi dans votre portefeuille',
      inPortfolioShort: 'Portefeuille',
      legendTitle: 'Légende des pastilles',
      legendBtn: 'Légende',
      qualityGrade: 'Cote qualité',
      gradeLegend_A: 'Excellente',
      gradeLegend_B: 'Bonne',
      gradeLegend_C: 'Moyenne',
      gradeLegend_D: 'Médiocre',
      gradeLegend_E: 'Mauvaise',
      gradeLegend_F: 'À éviter',
      legendCalc: 'Calculée à partir du P/E, ROE, endettement et marge bénéficiaire.',
      legendFreq: 'Fréquence de dividende',
      freqLegend_M: 'Mensuel',
      freqLegend_T: 'Trimestriel',
      freqLegend_S: 'Semestriel',
      freqLegend_A: 'Annuel',
      importedNote: 'Importé du portefeuille',
      notAdvice: 'Ceci n\'est pas un conseil financier',
      discTitle: 'Important — Vérifiez avant d\'acheter',
      discMandatory: 'Mention obligatoire',
      discP1: 'Les renseignements affichés dans la section Marché (cours, dividendes, fréquences, recommandations analystes, idées de recherche, Signaux Marché Auto-Gère) proviennent de sources publiques et gratuites (Yahoo Finance et IA Gemini).',
      discP2: 'Les Signaux Marché Auto-Gère (Court / Moyen / Long terme) sont calculés en interne à partir de 5 indicateurs techniques classiques : RSI (momentum), MACD (convergence/divergence), MA (moyennes mobiles 50/200), MFI (flux monétaire) et OBV (volume cumulé). Méthodologie ouverte : ces signaux sont une aide à la lecture du marché, jamais une garantie de performance future.',
      discP3: 'Ces données peuvent contenir des erreurs, des décalages ou des informations périmées. Un outil de contre-vérification est intégré côté serveur, mais il ne remplace en aucun cas une vérification directe.',
      discP4: 'Avant toute transaction réelle, vérifiez systématiquement les chiffres (prix, dividende, fréquence, signaux techniques) sur la plateforme officielle de votre courtier ou directement sur le site de l\'émetteur.',
      discSecTitle: 'Auto-Gère est un logiciel externe',
      discSecBody: 'Nous n\'avons aucun accès à vos comptes bancaires réels, à votre courtier ou à vos cartes. Aucune connexion bancaire directe — donc aucun risque de vol d\'identité bancaire. Vous saisissez vous-même vos transactions et positions à des fins de suivi uniquement.',
      discInfo: 'Auto-Gère est un outil d\'information et de suivi — il ne constitue ni un conseil financier, ni une recommandation d\'investissement, ni une sollicitation d\'achat ou de vente. Les Signaux Marché, les notes Auto-Gère et les recommandations affichées sont fournis à titre indicatif uniquement. Consultez un conseiller en placement agréé avant toute décision d\'investissement engageante.',
      dontShowAgain: 'Ne plus afficher cet avertissement',
      dontShowNote: '(réapparaît si vous réactivez les Astuces dans Paramètres)',
      moreInfoAria: 'Plus d\'informations sur l\'avertissement',
      moreInfo: 'Plus d\'informations',
      footerDisclaimer: 'Auto-Gère est un outil de gestion et de suivi de vos placements. Les analyses, notes Auto-Gère, Signaux Marché (Court/Moyen/Long terme) basés sur 5 indicateurs techniques — RSI, MACD, MA, MFI, OBV — et résumés IA sont fournis à titre strictement informatif et ne constituent en aucun cas une recommandation d\'achat, de vente ou de conservation. Consultez un conseiller financier qualifié avant toute décision d\'investissement.',
      importTooltip: 'Ajoute automatiquement tous les actifs de votre portefeuille à votre surveillance'
    },
    categories: {
      added: 'Catégorie ajoutée',
      modified: 'Catégorie modifiée',
      deleted: 'Catégorie supprimée',
      confirmDelete: 'Supprimer cette catégorie ?',
      errorAdd: 'Erreur lors de l\'ajout',
      errorModify: 'Erreur lors de la modification',
      errorDelete: 'Erreur lors de la suppression',
      manage: 'Gérer les catégories',
      newPlaceholder: 'Nouvelle catégorie...',
      none: 'Aucune catégorie',
      defaultBadge: '(défaut)',
      choose: 'Choisir une catégorie'
    },
    settings: {
      passwordChanged: 'Mot de passe modifié avec succès',
      passwordError: 'Erreur lors du changement',
      passwordRequired: 'Mot de passe requis',
      accountDeleted: 'Compte supprimé. À bientôt.',
      accountDeleteError: 'Erreur lors de la suppression du compte',
      deletingBtn: 'Suppression…',
      deletePermanentlyBtn: 'Supprimer définitivement',
      changingPasswordBtn: 'Modification...',
      changePasswordBtn: 'Modifier le mot de passe',
      twoFactorError: 'Erreur lors de la configuration',
      // Headers
      title: 'Paramètres',
      subtitle: 'Gérez vos paramètres de sécurité et votre compte',
      // Appearance
      appearanceTitle: 'Apparence',
      appearanceDesc: 'Personnalisez la couleur d\'accent de l\'interface',
      themeLabel: 'Thème de couleur',
      themeCurrent: 'Thème actif',
      // Password section
      passwordTitle: 'Mot de passe',
      passwordDesc: 'Modifiez régulièrement votre mot de passe pour renforcer la sécurité de votre compte',
      changeMyPasswordBtn: 'Changer mon mot de passe',
      changePasswordDialogTitle: 'Changer mon mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      passwordHelp: 'Min. 8 caractères. Utilisez majuscules, chiffres et symboles.',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      // 2FA section
      twoFactorTitle: 'Authentification à deux facteurs (2FA)',
      twoFactorDesc: 'Ajoutez une couche supplémentaire de sécurité avec Google Authenticator, Microsoft Authenticator ou Authy',
      enabled: 'Activé',
      disabled: 'Désactivé',
      enable2faBtn: 'Activer le 2FA',
      disable2faBtn: 'Désactiver le 2FA',
      setup2faTitle: 'Configurer l\'authentification à deux facteurs',
      manualCode: 'Code secret (saisie manuelle):',
      recoveryCodes: 'Codes de récupération',
      enter6DigitCode: 'Entrez le code à 6 chiffres affiché dans votre application',
      verifyingBtn: 'Vérification...',
      disable2faTitle: 'Désactiver le 2FA',
      sixDigitLabel: 'Code à 6 chiffres',
      // Account info
      accountInfo: 'Informations du compte',
      emailLabel: 'Email',
      fullName: 'Nom complet',
      addressTitle: 'Adresse postale',
      addressStreet: 'Adresse (rue)',
      addressCity: 'Ville',
      addressPostalCode: 'Code postal',
      addressProvince: 'Province / État',
      addressCountry: 'Pays',
      addressEmpty: 'Aucune adresse renseignée',
      editProfileBtn: 'Modifier mes infos',
      editProfileTitle: 'Modifier mes informations',
      editProfileDesc: 'Mettez à jour votre nom, votre adresse et votre adresse email. Le changement d\'email nécessite une confirmation par lien.',
      saveBtn: 'Enregistrer',
      saving: 'Enregistrement…',
      profileUpdated: 'Profil mis à jour',
      emailChangePending: 'Changement en attente',
      emailChangePendingDesc: 'Un lien de confirmation a été envoyé à',
      emailChangeExpiresAt: 'Le lien expire',
      emailChangeCancel: 'Annuler le changement',
      emailChangeCanceled: 'Demande de changement annulée',
      emailChangeRequested: 'Lien de confirmation envoyé à {email}. Cliquez dessus dans l\'heure qui suit pour valider.',
      emailUnchanged: 'Aucun changement d\'email — la nouvelle adresse est identique à l\'actuelle.',
      emailAlreadyUsed: 'Cette adresse email est déjà utilisée par un autre compte.',
      emailVerifySuccess: 'Email mis à jour avec succès ! Vous pouvez maintenant vous connecter avec votre nouvelle adresse.',
      emailVerifyExpired: 'Lien expiré. Refaites une demande de changement.',
      emailVerifyInvalid: 'Lien invalide ou déjà utilisé.',
      subscriptionTier: 'Formule d\'abonnement',
      // Suggestions
      mySuggestions: 'Mes suggestions',
      noSuggestionsYet: 'Aucune suggestion envoyée pour le moment',
      newSuggestion: 'Nouvelle suggestion',
      suggCategory: 'Catégorie',
      suggCategoryFeature: 'Nouvelle fonctionnalité',
      suggCategoryImprovement: 'Amélioration',
      suggCategoryBug: 'Signaler un bug',
      suggCategoryGeneral: 'Général',
      suggTitle: 'Titre',
      suggTitlePlaceholder: 'Ex: Ajouter un graphique d\'évolution',
      suggDescription: 'Description',
      suggDescriptionPlaceholder: 'Décrivez votre idée en détail...',
      sendingBtn: 'Envoi...',
      sendSuggestionBtn: 'Envoyer la suggestion',
      // Danger zone
      dangerZone: 'Zone dangereuse',
      dangerZoneSubtitle: 'Actions irréversibles sur votre compte',
      dangerBullet1: 'La suppression de votre compte est',
      dangerBullet1Strong: 'définitive et irréversible',
      dangerBullet2: 'Toutes vos données seront supprimées : transactions, budgets, portefeuille, watchlist, factures',
      dangerBullet3: 'Votre abonnement Premium en cours sera annulé sans renouvellement',
      deleteAccountFinal: 'Cette action est',
      deleteAccountFinalStrong: 'définitive',
      deleteAccountFinalSuffix: 'et ne peut pas être annulée.',
      willBeDeleted: 'Seront définitivement supprimés :',
      itemTxBudgets: 'Vos transactions et budgets',
      itemPfWatchlist: 'Votre portefeuille et watchlist',
      itemInvoices: 'Vos factures et historique de paiements',
      itemSuggAlerts: 'Vos suggestions et alertes',
      typeDeletePrompt: 'pour confirmer',
      typePasswordPlaceholder: 'Entrez votre mot de passe',
      tipsTitle: 'Astuces guidées',
      tipsDesc: 'Affiche de petites bulles d\'astuces sur les pages clés pour vous accompagner dans vos premiers pas.',
      enabledPlural: 'Activées',
      disabledPlural: 'Désactivées',
      tipsNoneClosed: 'Aucune astuce n\'a encore été fermée.',
      tipsClosedCount: 'Vous avez fermé {count} astuce(s).',
      tipsResetBtn: 'Réafficher toutes les astuces',
      appUpdateTitle: 'Mise à jour de l\'application',
      appUpdateDesc: 'Auto-Gère ne vérifie plus automatiquement les nouvelles versions en arrière-plan. Cliquez ici pour vérifier maintenant et recevoir les dernières améliorations. Version actuelle :',
      checkingBtn: 'Vérification…',
      updateBtn: 'Mettre à jour',
      budgetAlertTitle: 'Alertes email · Budget',
      budgetAlertDesc: 'Recevez un email lorsqu\'une de vos catégories Épargne / Dépense atteint 90 % de sa limite (dépense) ou 100 % de son objectif (épargne). La cloche du tableau de bord reste active dans tous les cas.',
      alertsEnabled: 'Alertes email activées',
      marketReportTitle: 'Rapport des faits saillants',
      marketReportDesc: 'Recevez par courriel les gagnants et les pertes du jour parmi les titres de votre portefeuille, après la clôture des marchés.',
      marketReportFreq_off: 'Désactivé',
      marketReportFreq_daily: 'Chaque jour',
      marketReportFreq_weekly: 'Chaque semaine (vendredi)',
      marketReportFreq_monthly: 'Chaque mois',
      marketReportSaved: 'Fréquence du rapport enregistrée',
      marketReportError: 'Erreur lors de l\'enregistrement',
      marketReportHint: 'Envoyé vers 17 h (heure de l\'Est) après la clôture des marchés américains, les jours de bourse.',
      alertsDisabled: 'Alertes email désactivées',
      alertsPrefError: 'Impossible de mettre à jour la préférence',
      extraRecipientsTitle: 'Destinataires supplémentaires',
      extraRecipientsDesc: 'Ces personnes recevront les mêmes alertes que vous (budget, dépassement…) en plus de votre boîte principale. Idéal pour prévenir un conjoint, comptable ou associé.',
      removeBtn: 'Retirer',
      addBtn: 'Ajouter',
      recipientPlaceholder: 'conjoint@exemple.com',
      invalidEmail: 'Adresse email invalide',
      alreadyPrimary: 'Vous recevez déjà les alertes sur votre email principal',
      alreadyInList: 'Cette adresse est déjà dans la liste',
      maxRecipients: 'Maximum 5 destinataires supplémentaires',
      addedToAlerts: '{email} ajouté aux alertes',
      recipientRemoved: 'Destinataire retiré',
      cannotSave: 'Impossible d\'enregistrer'
    },
    paypalExtra: {
      cancelled: 'Renouvellement automatique annulé',
      cancelError: 'Erreur lors de l\'annulation',
      paypalError: 'Erreur PayPal. Réessayez plus tard.',
      promoFirstCycleTitle: 'Rabais appliqué au premier paiement',
      promoFirstCycleDesc: 'Le code {code} vous donne {percent} % de rabais sur votre premier paiement. Les renouvellements suivants seront facturés au prix régulier.',
      promoNoteBanner: "Le rabais s'applique sur votre premier paiement (avec ou sans renouvellement automatique). Les renouvellements suivants sont au prix régulier.",
      cancelledByUser: 'Paiement annulé'
    },
    exportExtra: {
      error: 'Erreur lors de l\'export',
      downloaded: 'Export téléchargé'
    },
    common: {
      save: 'Enregistrer',
      saveChanges: 'Enregistrer les modifications',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      search: 'Rechercher',
      filter: 'Filtrer',
      export: 'Exporter',
      import: 'Importer',
      add: 'Ajouter',
      confirm: 'Confirmer',
      loading: 'Chargement…',
      error: 'Erreur',
      errorLoading: 'Erreur lors du chargement',
      errorSaving: 'Erreur lors de l\'enregistrement',
      errorDeleting: 'Erreur lors de la suppression',
      errorAdding: 'Erreur lors de l\'ajout',
      errorUpdating: 'Erreur lors de la modification',
      success: 'Succès',
      deleted: 'Supprimé',
      added: 'Ajouté',
      modified: 'Modifié',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      clickToHide: 'Cliquer pour masquer'
    },
    premium: {
      title: 'Passez à Premium',
      autoRenewTitle: 'Renouvellement automatique',
      autoRenewReactivated: 'Renouvellement automatique réactivé',
      reactivateFailed: 'Réactivation impossible',
      activeBadge: 'Actif',
      disabledBadge: 'Désactivé',
      nextBilling: 'Prochaine facturation :',
      noRenewal: 'Pas de renouvellement. Votre Premium expire le {date}.',
      expiryWarning: 'Attention : à l\'expiration, vous ne pourrez plus ajouter de nouveaux renseignements (transactions, positions, budgets). Vos données existantes restent accessibles en lecture seule.',
      activeTitle: 'Abonnement Premium actif',
      subtitle: 'Débloquez toutes les fonctionnalités sans limite',
      reservedTitle: 'Réservé aux abonnés Premium',
      reservedDesc: 'Passez à Premium pour débloquer cette fonctionnalité.',
      upgradeNow: 'Passer à Premium',
      expiresOn: 'Expire le',
      included: 'Inclus dans Premium',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      saveBadge: 'ÉCONOMISEZ',
      perMonth: 'par mois · sans engagement',
      monthlyEquiv: 'soit',
      autoRenew: 'Renouvellement automatique',
      autoRenewOn: 'Votre abonnement se renouvellera automatiquement. Annulable à tout moment.',
      autoRenewOff: 'Paiement unique. Vous devrez renouveler manuellement à l\'expiration.',
      autoRenewActive: 'Renouvellement automatique : ACTIVÉ',
      autoRenewInactive: 'Renouvellement automatique : DÉSACTIVÉ',
      nextBilling: 'Prochain prélèvement le',
      noRenewal: 'Votre Premium expirera à la fin de la période en cours sans renouvellement.',
      cancelRenewal: 'Annuler le renouvellement',
      confirmCancelTitle: 'Annuler le renouvellement automatique ?',
      keepRenewal: 'Garder le renouvellement',
      confirmCancel: 'Oui, annuler',
      payWithPaypal: 'Paiement sécurisé via PayPal',
      testMode: '(mode test)',
      processing: 'Traitement du paiement…',
      myInvoices: 'Mes factures',
      paid: '✓ Payée',
      billedIn: 'Facturé',
      notConfigured: 'Paiement PayPal non configuré.',
      confirmCancelDescPrefix: 'Votre abonnement Premium restera actif jusqu\'au',
      confirmCancelDescSuffix: 'Aucun prélèvement supplémentaire ne sera effectué. Vous pourrez réactiver à tout moment.',
      autoRenewedBadge: 'Auto-renouvellement',
      subActivated: 'Abonnement activé ! Facture {invoice} envoyée par email.',
      activationError: 'Échec de l\'activation',
      captureSuccess: 'Paiement réussi ! Facture {invoice} envoyée par email.',
      captureError: 'Échec de la capture du paiement',
      planIdMissing: 'Plan ID manquant',
      features: {
        unlimitedTransactions: 'Transactions illimitées',
        unlimitedAssets: 'Portefeuille sans limite d\'actifs',
        priceAlerts: 'Alertes de prix par email',
        realTimeData: 'Données de marché en temps réel',
        exports: 'Exports PDF & Excel illimités',
        multiCurrency: 'Multi-devises (15 devises)',
        twoFactor: 'Authentification 2FA',
        prioritySupport: 'Support prioritaire'
      }
    },
    budgetExtra: {
      typeLabel: 'Type d\'objectif',
      expenseType: 'Plafond de dépense',
      expenseDesc: 'Limiter les dépenses',
      savingType: 'Objectif d\'épargne',
      savingDesc: 'Ramasser un montant',
      goalAmount: 'Montant objectif',
      manageCategories: 'Gérer les catégories',
      saved: 'Épargné',
      target: 'Objectif',
      leftToSave: 'Reste à épargner',
      badgeSaving: '🎯 Épargne',
      badgeExpense: '💸 Dépense',
      goalReached: '✓ Objectif atteint !',
      overBudget: '⚠ Budget dépassé ou proche de la limite',
      approachingLimit: '⚠ Vous approchez de la limite',
      editTooltip: 'Modifier ce budget',
      deleteTooltip: 'Supprimer ce budget',
      moveUpTooltip: 'Déplacer vers le haut',
      moveDownTooltip: 'Déplacer vers le bas',
      farFromGoal: '⚠ Loin de votre objectif — pensez à mettre de côté',
      gettingStarted: '↗ Vous commencez tout juste à épargner'
    },
    reports: {
      title: 'Rapports & exports',
      subtitle: 'Synthèse de vos finances et téléchargements PDF / Excel.',
      summaryIncome: 'Revenus totaux',
      summaryExpense: 'Dépenses totales',
      summaryBalance: 'Solde net',
      summaryPortfolio: 'Valeur du portefeuille',
      netCumulative: 'Cumul revenus − dépenses',
      entries: 'écritures',
      assets: 'actifs',
      exportsTitle: 'Exports rapides',
      exportsSubtitle: 'Téléchargez vos données dans le format de votre choix.',
      transactionsTitle: 'Transactions',
      transactionsDesc: 'Liste détaillée de toutes vos transactions avec catégories.',
      budgetsTitle: 'Budgets',
      budgetsDesc: 'État de tous vos budgets dépense et épargne.',
      budgetIncomeTitle: 'Revenu des Actifs',
      budgetIncomeDesc: 'Revenus prévisionnels (paie, dividendes, allocations) par source.',
      portfolioTitle: 'Portefeuille',
      portfolioDesc: 'Composition et performance de votre portefeuille.',
      downloadPdf: 'Télécharger PDF',
      downloadExcel: 'Télécharger Excel',
      downloading: 'Téléchargement…',
      downloadOk: 'Export téléchargé',
      // v1.04.01 - Reports.jsx traductions critiques
      archiveBudget: 'Archiver le Budget personnel de l\'année en PDF',
      archiveIncome: 'Archiver le Revenu des Actifs d\'un mois en PDF',
      archivePortfolio: "Archiver le Portefeuille de l'année en PDF",
      archivePortfolioDesc: 'Génère une photo annuelle complète de votre portefeuille (actifs, quantités, valeurs, répartition). Stockée dans la page « Archive ». Une nouvelle génération remplace celle de la même année.',
      archivePortfolioOk: 'Archive Portefeuille {year} générée et sauvegardée dans Archive.',
      year: 'Année',
      month: 'Mois',
      createPdf: 'Créer le PDF',
      archiveYear: 'Archiver l\'année',
      archiveMonth: 'Archiver le mois',
      yearToArchive: 'Année à archiver',
      downloadError: 'Erreur lors du téléchargement',
      activeBudgetsTitle: 'Budgets actifs',
      budgetsCount: 'budget(s) actif(s)',
      colCategory: 'Catégorie',
      colType: 'Type',
      colSpent: 'Réalisé',
      colLimit: 'Cible',
      colProgress: 'Progression',
      typeSaving: '🎯 Épargne',
      typeExpense: '💸 Dépense',
      chartIncomeVsExpense: 'Revenus vs Dépenses',
      chartTopExpenses: 'Top dépenses par catégorie',
      chartMonthlyEvolution: 'Évolution mensuelle (12 derniers mois)',
      chartPortfolio: 'Répartition du portefeuille',
      archiveYearBtn: 'Archiver l\'année',
      archiveYearTooltip: 'Génère un PDF annuel consolidé (transactions + budgets + portefeuille)',
      confirmArchive: 'Générer le rapport annuel consolidé pour {year} ?\n\nIl inclura toutes vos transactions, budgets et le portefeuille de l\'année. Le PDF sera disponible dans la page Archive.',
      archiveSuccess: 'Rapport annuel {year} archivé',
      archiveError: 'Erreur lors de l\'archivage',
      archiving: 'Archivage…',
      monthlyTitle: 'Archiver les transactions d\'un mois en PDF',
      monthlySubtitle: 'Génère un PDF mensuel des transactions. Le fichier apparaîtra dans la grille de l\'année correspondante de la page Archive.',
      monthlyYearLabel: 'Année',
      monthlyMonthLabel: 'Mois',
      monthlyBtn: 'Créer le PDF',
      monthlyOk: 'PDF mensuel créé ({year}-{month})',
      monthlyError: 'Aucune transaction pour ce mois ou erreur',
      selectYearBody: 'Sélectionnez l\'année à archiver. Un rapport PDF complet sera généré et conservé dans la section Archive. Si une archive existe déjà pour cette année, vous pourrez choisir de l\'écraser.',
      archiveExists: 'Archive déjà existante',
      existsForYear: 'Une archive existe déjà pour l\'année',
      overwriteQuestion: 'Voulez-vous l\'écraser et générer une nouvelle version ?',
      keepOld: 'Conserver l\'ancienne',
      overwriting: 'Écrasement…',
      overwriteBtn: 'Écraser et regénérer',
      specialPaymentsNote: 'Paiements exceptionnels (spéciaux, extraordinaires) reçus sur vos actions détenues — en plus des dividendes récurrents.',
      annualGrowth: 'Croissance annuelle',
      cagrFull: 'CAGR (années complètes)',
      inNYears: 'Dans {n} ans',
      perYear: 'par année',
      projectionNote: 'Projection basée sur ton CAGR historique. Les rendements futurs peuvent varier selon les décisions des entreprises (hausse/coupure de dividendes, rachats), l\'inflation et les mouvements de marché. À utiliser comme indicateur, pas comme garantie.',
      shareChartAria: 'Partager mon graphique dividendes',
      create12Tip: 'Crée les 12 archives PDF (janvier → décembre) pour l\'année sélectionnée'
    },
    archive: {
      title: 'Archive',
      subtitle: 'Consultez les transactions de vos années passées (lecture seule)',
      selectYear: 'Choisir une année',
      income: 'Revenus',
      expense: 'Dépenses',
      balance: 'Solde net',
      transactionsTitle: 'Transactions',
      readOnly: 'Les transactions archivées sont en lecture seule.',
      noTx: 'Aucune transaction pour cette année.',
      emptyTitle: 'Aucune archive disponible',
      emptyDesc: 'Vos transactions des années précédentes apparaîtront ici automatiquement.',
      gridTitle: 'Archives sur 7 ans',
      gridSubtitle: 'Une colonne par année — un PDF mensuel cliquable par cellule.',
      generate: 'Générer',
      download: 'Télécharger',
      generating: 'Création…',
      monthlyArchiveSuccess: 'PDF mensuel créé ({year}-{month})',
      monthlyArchiveError: 'Impossible de générer ce PDF mensuel',
      yearlyPdfBadge: 'Annuel',
      monthlyPdfBadge: 'Mensuel',
      savedFiles: 'Fichiers archivés',
      noFilesForYear: 'Aucun PDF archivé pour {year}.',
      retentionNotice: 'Il est fortement conseillé de conserver vos données au moins 7 ans avant suppression (obligations fiscales).',
      deleteWarning: '⚠️ Êtes-vous sûr·e de supprimer définitivement l\'archive {year} ?\n\nIl est FORTEMENT conseillé de conserver vos données au moins 7 ans (obligations fiscales). Cette action est irréversible.',
      deleteSuccess: 'Archive supprimée',
      expiredTitle: 'Données expirées (hors fenêtre 7 ans)',
      expiredDesc: 'Ces archives ont dépassé la fenêtre des 7 dernières années. Elles seront supprimées automatiquement après le délai indiqué, sauf si vous décidez de les conserver.',
      noExpired: 'Aucune archive expirée.',
      autoDeleteIn: 'Suppression auto dans {days} j',
      autoDeleteToday: 'Suppression auto aujourd\'hui',
      keepLonger: 'Conserver',
      keepSuccess: 'Suppression automatique annulée',
      deleteNow: 'Supprimer maintenant',
      monthShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
      annualRowLabel: 'Annuel',
      // Dialogue de suppression à 2 choix
      removeDialogTitle: 'Que voulez-vous faire avec cette archive ?',
      removeDialogDesc: 'Choisissez "Exporter" pour télécharger immédiatement le PDF, ou "Marquer comme expirée" pour la déplacer dans la zone "Données expirées" (suppression auto dans 30 jours, sauf annulation).',
      exportAction: 'Exporter (PDF)',
      expireAction: 'Marquer comme expirée',
      cancel: 'Annuler',
      expireSuccess: 'Archive marquée expirée — suppression auto dans 30 jours',
      expireError: 'Impossible de marquer cette archive',
      sendByEmailTooltip: 'Envoyer par email',
      budgetGridTitle: 'Budget personnel — archives annuelles',
      budgetGridSubtitle: 'Photo annuelle complète du Budget personnel (dépenses, épargnes, cadences). 1 PDF par année. Source : Budget → Budget personnel.',
      annualSnapshot: 'Photo annuelle',
      portfolioSnapshot: 'Portefeuille (photo annuelle)',
      incomeGridTitle: 'Revenu des Actifs — archives mensuelles',
      incomeGridSubtitle: 'Chaque cellule crée un PDF des revenus prévus du mois (source : Budget > Revenu des Actifs). Stocké sur 7 ans, identique à la grille Transactions.',
      monthCol: 'Mois',
      emailDialogTitle: 'Envoyer l\'archive par email',
      emailDialogDesc: 'Le PDF sera envoyé en pièce jointe. Idéal pour transmettre à votre comptable, associé ou proche.',
      recipientLabel: 'Destinataire',
      exampleEmail: 'comptable@exemple.com',
      sending: 'Envoi...',
      send: 'Envoyer',
      invalidEmail: 'Adresse email invalide',
      sentTo: 'Archive envoyée à {email}',
      yearCol: 'Année',
      sendFailed: 'Échec de l\'envoi'
    },
    marketAnalysis: {
      loading: 'Chargement de l\'analyse…',
      tipTitle: 'Analyse de votre portefeuille',
      tipBody: 'Auto-Gère analyse les fondamentaux (P/E, ROE, dette, marge) de chacune de vos actions et leur attribue une note de A à F. Vous voyez aussi le consensus des analystes. Cliquez sur Résumé pour obtenir une synthèse détaillée. Astuce : le rapport mensuel peut être envoyé directement à votre boîte courriel.',
      analyzedSuffix: 'action(s) analysée(s) depuis votre portefeuille.',
      sortLabel: 'Trier par :',
      sortNone: 'Aucun',
      autogereGrade: 'Note Auto-Gère',
      sortBest: 'Meilleure (A → F)',
      sortWorst: 'Pire (F → A)',
      optgroupSignal: 'Signal Marché (Moyen-Terme)',
      sortBull: 'Haussier d\'abord',
      sortHold: 'Conservé / Neutre d\'abord',
      sortBear: 'Baissier d\'abord',
      filterAll: 'Tous',
      buy: 'Achat',
      hold: 'Conserver',
      sell: 'Vente',
      reco_hold2: 'Conservé',
      reco_sell2: 'Vendre',
      reco_strong_buy: 'Achat fort',
      reco_strong_sell: 'Vente forte',
      reco_underperform: 'Sous-performance',
      noneInCategory: 'Aucune action dans la catégorie pour l\'instant :',
      sending: 'Envoi en cours…',
      sendReport: 'Envoyer le rapport mensuel',
      reportSent: 'Rapport envoyé à {r} ({n} actions)',
      loadError: 'Impossible de charger l\'analyse du portefeuille',
      progressiveLoading: 'Analyse en cours… {done}/{total} titres analysés — les résultats s\'affichent au fur et à mesure.',
      legendTitle: 'Notes de qualité Auto-Gère : A → F',
      legendIntro: 'Auto-Gère calcule un score sur 100 en combinant 4 axes pondérés à parts égales (25 % chacun) :',
      axisVal: 'Valorisation — Ratio cours/bénéfice (P/E). Plus bas = moins cher relatif.',
      axisRent: 'Rentabilité — Rendement des capitaux propres (ROE). Plus élevé = société rentable.',
      axisDebt: 'Endettement — Ratio dette / capitaux propres. Plus bas = bilan plus sain.',
      axisMargin: 'Marge bénéficiaire — Marge nette. Plus élevée = entreprise efficace.',
      score: 'Score',
      gradeLabel_A: 'Excellent',
      gradeLabel_B: 'Bon',
      gradeLabel_C: 'Moyen',
      gradeLabel_D: 'Faible',
      gradeLabel_E: 'Très faible',
      gradeLabel_F: 'Critique',
      gradeLabel_UNK: 'N/D',
      gradeDesc_A: 'Fondamentaux solides sur tous les axes. Valorisation raisonnable, rentabilité élevée, endettement maîtrisé, marge robuste.',
      gradeDesc_B: 'Société de qualité avec des fondamentaux globalement positifs. Une ou deux faiblesses mineures sans risque majeur.',
      gradeDesc_C: 'Profil mitigé. Certains indicateurs sont solides, d\'autres faibles. À surveiller selon la tolérance au risque.',
      gradeDesc_D: 'Plusieurs signaux d\'alerte (valorisation élevée, rentabilité faible, dette importante ou marges étroites).',
      gradeDesc_E: 'Profil financier dégradé. Risque significatif sur la pérennité ou la performance future.',
      gradeDesc_F: 'Fondamentaux très détériorés. Forte probabilité de pertes ou de restructuration.',
      yahooNote: 'Les données proviennent de Yahoo Finance. La note ne constitue pas un conseil financier.',
      fundamentals: 'Fondamentaux',
      hintPE: 'Price/Earnings (TTM). Inférieur = moins cher relatif.',
      hintFwdPE: 'P/E projeté pour l\'année à venir.',
      hintROE: 'Return on Equity : rentabilité des capitaux propres.',
      labelMargin: 'Marge bénéf.',
      hintMargin: 'Marge nette.',
      labelDebt: 'Dette/Cap.',
      hintDebt: 'Debt to Equity (en %). < 100 = sain.',
      hintBeta: 'Volatilité vs marché. 1 = comme le marché.',
      labelYield: 'Rendement div.',
      hintYield: 'Dividende annuel / prix actuel.',
      hintPayout: '% du bénéfice reversé en dividendes.',
      recosTitle: 'Recommandations analystes',
      noRecos: 'Recommandations analystes : N/A',
      totalAnalysts: 'Total : {n} analystes',
      estimate: ' (estimation)',
      consensus: 'Consensus :',
      targetMean: 'Cible moyenne :',
      summary: 'Résumé',
      chart: 'Graphique',
      chartTitle: 'Graphique TradingView',
      tvNote: 'Données fournies par TradingView. Pour information uniquement — ne constitue pas un conseil financier.',
      signalsTitle: 'Signaux Marché Auto-Gère',
      signalsDisclaimer: 'Basé sur RSI · MACD · MA · MFI · OBV. Ne constitue pas un conseil financier.',
      computing: 'Calcul des indicateurs techniques…',
      horizon_short_term: 'Court-Terme',
      horizonSub_short_term: '1-2 sem.',
      horizon_mid_term: 'Moyen-Terme',
      horizonSub_mid_term: '1-3 mois',
      horizon_long_term: 'Long-Terme',
      horizonSub_long_term: '6 mois+',
      signal_strong_bull: 'Signal haussier fort',
      signal_bull: 'Signal haussier',
      signal_neutral: 'Neutre',
      signal_bear: 'Signal baissier',
      signal_strong_bear: 'Signal baissier fort'
    },
    globalAlerts: {
      button: 'Alerte générale',
      buttonTip: 'Alerte courriel sur TOUS les titres : % de variation vs clôture de la veille',
      title: 'Alerte générale',
      scopePortfolio: 'Portefeuille',
      scopeWatchlist: 'Suivi de titres',
      description: 'Une seule règle appliquée à tous vos titres : vous recevez un courriel dès qu\'un titre varie au-delà de vos seuils par rapport à la clôture de la veille.',
      enable: 'Activer l\'alerte générale',
      upLabel: 'Hausse de',
      downLabel: 'Baisse de',
      optional: 'facultatif',
      antiSpamNote: 'Un seul courriel par titre et par jour lorsqu\'un seuil est franchi. Les titres déclenchés en même temps sont regroupés dans un seul courriel. Vérification toutes les 15 minutes.',
      save: 'Enregistrer',
      saved: 'Alerte générale enregistrée',
      saveError: 'Erreur lors de l\'enregistrement',
    },
    budgetTable: {
      amountViewTip: "Changer la période d'affichage du montant (annuel, mensuel, aux 2 semaines, à la semaine)",
      viewMonthly: 'Au mois (÷12)',
      viewBiweekly: 'Aux 2 sem. (÷26)',
      viewWeekly: 'À la sem. (÷52)',
      viewShort_monthly: 'mois',
      viewShort_biweekly: '2 sem.',
      viewShort_weekly: 'sem.',
      periodTip: 'Le montant saisi sera converti en annuel selon la période choisie',
      periodAnnual: 'Par année (×1)',
      periodMonthly: 'Par mois (×12)',
      periodBiweekly: 'Aux 2 sem. (×26)',
      periodWeekly: 'Par sem. (×52)',
      emailAlert: 'Alerte email',
      emailAlertOnTip: 'Rappels email activés pour cette ligne — cliquez pour désactiver',
      emailAlertOffTip: 'Rappels email désactivés pour cette ligne — cliquez pour activer',
      markDone: 'Marquer fait',
      markUndone: 'Marquer non fait',
      done: 'fait',
      removeDate: 'Retirer cette date',
      addDateTip: 'Ajouter une date manuellement (entrée libre)',
      addDate: 'Ajouter date',
      presets: 'Préréglages :',
      weeklyTip: 'Génère 52 paiements hebdomadaires (1 par semaine sur l\'année) — idéal loyer hebdo, épicerie, abonnements calés sur la paie',
      weekly: 'Hebdomadaire (52×)',
      monthlyTip: 'Génère 12 paiements mensuels (janvier → décembre) — idéal hypothèque, loyer, abonnements',
      monthly: 'Mensuel (12×)',
      quarterlyTip: 'Génère 4 paiements trimestriels (janvier, avril, juillet, octobre) — idéal taxes municipales/scolaires',
      quarterly: 'Trimestriel (4×)',
      semiTip: 'Génère 2 paiements semestriels (janvier + juillet) — idéal assurances habitation/auto',
      semi: 'Semestriel (2×)',
      annualTip: 'Génère 1 seul paiement annuel à la date pivot — idéal abonnement annuel, taxe foncière unique',
      annual: 'Annuel (1×)',
      freqWeeklyLabel: 'hebdomadaires (52×/an)',
      freqMonthlyLabel: 'mensuels (janv. → déc.)',
      freqQuarterlyLabel: 'trimestriels (4×/an, janv./avr./juil./oct.)',
      freqSemiLabel: 'semestriels (2×/an, janv./juil.)',
      freqAnnualLabel: 'annuel (1×/an)',
      paymentsGenerated: '{n} paiements {label} générés',
      payPeriodError: 'Impossible d\'enregistrer la période de paie',
      noUnpaidForDate: 'Aucun paiement non payé prévu le {date}.',
      net: 'Net :',
      received: 'reçu',
      paid: 'payé',
      receivedPl: 'reçus',
      paidPl: 'payés',
      deficitTip: 'mois échu(s) non reçu(s) — bascule en dépense',
      totalIncome: 'TOTAL REVENUS',
      totalExpense: 'TOTAL DÉPENSES',
      annualFixed: 'Dépenses fixes annuelles',
      totalCap: 'TOTAL',
      netToTransfer: 'NET À VIRER',
      surplus: 'SURPLUS',
      depAbbr: 'dép.',
      defAbbr: 'déf.',
      perYourPeriod: 'Selon votre période :',
      payPeriodTip: 'Pour changer la période de paie, utilisez la carte verte tout en haut du tableau (« Ma période de paie »).',
      rentBehindTip: 'Loyers échus non reçus — bascule en dépense dans le Net réel',
      newAssetHeader: 'Nouvel actif (entête) — ex : « 777 de la Noé », « Condo Verdun », « Duplex Ahuntsic »…',
      newAssetDesc: 'Créez d\'abord l\'entête de votre bien. Vous pourrez ensuite ajouter en dessous des sections 💵 revenu (loyers) ET/OU 💸 dépense (taxes, hypothèque, entretien…).',
      assetNamePh: 'Nom de l\'actif...',
      createAsset: 'Créer l\'actif',
      addSectionToAsset: 'Ajouter une section à un actif (💵 revenu ou 💸 dépense)',
      parentAsset: 'Actif parent',
      yes: 'Oui',
      no: 'Non',
      addLineIn: 'Ajouter une ligne dans',
      assetBadge: 'Actif',
      sections: 'section(s)',
      receivedCap: 'Reçus',
      paidCap: 'Payées',
      incomeBadge: 'Revenu',
      expenseBadge: 'Dépense',
      netIncomeCap: 'REVENU NET',
      deficitCap: 'DÉFICIT',
      deficitWord: 'déficit',
      realNetLabel: 'Net réel (avec déficit)',
      expectedAssetIncome: 'Revenu prévu des actifs'
    },
    accountant: {
      title: 'Feuille comptable',
      subtitle: 'Récapitulatif fiscal prêt à transmettre à votre comptable',
      exportPdf: 'Export PDF',
      exportExcel: 'Export Excel',
      netResult: 'Résultat Net',
      monthCol: 'Mois',
      incomeCol: 'Revenus',
      expenseCol: 'Dépenses',
      resultCol: 'Résultat',
      categoryCol: 'Catégorie',
      txCount: 'Nb. transactions',
      loadError: 'Erreur lors du chargement',
      downloaded: 'Feuille comptable {fmt} téléchargée',
      exportError: 'Erreur lors de l\'export'
    },
    authFlow: {
      verifying: 'Vérification en cours…',
      waitFew: 'Patientez quelques secondes.',
      emailVerified: 'Email vérifié !',
      addressLabel: 'L\'adresse',
      nowActive: 'est maintenant active.',
      canAccessAll: 'Vous pouvez désormais accéder à toutes les fonctionnalités de Auto-Gère et souscrire à un plan Premium.',
      login: 'Se connecter',
      linkExpired: 'Lien expiré',
      expiredBody: 'Ce lien d\'activation a expiré (24 h max). Connectez-vous pour en recevoir un nouveau.',
      alreadyActivated: 'Compte déjà activé',
      alreadyUsedBody: 'Ce lien a déjà été utilisé. Votre compte est activé et prêt à l\'emploi.',
      loginNormally: 'Connectez-vous normalement pour accéder à Auto-Gère.',
      linkInvalid: 'Lien invalide',
      invalidBody: 'Ce lien d\'activation est invalide ou a déjà été utilisé.',
      goToLogin: 'Aller à la connexion',
      pwdMin8: 'Le mot de passe doit faire au moins 8 caractères.',
      pwdMismatch: 'Les deux mots de passe ne sont pas identiques.',
      pwdResetDone: 'Mot de passe réinitialisé',
      resetFailed: 'Échec de la réinitialisation',
      resetLinkInvalidBody: 'Ce lien de réinitialisation est incomplet ou expiré.',
      backToLogin: 'Retour à la connexion',
      pwdResetTitle: 'Mot de passe réinitialisé ✓',
      redirecting: 'Redirection vers la page de connexion…',
      newPwd: 'Nouveau mot de passe',
      choosePwd: 'Choisissez un nouveau mot de passe sécurisé pour votre compte Auto-Gère.',
      min8: 'Au moins 8 caractères',
      confirmPwd: 'Confirmer le mot de passe',
      resetting: 'Réinitialisation…',
      resetBtn: 'Réinitialiser le mot de passe',
      activationRequired: 'ACTIVATION REQUISE',
      verifyYourEmail: 'Vérifiez votre adresse email',
      hello: 'Bonjour',
      clickLinkSentTo: 'Pour activer votre compte Auto-Gère, cliquez sur le lien que nous venons d\'envoyer à :',
      dontSeeEmail: 'Vous ne voyez pas l\'email ?',
      checkSpam: 'Vérifiez votre dossier spam / courrier indésirable. Si vous ne le trouvez toujours pas après quelques minutes, cliquez sur « Renvoyer l\'email » ci-dessous pour continuer.',
      addContact: 'Ajoutez support@autogere.ca à vos contacts pour garantir la bonne réception de nos messages.',
      resendSuccess: 'Email d\'activation renvoyé. Vérifiez votre boîte de réception et vos spams.',
      resendError: 'Erreur lors de l\'envoi. Réessayez dans quelques minutes.',
      statusRefreshed: 'Statut actualisé.',
      sendingNow: 'Envoi en cours…',
      resendEmail: 'Renvoyer l\'email',
      checkingBtn: 'Vérification…',
      iClicked: 'J\'ai cliqué — actualiser',
      wrongAddress: 'Mauvaise adresse ? Déconnectez-vous et créez un nouveau compte.',
      logoutBtn: 'Se déconnecter',
      noCharge: 'Aucun frais ne sera prélevé tant que vous n\'avez pas activé votre compte et choisi un plan.'
    },
    ideas: {
      scrDividend: 'Dividende',
      scrHighDiv: 'Hauts dividendes (large caps sous-évaluées)',
      scrUndervaluedGrowth: 'Croissance sous-évaluée',
      scrDayGainers: 'Gagnants du jour',
      scrDayLosers: 'Perdants du jour',
      scrMostActive: 'Plus actives',
      scrGrowthTech: 'Tech en croissance',
      scrSmallCaps: 'Small caps agressives',
      scrMostShorted: 'Plus shortées',
      scrMorningstar: 'Morningstar 5 étoiles',
      scrLargestCap: 'Plus grosses capitalisations',
      scr52Gainers: 'Gagnants 52 sem.',
      scr52Losers: 'Perdants 52 sem.',
      sortRelevance: 'Pertinence',
      sortGrade: 'Cote (A → F)',
      sortDivDollar: 'Dividende $/an (tous)',
      sortDivYield: 'Rendement %',
      sortDivM: 'Div. Mensuel (M) seulement',
      sortDivT: 'Div. Trimestriel (T) seulement',
      sortDivS: 'Div. Semestriel (S) seulement',
      sortDivA: 'Div. Annuel (A) seulement',
      sortPriceAsc: 'Prix croissant',
      sortSymbol: 'Symbole (A → Z)',
      sortCountry: 'Nationalité (CA → US → EU → AS)',
      sortMarketCap: 'Capitalisation (grande → petite)',
      sortPriceDesc: 'Prix décroissant (chère → bon marché)',
      sortPriceAsc2: 'Prix croissant (bon marché → chère)',
      noResultsCur: 'Aucun résultat en {cur} pour ce screener.',
      noResultsScreener: 'Aucun résultat — Yahoo n\'a rien retourné pour ce screener.',
      searchUnavailable: 'Recherche indisponible — réessayez plus tard',
      aiUnavailable: 'Recherche IA indisponible — réessayez plus tard',
      tipTitle: 'Recherche de titres et cryptos',
      tipDemoBody: 'Découvrez des actions et des cryptos via les screeners Yahoo Finance en temps réel ou via notre IA. Filtres : haut rendement, croissance, dividende, gagnants du jour, etc.',
      premiumFeature: 'Fonctionnalité Premium',
      premiumBody: 'La recherche dynamique de titres et cryptos (Yahoo Screener + IA) est réservée aux Premium. En mode démo, cette fonctionnalité est désactivée.',
      goPremium: 'Passer à Premium',
      tipSearchBody: 'Choisissez un screener Yahoo (résultats en temps réel) ou tapez une recherche libre — l\'IA proposera des titres ou cryptos correspondants. Ajoutez vos coups de cœur au Panier.',
      stocks: 'Actions',
      cryptos: 'Cryptos',
      allCurrencies: 'Toutes',
      aiPlaceholderCrypto: "Recherche libre IA : 'tokens DeFi à fort potentiel', 'cryptos PoS rentables'…",
      aiPlaceholderStocks: "Recherche libre IA : 'pipelines canadiens', 'REIT mensuel à dividende élevé'…",
      searchBtn: 'Chercher',
      screenersCrypto: 'Screeners Yahoo Crypto (live) :',
      screenersStocks: 'Screeners Yahoo Actions (live) :',
      source: 'source',
      sortBy: 'Trier par',
      added: 'Ajouté',
      basketBtn: 'Panier',
      annualDiv: 'Div. annuel',
      perShare: '/action',
      payment: 'Versement',
      yield: 'Rendement',
      noneOption: '(aucune)',
      emptyStateStocks: 'Choisissez un screener actions ou tapez une recherche libre pour commencer.',
      emptyStateCrypto: 'Choisissez un screener crypto ou tapez une recherche libre pour commencer.'
    },
    basket: {
      clearConfirm: 'Vider complètement le panier ?',
      cleared: 'Panier vidé',
      premiumTitle: 'Panier Premium',
      premiumBody: 'Le panier vous permet d\'accumuler des idées avant de les ajouter à votre portefeuille. Réservé aux utilisateurs Premium.',
      tipTitle: 'Votre panier d\'idées',
      tipBody: 'Les titres que vous avez ajoutés depuis l\'onglet Recherche apparaissent ici. Cliquez sur Ajouter au portefeuille pour transférer un titre vers votre portefeuille (quantité et prix à saisir). Le panier est sauvegardé localement dans votre navigateur.',
      empty: 'Votre panier est vide.',
      emptyHint: 'Allez dans l\'onglet Recherche pour trouver des titres à ajouter.',
      addToPortfolio: 'Ajouter au portefeuille',
      pending: 'titre en attente',
      pendingPl: 'titres en attente'
    },
    tools: {
      converterTitle: 'Convertisseur de devises',
      amountLabel: 'Montant à convertir',
      invert: 'Inverser',
      result: 'Résultat',
      rateInEffect: 'Taux en vigueur :',
      tipTitle: 'Outils de calcul',
      tipBody: 'Cet espace regroupe des utilitaires pratiques pour vos décisions financières. Le convertisseur de devises utilise les taux en temps réel chargés à votre connexion. D\'autres outils (calculateur de dividendes composés, simulateur de retrait, etc.) seront ajoutés ici progressivement.'
    },
    pwa: {
      installed: 'App installée',
      installedTip: 'Vous utilisez Auto-Gère depuis l\'application installée',
      installBtn: 'Installer l\'app',
      installTip: 'Installer Auto-Gère comme app sur votre ordinateur (raccourci bureau + fenêtre dédiée)',
      previewBanner1: 'Vous êtes sur l\'environnement de TEST. Allez sur',
      previewBanner2: 'pour la vraie application.'
    }
  },
  en: {
    confirmDelete: {
      title: 'Confirm deletion',
      description: 'This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel'
    },
    // Navigation
    nav: {
      login: 'Login',
      signup: 'Create my account',
      dashboard: 'Dashboard',
      transactions: 'Statement of operations',
      budget: 'Budgets',
      portfolio: 'Portfolio',
      market: 'Market',
      reports: 'Reports',
      archive: 'Archive',
      settings: 'Settings',
      logout: 'Logout'
    },
    // Landing Page
    landing: {
      title: 'Master your finances and investments in one place',
      subtitle: 'A complete platform to manage your budget, track expenses, and optimize your investment portfolio.',
      getStarted: 'Get Started Free',
      tryDemo: '🎬 Try the demo — no sign-up',
      demoLoading: 'Opening the demo…',
      demoSubtext: 'Explore the full app with sample data, no account needed.',
      demoBannerText: 'Demo mode — shared sample data, reset daily.',
      demoBannerCta: 'Create my free account',
      trackingOnlyTitle: 'Tracking platform only',
      trackingOnlyBody: 'Auto-Gère does not execute any financial transactions: no buying or selling of securities, no connection to your bank or brokerage accounts. You enter your data, the app organizes and tracks it for you — your funds always stay at your institution.',
      launchCounter: 'Launch offer: {count} subscribers already — only {left} spots left at the reduced price, locked for life!',
      launchPriceHero: 'Launch price: ${monthly}/month or ${yearly}/year — locked for life!',
      midCtaTitle: 'Convinced? Your free account is ready in 30 seconds.',
      pricingBadge: 'Pricing',
      pricingTitle: 'Simple pricing, no surprises',
      pricingSubtitle: 'Start for free, upgrade to Premium when you are ready. Cancel anytime.',
      pricingFreeTitle: 'Free',
      pricingFreeSub: 'No credit card required',
      pricingFree1: 'Full dashboard and budget',
      pricingFree2: '2 portfolio assets',
      pricingFree3: '1 statement import (CSV/Excel)',
      pricingFreeCta: 'Create my free account',
      pricingLaunchBadge: 'Launch offer — first 100',
      pricingMonthlyTitle: 'Premium monthly',
      pricingPerMonth: '/month',
      pricingPerYear: '/year',
      pricingFrozen: 'Price locked for life while you stay subscribed',
      pricingPrem1: 'Unlimited assets and imports',
      pricingPrem2: 'Full dividend tracking (calendar, history, totals)',
      pricingPrem3: 'Email alerts and monthly PDF reports',
      pricingPrem4: 'Real-time markets and multi-currency',
      pricingPremiumCta: 'Become a founding member',
      pricingYearlyTitle: 'Premium yearly',
      pricingYearlySave: '2 months free vs monthly',
      pricingNote: 'Prices in Canadian dollars (CAD). Secure payment via PayPal. One-click cancellation, no hidden fees.',
      launchPriceHeroSub: 'Reserved for the first 100 subscribers (regular price: ${standard}/month afterwards). Free trial included.',
      learnMore: 'Learn More',
      features: 'Powerful features for your financial success',
      feature1Title: 'Expense Tracking',
      feature1Desc: 'Track all your transactions and categorize expenses automatically.',
      feature2Title: 'Budget Management',
      feature2Desc: 'Create custom budgets and receive alerts before exceeding them.',
      feature3Title: 'Investment Portfolio',
      feature3Desc: 'Manage your stocks and cryptocurrencies with real-time prices.',
      feature4Title: 'Smart Alerts',
      feature4Desc: 'Receive notifications for important financial events.',
      feature5Title: 'Maximum Security',
      feature5Desc: 'Your data is encrypted and protected according to banking standards.',
      feature6Title: 'Detailed Reports',
      feature6Desc: 'Visualize your finances with comprehensive charts and reports.',
      cta: 'Ready to take control of your finances?',
      ctaSubtitle: 'Start free today. No credit card required.',
      ctaButton: 'Create my free account',
      footer: '© 2026 Auto-Gère. All rights reserved.',
      // === Landing page v2 (2026 redesign) ===
      heroBadge: '2026 highlights · Auto import · Multi-currency · Excel-style budget',
      heroTitleMain: 'Master your finances and investments',
      heroTitleAccent: 'in one place',
      heroSubtitle: 'Expense tracking, Excel-style budget, multi-currency portfolio and PDF reports — import your statements (CSV/Excel) in one click, no bank connection required.',
      reassureEncryption: 'Bank-grade encryption',
      reassureEncryptionSub: 'JWT + 2FA TOTP',
      reassureRealtime: 'Real-time market data',
      reassureRealtimeSub: 'Yahoo Finance · CoinGecko',
      reassureAlerts: 'Email alerts',
      reassureAlertsSub: 'Watchlist & thresholds',
      reassureFree: 'Free to start',
      reassureFreeSub: '1 bank statement upload · 2 assets',
      slidesBadge: 'Guided tour',
      slidesTitle: 'Discover Auto-Gère screen by screen',
      slidesSubtitle: 'A real preview of every tab — dashboard, budget, portfolio, market and more.',
      slide_dashboard: 'Dashboard — all your finances at a glance',
      slide_transactions: 'Transactions — income and expenses, categorized',
      slide_budget: 'Budgets — payment dates, reminders and live progress',
      slide_portfolio: 'Portfolio — stocks & crypto in real time, multi-currency',
      slide_market: 'Market — watchlist, price alerts and market cap',
      slide_reports: 'Reports — tailor-made PDF/Excel exports',
      slide_archive: 'Archive — 7 years of PDF history, send by email',
      slide_settings: 'Settings — 2FA security and flexible subscription',
      videoBadge: 'Video demo',
      videoTitle: 'Discover Auto-Gère on video',
      videoSubtitle: 'A guided tour of the software: dashboard, budget, portfolio, reports — see everything Auto-Gère can do for your finances.',
      videoTabFull: 'Full walkthrough',
      videoTabTransactions: 'Transactions',
      videoPlayCta: 'Play the video',
      videoNoSound: 'Visual demonstration · no narration',
      sectionTitle: 'Every feature, no compromises',
      sectionSubtitle: 'Discover what makes Auto-Gère unique: smart automation, native multi-currency support, and spreadsheet-grade tools — all in one fluid interface.',
      badgeNew: 'New',
      featAiImportTitle: 'Bank statement import',
      featAiImportDesc: 'Drop your statement as PDF, CSV, OFX, QFX or even a photo: Auto-Gère extracts your transactions automatically, detects currency and category. The source document is never stored on our servers.',
      featBudgetExcelTitle: 'Detailed Excel-style budget',
      featBudgetExcelDesc: 'Spreadsheet view with "Auto-paid" columns (green / red), payment dates per paycheck, dynamic calculations and customizable periods. Excel\'s comfort, the web\'s fluidity.',
      featMultiCurrencyTitle: 'Multi-currency portfolio',
      featMultiCurrencyDesc: 'Track US, Canadian (.TO / .UN), European and Indian (.NS) stocks with their national flag and native currency (USD, CAD, EUR, INR…). Automatic conversion to Canadian dollar (default base currency).',
      featDashboardTitle: 'Enriched dashboard',
      featDashboardDesc: 'Three rearrangeable pie charts (Total, US, Canada), monthly dividend tracking, real-time unrealized gains and a "Amount to set aside per paycheck" summary.',
      featDividendsTitle: 'Dividend tracking',
      featDividendsDesc: 'Upcoming ex-dividend dates calendar, visual frequency (Monthly / Quarterly / Semi-annual / Annual), manual overrides and annual total per position.',
      featAnalysisTitle: 'Portfolio analysis with A→F grades',
      featAnalysisDesc: 'For each holding: Auto-Gère quality score from A to F based on 4 axes (P/E, ROE, debt, margin), analyst consensus (Buy / Hold / Sell), synthetic summary. For uncovered tickers, an in-depth research is auto-generated.',
      featToolsTitle: 'Built-in financial tools',
      featToolsDesc: 'Real-time currency converter (CAD · USD · EUR · GBP · CHF · JPY · INR) with daily rates, smart calculators and more to come. Available directly in Market → Tools.',
      featReportsTitle: 'Reports & yearly archive',
      featReportsDesc: 'Export your transactions, budgets and portfolio as PDF / Excel anytime. Receive a monthly performance report by email. Archive past years in one click.',
      portfolioBadge: 'Global markets',
      portfolioTitlePart1: 'Your stocks,',
      portfolioTitleAccent: 'their currency',
      portfolioTitlePart2: ', your overview.',
      portfolioBullet1Strong: '200+ markets',
      portfolioBullet1Rest: ' supported: NYSE, NASDAQ, TSX, Euronext, LSE, NSE, Tokyo…',
      portfolioBullet2Strong: 'National flags',
      portfolioBullet2Rest: ' to recognize each stock\'s origin at a glance',
      portfolioBullet3Strong: 'Sort by column',
      portfolioBullet3Rest: ': price, value, gain, dividend — ascending or descending in one click',
      portfolioBullet4Strong: 'Automatic dividends',
      portfolioBullet4Rest: ': next date, frequency, cumulative monthly total',
      portfolioCaption: 'Price in native currency · Value converted to CAD',
      ctaTitleNew: 'Ready to take back control of your finances?',
      ctaSubtitleNew: 'Get started for free in under a minute. No credit card required — go Premium only when you are convinced.',
      ctaButtonNew: 'Create my free account',
      ctaTrust: '1 bank statement upload · 2 assets · $0 to start',
      footerFaq: 'FAQ',
      footerRefund: 'Refund policy',
      footerPrivacy: 'Privacy policy',
      footerContact: 'Contact'
    },
    // Auth Page
    auth: {
      welcome: 'Welcome back!',
      emailPlaceholder: 'you@example.com',
      createAccount: 'Create account',
      loginSubtitle: 'Log in to access your dashboard',
      registerSubtitle: 'Start managing your finances now',
      fullName: 'Full name',
      email: 'Email',
      password: 'Password',
      loginButton: 'Login',
      registerButton: 'Create account',
      legalConsentLabel: 'I have read and accept',
      legalConsentLink: 'the legal terms',
      legalConsentRequired: 'You must accept the legal terms to create an account.',
      privacyConsentLabel: 'I consent to the collection and use of my personal information as described in the',
      privacyConsentLink: 'Privacy Policy',
      privacyConsentLaw: 'Law 25, Quebec',
      privacyConsentRequired: 'You must consent to the Privacy Policy (Law 25) to create an account.',
      legalConsentSale: 'I have read and accept the Terms of Sale',
      legalConsentSaleRequired: 'You must accept the Terms of Sale to subscribe.',
      loading: 'Loading...',
      noAccount: 'No account yet? Sign up',
      hasAccount: 'Already have an account? Log in',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Account created successfully! Please log in.',
      heroTitle: 'Your finances, secured',
      heroSubtitle: 'Bank-grade encryption and two-factor authentication',
      twoFactorTitle: '2FA Verification',
      twoFactorSubtitle: 'Enter the 6-digit code from your authenticator app',
      twoFactorCodeLabel: '2FA Code',
      twoFactorHint: 'You can also use a recovery code',
      twoFactorVerify: 'Verify',
      twoFactorVerifying: 'Verifying...',
      twoFactorBack: 'Back to login',
      twoFactorPrompt: 'Enter your two-factor authentication code',
      error: 'An error occurred',
      trustBannerTitle: 'Encrypted connection — bank-grade standard',
      trustBannerDesc: 'Your session is secured with an httpOnly cookie, invisible to scripts and third-party extensions — protection matching major financial institutions.',
      cookieHttpOnly: 'httpOnly cookie',
      activationEmailSent: 'Activation email sent to:',
      activationSpamWarning: 'If you can\'t find it:',
      activationSpamBody: 'Check your spam / junk folder. If nothing arrives after a few minutes, click "Resend email" below to continue.',
      resendActivation: 'Resend email',
      forgotPassword: 'Forgot password?',
      forgotPasswordTitle: 'Reset password',
      forgotPasswordDesc: 'We will send you a link to create a new password.',
      forgotEmailLabel: 'Email address',
      forgotSubmit: 'Send link',
      forgotSuccess: 'If an account exists, a reset email has been sent.',
      forgotError: 'Unable to send reset email.',
      forgotRateLimit: 'Limit: 3 attempts per hour per email address.',
      forgotSentTitle: '📨 Email sent',
      forgotSentBody: 'Check your inbox (and spam / junk folder). The link expires in 1 hour.',
      cancel: 'Cancel'
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      balance: 'Monthly Balance',
      income: 'Income',
      expenses: 'Expenses',
      portfolioValue: 'Portfolio',
      assetIncome: 'Asset income',
      alerts: 'Alerts',
      recentTransactions: 'Recent Transactions',
      noTransactions: 'No transactions',
      subscription: 'Subscription',
      currentPlan: 'Current plan',
      upgradeToPremium: 'Upgrade to Premium to unlock all advanced features.',
      upgradeButton: 'Upgrade to Premium',
      loading: 'Loading...',
      totalIncome: 'Total income',
      totalSpent: 'Total spent',
      txDistribution: 'Operations distribution',
      portfolioDistribution: 'Portfolio distribution',
      // v1.03.02 - i18n audit (Dashboard.jsx)
      amountPerPay: 'Amount to transfer per paycheck',
      accordingToPeriod: 'According to your period',
      projectedAssetIncome: 'Projected asset income',
      netBalance: 'Net balance (income − expenses)',
      rentalDeficit: 'Rental deficit detected',
      distributionByAccount: 'Distribution by account',
      mergeTables: 'Merge tables',
      checkingAccount: 'Checking account',
      account: 'Account',
      income: 'Income',
      expenses: 'Expenses',
      netBalanceShort: 'Net balance',
      txCountShort: '# TX',
      welcomeTitle: 'Welcome to Auto-Gère!',
      welcomeBody: 'Your dashboard aggregates all your finances. Click Refresh at the top right to sync live prices, and check Merge tables in Distribution by account for a global total.',
      rentalDeficitBody: 'One or more payments expected in Asset Income have not been received yet (past due). This amount is subtracted from real net income — like an expense.',
      deficitGoTo: 'View in Asset Income',
      dismissAlert: 'Dismiss this warning',
      payPeriodWeekly: 'Weekly (×52)',
      payPeriodBiweekly: 'Bi-weekly (×26)',
      payPeriodSemimonthly: 'Semi-monthly (×24)',
      payPeriodMonthly: 'Monthly (×12)',
      payLabel: 'paychecks',
      noAsset: 'No asset',
      budgetAlert: 'You have reached 90% of your budget for {category}',
      savingGoalReached: 'Savings goal reached for {category}!',
      clearAllAlerts: 'Clear all',
      confirmClearAlerts: 'Delete all alerts?',
      refresh: 'Refresh',
      typeCol: 'Type',
      totalRow: 'Total',
      moveUp: 'Move up',
      moveDown: 'Move down',
      noUsStocks: 'No US stocks'
    },
    // Transactions
    transactions: {
      title: 'Statement of operations',
      subtitle: 'Manage your income and expenses',
      // v1.03.07 - Transactions + AccountTabs
      checkingAccount: 'Checking account',
      addCard: 'Add a card',
      addCardBtn: '+ Add a card',
      editCard: 'Edit card',
      addCreditCard: 'Add credit card',
      allTab: 'All',
      uncategorized: 'Uncategorized',
      allPeriods: 'All periods',
      importBtn: 'Import',
      exportBtn: 'Export',
      resetBtn: 'Reset',
      selectedCard: 'Selected card',
      addTransaction: 'Add transaction',
      newTransaction: 'New transaction',
      type: 'Type',
      income: 'Income',
      expense: 'Expense',
      saving: 'Saving',
      reimbursement: 'Reimbursement',
      amount: 'Amount',
      category: 'Category',
      categoryPlaceholder: 'Ex: Food, Salary, Transport',
      description: 'Description',
      add: 'Add',
      date: 'Date',
      noTransactions: 'No transactions recorded',
      addFirstTransaction: 'Add your first transaction',
      success: 'Transaction added successfully',
      error: 'Error adding transaction',
      scanReceipt: 'Scan a receipt',
      scanInProgress: 'Analyzing…',
      scanSuccess: 'Receipt analyzed! Please review fields before saving.',
      scanError: 'Could not scan this image',
      scanInvalidType: 'Unsupported format (JPEG, PNG or WEBP only)',
      scanTooLarge: 'Image too large (max 8 MB)',
      raz: 'Reset',
      razTooltip: 'Reset all transactions',
      razConfirm: '⚠️ WARNING: This action will permanently delete ALL your transactions and reset your budgets to zero.\n\nAre you sure you want to continue?',
      razSuccess: 'All transactions have been deleted',
      razError: 'Reset failed',
      cardName: 'Card name',
      currencyLabel: 'Currency',
      creditLimit: 'Credit limit',
      creditLimitTip: 'Enter the limit as shown on your statement — Auto-Gère will convert automatically for multi-currency comparisons.',
      cycleDay: 'Cycle end day (1-31)',
      cycleDayTip: 'The displayed balance reflects transactions from the current cycle.',
      updateBtn: 'Update',
      deleteCardTitle: 'Delete this card?',
      deleteCardBody: 'Associated transactions will be reassigned to the checking account, not deleted.',
      nameRequired: 'Name is required',
      cycleDayRange: 'Cycle day must be between 1 and 31',
      cardUpdated: 'Card updated',
      cardAdded: 'Card added',
      cardDeleted: 'Card deleted — transactions reassigned to the checking account',
      cardDeleteError: 'Delete failed',
      useBtn: 'Use',
      balanceDue: 'Balance due',
      actionsCol: 'Actions',
      introTitle: 'Your transactions, at a glance',
      introBody: 'Click Import to upload a PDF / CSV / OFX statement (the AI scanner detects transactions automatically). Use the Uncategorized filter + the month selector to catch up on your imports quickly. When you change a category manually, Auto-Gère offers to apply the same category to duplicates.',
      deleteTxConfirm: 'Delete this transaction?',
      inCur: 'in'
    },
    // Budget
    budget: {
      title: 'Budgets',
      subtitle: 'Set and track your budgets',
      // v1.03.07 - Budget.jsx
      tabPersonal: 'Personal budget',
      tabAssetIncome: 'Asset income',
      tabSavings: 'Savings / Expense',
      tabEmailAlerts: 'Email alerts',
      rolloverBtn: 'Roll over to next year',
      rolloverTitle: 'Roll the Budget over to next year',
      rolloverSubtitle: 'Archives the ending year then resets progress — your structure (sections, lines, amounts) is preserved.',
      rolloverYearLabel: 'Year to close',
      rolloverStep1: 'A snapshot PDF of your {year} Personal Budget is created and stored in Archive',
      rolloverStep2: 'All payment dates are shifted from {year} to {next}',
      rolloverStep3: '"Done" checkmarks are cleared (progress reset to 0%) — sections, lines and amounts preserved',
      rolloverWarning: 'Irreversible action (except the archived PDF). Both Personal Budget AND Asset Income tabs are processed.',
      rolloverConfirmLabel: 'To confirm, type {year} below:',
      rolloverGo: 'Roll over to next year',
      rolloverRunning: 'Processing…',
      rolloverSuccess: 'Budget {year} archived — welcome to {next}! Progress reset.',
      rolloverError: 'Error while rolling over to next year.',
      payPeriodTitle: 'My pay period',
      payPeriodSub: 'Change the calculation basis for the table and transfer amount.',
      emailReminderTitle: 'Email reminder · upcoming payments',
      emailReminderSub: 'A single email grouping all payments (auto or manual) scheduled for the same day — sent at 9 a.m. Eastern time.',
      testEmailBtn: 'Send test',
      newSection: 'New section (e.g. house, car, insurance…)',
      calcAsIncome: 'Calculated as income',
      calcAsExpense: 'Calculated as expense',
      sectionNamePlaceholder: 'Section name…',
      addSection: 'Add',
      colDescription: 'Description',
      colAutoPaid: 'Auto paid',
      colPaymentDates: 'Payment dates',
      colAnnual: 'Year',
      colProgressionLive: 'Live progress',
      colActions: 'Actions',
      yes: 'Yes',
      no: 'No',
      reminderDays1: '1 day before',
      reminderDays2: '2 days before',
      reminderDays3: '3 days before',
      reminderDays7: '7 days before',
      reminderNever: 'Never',
      reminderDisabled: 'Disabled (no email)',
      reminderSameDay: 'Same day',
      total: 'Total',
      expense: 'Expense',
      income: 'Income',
      tooltipIncomeSection: 'Section counted as INCOME',
      tooltipExpenseSection: 'Section counted as EXPENSE',
      addBudget: 'Create budget',
      newBudget: 'New budget',
      category: 'Category',
      limit: 'Limit',
      period: 'Period',
      monthly: 'Monthly',
      spent: 'Spent',
      remaining: 'Remaining',
      noBudgets: 'No budgets defined',
      createFirstBudget: 'Create your first budget',
      success: 'Budget created successfully',
      error: 'Error creating budget',
      tipDetailTitle: 'Percentage budget',
      tipDetailBody: 'Set the percentage of your monthly income you want to allocate to each category (housing, food, savings…). Auto-Gère automatically computes the amounts and alerts you when you exceed them.',
      tipIncomeTitle: 'Asset Income',
      tipIncomeBody: 'Dedicated to your personal real-estate assets (rental apartments, multi-unit buildings…). Enter here the income (rents collected) AND the incurred expenses (municipal taxes, maintenance, mortgage, insurance…). The net balance is shown at the bottom of the table for each asset.'
    },
    // Portfolio
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Manage your investments',
      addAsset: 'Add asset',
      newAsset: 'New asset',
      assetType: 'Asset type',
      nextDividendDate: 'Next dividend',
      noDividend: '—',
      stock: 'Stock',
      crypto: 'Cryptocurrency',
      symbol: 'Symbol',
      symbolPlaceholder: 'e.g. AAPL, bitcoin',
      quantity: 'Quantity',
      targetQty: 'Target',
      targetQtyOptional: 'optional — target number (e.g. 100)',
      sortByTargetQty: 'Sort by purchase target',
      purchasePrice: 'Purchase price',
      totalReceived: 'Total received ({year})',
      grandTotalReceived: 'Total dividends received in {year}',
      importHistory: 'Import history',
      importHistoryTip: 'Imports dividends already paid since the purchase date of each asset (estimate: payment/share × current quantity)',
      importHistoryLoading: 'Importing…',
      importHistoryConfirm: 'Import dividends paid since the purchase date of each asset? The estimate uses the current quantity. You can undo the import at any time.',
      importHistoryDone: '{n} payments imported into history',
      undoImport: 'Undo import',
      undoImportTip: 'Removes all automatically imported payments (manual "Dividend received" clicks are kept)',
      undoImportConfirm: 'Remove all imported payments from history? Manual "Dividend received" clicks will be kept.',
      undoImportDone: '{n} imported payments removed',
      yieldOnCost: 'YoC',
      currentPrice: 'Current price',
      totalValue: 'Total value',
      gainLoss: 'Gain/Loss',
      noAssets: 'No assets in your portfolio',
      addFirstAsset: 'Add your first asset',
      delete: 'Delete',
      success: 'Asset added successfully',
      deleteSuccess: 'Asset deleted',
      error: 'Error adding asset',
      dividendYield: 'Annual dividend yield',
      dividendYieldPlaceholder: 'e.g. 3.5 (leave empty if no dividend)',
      monthlyDividend: 'Monthly dividend',
      annualDividend: 'Annual',
      unrealizedProfits: 'Unrealized profits',
      slowGrowth: 'Slow movement (< 5%)',
      totalMovement: 'Total gains + losses',
      assetsShort: 'asset(s)',
      gains: 'Gains',
      losses: 'Losses',
      netLatent: 'net latent',
      vsSp500: 'Performance vs S&P 500',
      vsSp500Empty: 'Not enough historical data. Add assets to your portfolio.',
      vsSp500Note: 'Weighted by each asset value. Base 100 at the start of the period.',
      // v1.03.02 - i18n audit (Portfolio.jsx)
      stocksBought: 'Stocks bought',
      titlesTotal: 'titles total',
      cryptoHeld: 'Crypto held',
      unitsTotal: 'units total',
      totalPurchase: 'Total purchase price',
      capitalInvested: 'capital invested',
      currentValue: 'Current value',
      freqMonthlyShort: 'Monthly (M)',
      freqQuarterlyShort: 'Quarterly (Q)',
      freqSemiAnnualShort: 'Semi-annual (S)',
      freqAnnualShort: 'Annual (A)',
      dividendConfirm: 'Dividend confirmation',
      dividendReceived: 'received?',
      globalDividendSharing: 'Global dividend sharing',
      totalCap: 'TOTAL',
      refresh: 'Refresh',
      cancel: 'Cancel',
      save: 'Save',
      close: 'Close',
      disable: 'Disable',
      sharingBreakdownTitle: 'Detailed monthly dividend breakdown',
      titleCol: 'Symbol',
      grossMonthly: 'Gross monthly',
      monthlyTotal: 'Monthly total',
      annualTotal: 'Annual total',
      buildYourPortfolio: 'Build your portfolio',
      forceUpdatePrices: 'Force price and dividend refresh from Yahoo Finance',
      manageCoOwnership: 'Manage co-ownership and dividend sharing with partners',
      yourPortfolio: 'Your portfolio',
      outperforms: 'Outperforms',
      underperforms: 'Underperforms',
      distribution: 'Portfolio distribution',
      totalValueLabel: 'Total value',
      tabAll: 'All',
      tabStocks: 'Stocks',
      tabCrypto: 'Crypto',
      tabDividends: 'Dividends',
      noDividendAssets: 'No dividend asset. Set a yield > 0 when creating.',
      colYield: 'Yield',
      colDivMonthly: 'Monthly div.',
      colDivAnnual: 'Annual div.',
      actions: 'Actions',
      alsoInWatchlist: 'Also tracked in Market — open the watchlist to complete its info',
      inWatchlistShort: 'Market',
      toComplete: 'To complete',
      completeFieldsTooltip: 'Added from Market — fill in quantity and purchase price',
      refreshing: 'Refreshing…',
      sharingBtn: 'Sharing',
      yieldDetected: 'Yield {dy}% detected for {symbol}',
      noDividendFor: '{symbol}: no dividend',
      specialDividendToast: '🎁 {symbol}: special dividend of ${amount} detected on {date}. Not included in the recurring annual calculation.',
      yieldFetchError: 'Could not fetch the yield',
      specialDividendDetected: 'Special dividend detected',
      specialDividendNote: 'These exceptional payments are not included in the recurring annual dividend calculation shown below.',
      dividendFrequency: 'Dividend frequency',
      autoDetecting: 'Auto-detecting…',
      detectedLabel: 'Detected',
      fetchAuto: 'Fetch auto',
      freqAutoOption: 'Automatic (per Yahoo Finance)',
      freqMonthly: 'Monthly',
      freqQuarterly: 'Quarterly',
      freqSemiAnnual: 'Semi-annual',
      freqAnnual: 'Annual',
      freqSemiAnnualLong: 'Semi-annual (S — every 6 months)',
      semiAnnualNote: '(every 6 months)',
      freqHelp: 'Leave on Automatic to use the frequency detected by Yahoo Finance. Force a value only if the detection is wrong.',
      dpsLabel: 'Dividend per share',
      dpsAuto: 'Auto',
      dpsForced: 'Forced by you',
      dpsRevertAuto: 'Back to auto',
      dpsPlaceholderAuto: 'Leave empty to use auto: {value}',
      dpsPlaceholder: 'Leave empty for automatic Yahoo value',
      dpsHelp: 'Enter a value only if the Yahoo Finance data is wrong for this security. Otherwise leave empty.',
      nextDivDateLabel: 'Next dividend date',
      editableIfError: '— editable if wrong',
      restoreYahooTooltip: 'Restore the date automatically detected by Yahoo Finance',
      autoYahooBtn: 'Auto Yahoo',
      nextDivDateHelp: 'If the date detected by Yahoo Finance is incorrect, you can fix it here. Leave empty to use the auto value.',
      enterSymbolFirst: 'Enter a symbol first',
      yahooDateRestored: 'Yahoo date restored: {date}',
      yahooNoDate: 'Yahoo Finance does not provide a date for this security',
      yahooDateError: 'Could not fetch the Yahoo date',
      quarterlyDividend: 'Quarterly dividend',
      annualDividendFull: 'Annual dividend',
      dividendPeriodAria: 'Dividend display period',
      sharingActiveTooltip: 'Global sharing active — click to edit',
      sharingBreakdownTooltip: 'Click to see the detailed breakdown by security',
      paymentTrackingTab: 'Payment tracking',
      paymentTrackingTooltip: 'List of dividends whose expected date has passed — check to confirm receipt',
      noPendingConfirmations: '🎉 No dividend awaiting confirmation! All your dates are upcoming.',
      inFunction: 'active',
      dividendWord: 'Dividend',
      totalAnnualDividends: 'Total annual dividends:',
      sharingDesc: 'This split applies to the TOTAL of your dividends (all securities combined). The 1st row = your share. E.g.: total dividend $100/month, Paul 75% → you see $75/month.',
      coOwnership: 'Co-ownership',
      enableSharing: '+ Enable sharing',
      disableSharing: '× Disable',
      sharingDefaultNote: 'By default you receive 100%. Enable to share with associates (e.g. "Paul 75%, Son 25%").',
      yourNamePlaceholder: 'Your name (e.g. Paul)',
      associateNamePlaceholder: 'Associate name',
      removeAssociate: 'Remove this associate',
      addAssociate: '+ Add an associate',
      sumComplete: 'Sum complete ✓',
      sumOver: 'Over by: +{value} %',
      sumRemaining: 'Remaining: {value} % to distribute',
      needAtLeastTwo: 'Add at least 2 associates (you + 1 other)',
      sumMustBe100: 'The sum must be 100 (currently {sum})',
      eachNeedsName: 'Each associate must have a name',
      sharingSaved: 'Dividend sharing saved',
      noDividendPayers: 'No security currently pays dividends in your portfolio.',
      breakdownDesc: 'Breakdown of each security\'s gross monthly dividend according to your configured global shares. The 1st column = your share, the following = associates.',
      recipientLabel: 'Recipient',
      exampleEmail: 'accountant@example.com',
      sending: 'Sending...',
      send: 'Send',
      exportPdf: 'Export as PDF',
      sendByEmail: 'Send by email',
      emailSentTo: 'Email sent to {email}',
      sendFailed: 'Send failed',
      pdfExported: 'PDF exported',
      dateRestored: 'Date restored',
      dateRestoreFailed: 'Could not restore the previous date',
      nextDateSet: '{symbol} → {date} (use ↶ to undo if wrong)',
      noNextDateFound: 'No upcoming date found for {symbol}',
      refreshFailed: 'Refresh failed',
      noPrevDateForAsset: 'No previous date to restore for this asset',
      dateRestoredFor: 'Date restored for {symbol}',
      restoreFailed: 'Restore failed',
      restorePrevDate: '↶ Restore the previous date ({date})',
      noPrevDate: 'No previous date to restore',
      calcByFreq: 'Calculated from the "{freq}" frequency',
      next3Dates: '🔮 Next 3 estimated dates:',
      portfolioIntroTip: 'Add your stocks and cryptocurrencies to track real-time value, expected dividends, and analyst recommendations. Click Refresh to sync stock prices (Yahoo Finance) and crypto prices (CoinGecko).',
      refreshedToast: 'Portfolio refreshed ({n} assets)',
      completeQtyPrice: 'Fill in the quantity and price for {symbol}',
      byNationality: 'by nationality',
      tsxTipLabel: 'Tip:',
      tsxTipBody: 'for a Canadian stock (TSX), add .TO at the end of the symbol (e.g. JEPI.TO, H.TO). Without a suffix, the symbol will be treated as a US stock.',
      nativeCurrencyNote: 'asset\'s native currency',
      priceNativeTip: 'Enter the price in {native} (not in {cur}) — the conversion to {cur} will be done automatically by the app.',
      sortBySymbol: 'Sort by symbol',
      sortByNextDate: 'Sort by next dividend date',
      sortByFreq: 'Sort by frequency (M→Q→S→A)',
      sortByQty: 'Sort by quantity',
      sortByBuyPrice: 'Sort by purchase price',
      sortByCurPrice: 'Sort by current price',
      sortByTotalValue: 'Sort by total value (user currency)',
      sortByDps: 'Sort by dividend per share',
      sortByMonthlyDiv: 'Sort by average monthly dividend',
      sortByGain: 'Sort by gain / loss',
      receivedHeaderTip: 'Check when you have just received your dividend — Auto-Gère will look for the next upcoming date',
      confirmedTip: 'Dividends confirmed for this asset',
      validateOnceTip: 'Click ONCE to validate that dividends are correctly detected by Yahoo Finance',
      receivedCheckTip: 'Check when you have just received your dividend so the next date is searched',
      firstCheckTip: 'Click "To verify" the first time to enable dividend tracking'
    },
    // Market
    market: {
      title: 'Market Data',
      subtitle: 'Track real-time prices',
      tabWatchlist: 'Watchlist',
      tabAnalysis: 'Analysis',
      tabTools: 'Tools',
      tabBasket: 'Basket',
      tabIdeas: 'Ideas',
      importPortfolio: 'Import portfolio',
      importing: 'Importing…',
      search: 'Search',
      searchPlaceholder: 'Search stocks or crypto...',
      trending: 'Trending',
      price: 'Price',
      change24h: '24h Change',
      marketCap: 'Market Cap',
      volume: 'Volume',
      noData: 'No data available',
      newTitle: 'New tracker',
      editTitle: 'Edit tracker',
      addBtn: 'Add to watchlist',
      errorLoading: 'Failed to load watchlist',
      testSent: 'Test email sent',
      testError: 'Failed to send test email',
      checkOk: 'Check complete',
      checkNoneTriggered: 'No new threshold crossed for now',
      checkError: 'Check failed',
      symbolRequired: 'Symbol required',
      saveError: 'Failed to save',
      empty: 'No symbol tracked. Add your first symbol to the watchlist.',
      noResults: 'No result for this search.',
      testEmailBtn: 'Test email',
      testEmailTooltip: 'Send a test email to my address',
      checkAlertsBtn: 'Check alerts',
      checkAlertsTooltip: 'Check thresholds now and send emails if triggered',
      refreshBtn: 'Refresh',
      alertAbove: 'Alert if price ≥',
      alertBelow: 'Alert if price ≤',
      alertPctAbove: 'Alert if rise ≥',
      alertPctBelow: 'Alert if drop ≤',
      alertPctHint: 'Calculated from the price when the alert was saved. Leave blank to disable.',
      alertPctTriggered: 'Change since alert:',
      setAlert: 'Alert',
      setAlertTooltip: 'Set a price or % change alert',
      alertsConfigured: 'Alerts',
      alertsConfiguredTooltip: 'Active alerts — click to edit',
      sinceAlert: 'Since alert:',
      resetReference: 'Reset',
      resetReferenceTooltip: 'Reset reference to current price',
      optional: 'Optional',
      personalNote: 'Personal note',
      notePlaceholder: 'e.g. Buy below 150$, watch Q4 results...',
      cryptoPlaceholder: 'e.g. bitcoin, ethereum',
      stockPlaceholder: 'e.g. AAPL, TSLA',
      legendCap: 'Market capitalization (Cap)',
      capSuffix_T: 'T$',
      capSuffix_B: 'B$',
      capSuffix_M: 'M$',
      capLegend_T: 'Trillions of dollars (1T = 1,000 billion)',
      capLegend_B: 'Billions of dollars (1B = 1,000 million)',
      capLegend_M: 'Millions of dollars',
      importEmptyPortfolio: 'Your portfolio is empty. Add assets first.',
      importAllPresent: 'Watchlist already in sync with the portfolio.',
      importAdded: '{n} asset(s) added to the watchlist',
      importFailedSome: '({n} failure(s))',
      importNoneAdded: 'No asset could be added (free plan limit?)',
      importLoadError: 'Unable to load the portfolio',
      cleanupTitle: 'Securities removed from portfolio',
      cleanupDesc: 'These watchlist securities are no longer in your portfolio. Remove them from Market? (Keep them if you watch them on purpose.)',
      cleanupRemoveBtn: 'Remove {n} securit(y/ies)',
      cleanupKeepBtn: 'Keep',
      cleanupDone: '{n} securit(y/ies) removed from the watchlist',
      alertCurrencyLabel: 'Threshold currency',
      alertOneShotHint: 'Each alert sends only one email. Save the alert again to re-arm it.',
      alertCurrencyHint: 'Your high/low thresholds will be compared to the price converted into this currency.',
      sortLabel: 'Sort',
      sortDefault: 'Default (alerts first)',
      sortCapDesc: 'Market cap: high → low',
      sortCapAsc: 'Market cap: low → high',
      capLabel: 'Cap:',
      capTooltip: 'Market capitalization (total market value of the company)',
      priceUnavailable: 'Price unavailable',
      removeTooltip: 'Remove',
      alertTriggered: 'Alert triggered:',
      alertAboveMsg: 'Above',
      alertBelowMsg: 'Below',
      thresholdHigh: 'High threshold:',
      thresholdLow: 'Low threshold:',
      noteLabel: 'Note',
      removeTitle: 'Remove this symbol?',
      removeDesc: 'The symbol will be removed from your watchlist. You can add it again later.',
      removeConfirm: 'Remove',
      alsoInPortfolio: 'This asset is also in your portfolio',
      inPortfolioShort: 'Portfolio',
      legendTitle: 'Badge legend',
      legendBtn: 'Legend',
      qualityGrade: 'Quality grade',
      gradeLegend_A: 'Excellent',
      gradeLegend_B: 'Good',
      gradeLegend_C: 'Average',
      gradeLegend_D: 'Mediocre',
      gradeLegend_E: 'Poor',
      gradeLegend_F: 'Avoid',
      legendCalc: 'Calculated from P/E, ROE, debt and profit margin.',
      legendFreq: 'Dividend frequency',
      freqLegend_M: 'Monthly',
      freqLegend_T: 'Quarterly',
      freqLegend_S: 'Semi-annual',
      freqLegend_A: 'Annual',
      importedNote: 'Imported from portfolio',
      notAdvice: 'This is not financial advice',
      discTitle: 'Important — Verify before buying',
      discMandatory: 'Mandatory notice',
      discP1: 'The information displayed in the Market section (prices, dividends, frequencies, analyst recommendations, research ideas, Auto-Gère Market Signals) comes from public and free sources (Yahoo Finance and Gemini AI).',
      discP2: 'The Auto-Gère Market Signals (Short / Mid / Long term) are computed internally from 5 classic technical indicators: RSI (momentum), MACD (convergence/divergence), MA (50/200 moving averages), MFI (money flow) and OBV (cumulative volume). Open methodology: these signals are a market-reading aid, never a guarantee of future performance.',
      discP3: 'This data may contain errors, delays or outdated information. A cross-checking tool is integrated server-side, but it in no way replaces direct verification.',
      discP4: 'Before any real transaction, always verify the figures (price, dividend, frequency, technical signals) on your broker\'s official platform or directly on the issuer\'s website.',
      discSecTitle: 'Auto-Gère is an external software',
      discSecBody: 'We have no access to your real bank accounts, your broker or your cards. No direct bank connection — therefore no risk of banking identity theft. You enter your own transactions and positions for tracking purposes only.',
      discInfo: 'Auto-Gère is an information and tracking tool — it constitutes neither financial advice, nor an investment recommendation, nor a solicitation to buy or sell. Market Signals, Auto-Gère grades and displayed recommendations are provided for information purposes only. Consult a licensed investment advisor before any binding investment decision.',
      dontShowAgain: 'Don\'t show this warning again',
      dontShowNote: '(reappears if you re-enable Tips in Settings)',
      moreInfoAria: 'More information about the warning',
      moreInfo: 'More information',
      footerDisclaimer: 'Auto-Gère is a management and tracking tool for your investments. The analyses, Auto-Gère grades, Market Signals (Short/Mid/Long term) based on 5 technical indicators — RSI, MACD, MA, MFI, OBV — and AI summaries are provided for strictly informational purposes and in no way constitute a recommendation to buy, sell or hold. Consult a qualified financial advisor before any investment decision.',
      importTooltip: 'Automatically adds all the assets from your portfolio to your watchlist'
    },
    categories: {
      added: 'Category added',
      modified: 'Category updated',
      deleted: 'Category deleted',
      confirmDelete: 'Delete this category?',
      errorAdd: 'Failed to add',
      errorModify: 'Failed to update',
      errorDelete: 'Failed to delete',
      manage: 'Manage categories',
      newPlaceholder: 'New category...',
      none: 'No category',
      defaultBadge: '(default)',
      choose: 'Choose a category'
    },
    settings: {
      passwordChanged: 'Password updated successfully',
      passwordError: 'Failed to update password',
      passwordRequired: 'Password required',
      accountDeleted: 'Account deleted. Goodbye.',
      accountDeleteError: 'Failed to delete account',
      deletingBtn: 'Deleting…',
      deletePermanentlyBtn: 'Delete permanently',
      changingPasswordBtn: 'Updating…',
      changePasswordBtn: 'Change password',
      twoFactorError: '2FA configuration error',
      title: 'Settings',
      subtitle: 'Manage your security settings and account',
      appearanceTitle: 'Appearance',
      appearanceDesc: 'Customize the accent color of the interface',
      themeLabel: 'Color theme',
      themeCurrent: 'Active theme',
      passwordTitle: 'Password',
      passwordDesc: 'Update your password regularly to keep your account secure',
      changeMyPasswordBtn: 'Change my password',
      changePasswordDialogTitle: 'Change my password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      passwordHelp: 'Min. 8 characters. Use uppercase, digits and symbols.',
      passwordMismatch: 'Passwords do not match',
      twoFactorTitle: 'Two-factor authentication (2FA)',
      twoFactorDesc: 'Add an extra layer of security with Google Authenticator, Microsoft Authenticator or Authy',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enable2faBtn: 'Enable 2FA',
      disable2faBtn: 'Disable 2FA',
      setup2faTitle: 'Configure two-factor authentication',
      manualCode: 'Secret key (manual entry):',
      recoveryCodes: 'Recovery codes',
      enter6DigitCode: 'Enter the 6-digit code shown in your authenticator app',
      verifyingBtn: 'Verifying...',
      disable2faTitle: 'Disable 2FA',
      sixDigitLabel: '6-digit code',
      accountInfo: 'Account information',
      emailLabel: 'Email',
      fullName: 'Full name',
      addressTitle: 'Postal address',
      addressStreet: 'Street address',
      addressCity: 'City',
      addressPostalCode: 'Postal code',
      addressProvince: 'Province / State',
      addressCountry: 'Country',
      addressEmpty: 'No address on file',
      editProfileBtn: 'Edit my info',
      editProfileTitle: 'Edit my information',
      editProfileDesc: 'Update your name, address and email. Email change requires a confirmation link.',
      saveBtn: 'Save',
      saving: 'Saving…',
      profileUpdated: 'Profile updated',
      emailChangePending: 'Change pending',
      emailChangePendingDesc: 'A confirmation link was sent to',
      emailChangeExpiresAt: 'Link expires',
      emailChangeCancel: 'Cancel change',
      emailChangeCanceled: 'Change request cancelled',
      emailChangeRequested: 'Confirmation link sent to {email}. Click it within 1 hour to validate.',
      emailUnchanged: 'No email change — the new address is the same as the current one.',
      emailAlreadyUsed: 'This email address is already used by another account.',
      emailVerifySuccess: 'Email successfully updated! You can now sign in with your new address.',
      emailVerifyExpired: 'Link expired. Please request a new change.',
      emailVerifyInvalid: 'Invalid or already-used link.',
      subscriptionTier: 'Subscription plan',
      mySuggestions: 'My suggestions',
      noSuggestionsYet: 'No suggestion sent yet',
      newSuggestion: 'New suggestion',
      suggCategory: 'Category',
      suggCategoryFeature: 'New feature',
      suggCategoryImprovement: 'Improvement',
      suggCategoryBug: 'Report a bug',
      suggCategoryGeneral: 'General',
      suggTitle: 'Title',
      suggTitlePlaceholder: 'e.g. Add an evolution chart',
      suggDescription: 'Description',
      suggDescriptionPlaceholder: 'Describe your idea in detail...',
      sendingBtn: 'Sending...',
      sendSuggestionBtn: 'Send suggestion',
      dangerZone: 'Danger zone',
      dangerZoneSubtitle: 'Irreversible actions on your account',
      dangerBullet1: 'Deleting your account is',
      dangerBullet1Strong: 'final and irreversible',
      dangerBullet2: 'All your data will be deleted: transactions, budgets, portfolio, watchlist, invoices',
      dangerBullet3: 'Your active Premium subscription will be cancelled without renewal',
      deleteAccountFinal: 'This action is',
      deleteAccountFinalStrong: 'permanent',
      deleteAccountFinalSuffix: 'and cannot be undone.',
      willBeDeleted: 'Will be permanently deleted:',
      itemTxBudgets: 'Your transactions and budgets',
      itemPfWatchlist: 'Your portfolio and watchlist',
      itemInvoices: 'Your invoices and payment history',
      itemSuggAlerts: 'Your suggestions and alerts',
      typeDeletePrompt: 'to confirm',
      typePasswordPlaceholder: 'Enter your password',
      tipsTitle: 'Guided tips',
      tipsDesc: 'Shows small tip bubbles on key pages to guide your first steps.',
      enabledPlural: 'Enabled',
      disabledPlural: 'Disabled',
      tipsNoneClosed: 'No tip has been closed yet.',
      tipsClosedCount: 'You closed {count} tip(s).',
      tipsResetBtn: 'Show all tips again',
      appUpdateTitle: 'App update',
      appUpdateDesc: 'Auto-Gère no longer checks for new versions automatically in the background. Click here to check now and get the latest improvements. Current version:',
      checkingBtn: 'Checking…',
      updateBtn: 'Update',
      budgetAlertTitle: 'Email alerts · Budget',
      budgetAlertDesc: 'Receive an email when one of your Savings / Expense categories reaches 90% of its limit (expense) or 100% of its goal (savings). The dashboard bell stays active in all cases.',
      alertsEnabled: 'Email alerts enabled',
      marketReportTitle: 'Market highlights report',
      marketReportDesc: 'Receive by email the day\'s winners and losers among your portfolio holdings, after market close.',
      marketReportFreq_off: 'Off',
      marketReportFreq_daily: 'Every day',
      marketReportFreq_weekly: 'Every week (Friday)',
      marketReportFreq_monthly: 'Every month',
      marketReportSaved: 'Report frequency saved',
      marketReportError: 'Error while saving',
      marketReportHint: 'Sent around 5 PM (Eastern Time) after US market close, on trading days.',
      alertsDisabled: 'Email alerts disabled',
      alertsPrefError: 'Could not update the preference',
      extraRecipientsTitle: 'Additional recipients',
      extraRecipientsDesc: 'These people will receive the same alerts as you (budget, overrun…) in addition to your main inbox. Ideal to notify a spouse, accountant or associate.',
      removeBtn: 'Remove',
      addBtn: 'Add',
      recipientPlaceholder: 'spouse@example.com',
      invalidEmail: 'Invalid email address',
      alreadyPrimary: 'You already receive alerts on your main email',
      alreadyInList: 'This address is already in the list',
      maxRecipients: 'Maximum 5 additional recipients',
      addedToAlerts: '{email} added to alerts',
      recipientRemoved: 'Recipient removed',
      cannotSave: 'Could not save'
    },
    paypalExtra: {
      cancelled: 'Auto-renewal cancelled',
      cancelError: 'Cancellation failed',
      paypalError: 'PayPal error. Try again later.',
      promoFirstCycleTitle: 'Discount applied to your first payment',
      promoFirstCycleDesc: 'Code {code} gives you {percent}% off your first payment. Subsequent renewals will be billed at the regular price.',
      promoNoteBanner: 'The discount applies to your first payment (with or without auto-renewal). Subsequent renewals are at the regular price.',
      cancelledByUser: 'Payment cancelled'
    },
    exportExtra: {
      error: 'Export failed',
      downloaded: 'Export downloaded'
    },
    common: {
      save: 'Save',
      saveChanges: 'Save changes',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      add: 'Add',
      confirm: 'Confirm',
      loading: 'Loading…',
      error: 'Error',
      errorLoading: 'Failed to load',
      errorSaving: 'Failed to save',
      errorDeleting: 'Failed to delete',
      errorAdding: 'Failed to add',
      errorUpdating: 'Failed to update',
      success: 'Success',
      deleted: 'Deleted',
      added: 'Added',
      modified: 'Updated',
      monthly: 'Monthly',
      yearly: 'Yearly',
      clickToHide: 'Click to hide'
    },
    premium: {
      title: 'Upgrade to Premium',
      autoRenewTitle: 'Auto-renewal',
      autoRenewReactivated: 'Auto-renewal reactivated',
      reactivateFailed: 'Reactivation failed',
      activeBadge: 'Active',
      disabledBadge: 'Disabled',
      nextBilling: 'Next billing:',
      noRenewal: 'No renewal. Your Premium expires on {date}.',
      expiryWarning: 'Warning: upon expiry, you will no longer be able to add new information (transactions, positions, budgets). Your existing data remains accessible in read-only mode.',
      activeTitle: 'Premium subscription active',
      subtitle: 'Unlock all features without limits',
      reservedTitle: 'Premium only',
      reservedDesc: 'Upgrade to Premium to unlock this feature.',
      upgradeNow: 'Upgrade to Premium',
      expiresOn: 'Expires on',
      included: 'Included in Premium',
      monthly: 'Monthly',
      yearly: 'Yearly',
      saveBadge: 'SAVE',
      perMonth: 'per month · no commitment',
      monthlyEquiv: 'i.e.',
      autoRenew: 'Auto-renewal',
      autoRenewOn: 'Your subscription will renew automatically. Cancel anytime.',
      autoRenewOff: 'One-time payment. You will need to renew manually when it expires.',
      autoRenewActive: 'Auto-renewal: ON',
      autoRenewInactive: 'Auto-renewal: OFF',
      nextBilling: 'Next billing on',
      noRenewal: 'Your Premium will expire at the end of the current period without renewal.',
      cancelRenewal: 'Cancel renewal',
      confirmCancelTitle: 'Cancel auto-renewal?',
      keepRenewal: 'Keep renewal',
      confirmCancel: 'Yes, cancel',
      payWithPaypal: 'Secure payment via PayPal',
      testMode: '(test mode)',
      processing: 'Processing payment…',
      myInvoices: 'My invoices',
      paid: '✓ Paid',
      billedIn: 'Billed',
      notConfigured: 'PayPal payment not configured.',
      confirmCancelDescPrefix: 'Your Premium subscription will stay active until',
      confirmCancelDescSuffix: 'No further charge will be made. You can reactivate anytime.',
      autoRenewedBadge: 'Auto-renewal',
      subActivated: 'Subscription activated! Invoice {invoice} sent by email.',
      activationError: 'Activation failed',
      captureSuccess: 'Payment successful! Invoice {invoice} sent by email.',
      captureError: 'Payment capture failed',
      planIdMissing: 'Missing plan ID',
      features: {
        unlimitedTransactions: 'Unlimited transactions',
        unlimitedAssets: 'Portfolio with no asset limit',
        priceAlerts: 'Price alerts by email',
        realTimeData: 'Real-time market data',
        exports: 'Unlimited PDF & Excel exports',
        multiCurrency: 'Multi-currency (15 currencies)',
        twoFactor: '2FA authentication',
        prioritySupport: 'Priority support'
      }
    },
    budgetExtra: {
      typeLabel: 'Goal type',
      expenseType: 'Spending limit',
      expenseDesc: 'Cap your spending',
      savingType: 'Savings goal',
      savingDesc: 'Save up an amount',
      goalAmount: 'Goal amount',
      manageCategories: 'Manage categories',
      saved: 'Saved',
      target: 'Target',
      leftToSave: 'Left to save',
      badgeSaving: '🎯 Savings',
      badgeExpense: '💸 Expense',
      goalReached: '✓ Goal reached!',
      overBudget: '⚠ Over budget or near the limit',
      approachingLimit: '⚠ Approaching the limit',
      editTooltip: 'Edit this budget',
      deleteTooltip: 'Delete this budget',
      moveUpTooltip: 'Move up',
      moveDownTooltip: 'Move down',
      farFromGoal: '⚠ Far from your goal — start saving',
      gettingStarted: '↗ Just getting started saving'
    },
    reports: {
      title: 'Reports & exports',
      subtitle: 'Summary of your finances and PDF / Excel downloads.',
      summaryIncome: 'Total income',
      summaryExpense: 'Total expenses',
      summaryBalance: 'Net balance',
      summaryPortfolio: 'Portfolio value',
      netCumulative: 'Cumulative income − expenses',
      entries: 'entries',
      assets: 'assets',
      exportsTitle: 'Quick exports',
      exportsSubtitle: 'Download your data in the format of your choice.',
      transactionsTitle: 'Transactions',
      transactionsDesc: 'Full list of all your transactions with categories.',
      budgetsTitle: 'Budgets',
      budgetsDesc: 'Status of all your spending and savings budgets.',
      budgetIncomeTitle: 'Income Budget',
      budgetIncomeDesc: 'Projected income (salary, dividends, allowances) by source.',
      portfolioTitle: 'Portfolio',
      portfolioDesc: 'Composition and performance of your portfolio.',
      downloadPdf: 'Download PDF',
      downloadExcel: 'Download Excel',
      downloading: 'Downloading…',
      downloadOk: 'Export downloaded',
      archiveBudget: 'Archive the Personal Budget of the year as PDF',
      archiveIncome: 'Archive Asset Income for a month as PDF',
      archivePortfolio: 'Archive the Portfolio for the year as PDF',
      archivePortfolioDesc: 'Generates a complete annual snapshot of your portfolio (assets, quantities, values, allocation). Stored in the "Archive" page. A new generation replaces the one for the same year.',
      archivePortfolioOk: 'Portfolio archive {year} generated and saved in Archive.',
      year: 'Year',
      month: 'Month',
      createPdf: 'Create PDF',
      archiveYear: 'Archive the year',
      archiveMonth: 'Archive the month',
      yearToArchive: 'Year to archive',
      downloadError: 'Download failed',
      activeBudgetsTitle: 'Active budgets',
      budgetsCount: 'active budget(s)',
      colCategory: 'Category',
      colType: 'Type',
      colSpent: 'Actual',
      colLimit: 'Target',
      colProgress: 'Progress',
      typeSaving: '🎯 Savings',
      typeExpense: '💸 Expense',
      chartIncomeVsExpense: 'Income vs Expenses',
      chartTopExpenses: 'Top expenses by category',
      chartMonthlyEvolution: 'Monthly evolution (last 12 months)',
      chartPortfolio: 'Portfolio distribution',
      archiveYearBtn: 'Archive the year',
      archiveYearTooltip: 'Generate a consolidated yearly PDF (transactions + budgets + portfolio)',
      confirmArchive: 'Generate the consolidated yearly report for {year}?\n\nIt will include all your transactions, budgets and portfolio for the year. The PDF will be available on the Archive page.',
      archiveSuccess: 'Yearly report {year} archived',
      archiveError: 'Archival failed',
      archiving: 'Archiving…',
      monthlyTitle: 'Archive a month\'s transactions as PDF',
      monthlySubtitle: 'Generate a monthly PDF of transactions. The file appears in the matching year of the Archive page grid.',
      monthlyYearLabel: 'Year',
      monthlyMonthLabel: 'Month',
      monthlyBtn: 'Create PDF',
      monthlyOk: 'Monthly PDF created ({year}-{month})',
      monthlyError: 'No transactions for this month or error',
      selectYearBody: 'Select the year to archive. A complete PDF report will be generated and kept in the Archive section. If an archive already exists for that year, you can choose to overwrite it.',
      archiveExists: 'Archive already exists',
      existsForYear: 'An archive already exists for the year',
      overwriteQuestion: 'Do you want to overwrite it and generate a new version?',
      keepOld: 'Keep the old one',
      overwriting: 'Overwriting…',
      overwriteBtn: 'Overwrite and regenerate',
      specialPaymentsNote: 'Exceptional payments (special, extraordinary) received on your held stocks — in addition to recurring dividends.',
      annualGrowth: 'Annual growth',
      cagrFull: 'CAGR (full years)',
      inNYears: 'In {n} years',
      perYear: 'per year',
      projectionNote: 'Projection based on your historical CAGR. Future returns may vary depending on company decisions (dividend hikes/cuts, buybacks), inflation and market moves. Use as an indicator, not a guarantee.',
      shareChartAria: 'Share my dividend chart',
      create12Tip: 'Creates the 12 PDF archives (January → December) for the selected year'
    },
    archive: {
      title: 'Archive',
      subtitle: 'Browse your past-year transactions (read only)',
      selectYear: 'Select a year',
      income: 'Income',
      expense: 'Expenses',
      balance: 'Net balance',
      transactionsTitle: 'Transactions',
      readOnly: 'Archived transactions are read only.',
      noTx: 'No transaction for this year.',
      emptyTitle: 'No archive yet',
      emptyDesc: 'Your previous-year transactions will appear here automatically.',
      gridTitle: '7-year archive grid',
      gridSubtitle: 'One column per year — one clickable monthly PDF per cell.',
      generate: 'Generate',
      download: 'Download',
      generating: 'Creating…',
      monthlyArchiveSuccess: 'Monthly PDF created ({year}-{month})',
      monthlyArchiveError: 'Could not generate this monthly PDF',
      yearlyPdfBadge: 'Yearly',
      monthlyPdfBadge: 'Monthly',
      savedFiles: 'Archived files',
      noFilesForYear: 'No archived PDF for {year}.',
      retentionNotice: 'It is strongly recommended to keep your data for at least 7 years before deletion (tax requirements).',
      deleteWarning: '⚠️ Are you sure you want to permanently delete the {year} archive?\n\nIt is STRONGLY recommended to keep your data for at least 7 years (tax compliance). This action cannot be undone.',
      deleteSuccess: 'Archive deleted',
      expiredTitle: 'Expired data (outside the 7-year window)',
      expiredDesc: 'These archives are older than the 7 most recent years. They will be deleted automatically after the indicated delay unless you decide to keep them.',
      noExpired: 'No expired archive.',
      autoDeleteIn: 'Auto-delete in {days} days',
      autoDeleteToday: 'Auto-delete today',
      keepLonger: 'Keep',
      keepSuccess: 'Auto-deletion cancelled',
      deleteNow: 'Delete now',
      monthShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      annualRowLabel: 'Yearly',
      removeDialogTitle: 'What do you want to do with this archive?',
      removeDialogDesc: 'Pick "Export" to download the PDF now, or "Mark as expired" to move it to the "Expired data" zone (auto-deletes in 30 days unless cancelled).',
      exportAction: 'Export (PDF)',
      expireAction: 'Mark as expired',
      cancel: 'Cancel',
      expireSuccess: 'Archive marked as expired — auto-delete in 30 days',
      expireError: 'Could not mark this archive',
      sendByEmailTooltip: 'Send by email',
      budgetGridTitle: 'Personal Budget — annual archives',
      budgetGridSubtitle: 'Complete annual snapshot of the Personal Budget (expenses, savings, cadences). 1 PDF per year. Source: Budget → Personal Budget.',
      annualSnapshot: 'Annual snapshot',
      portfolioSnapshot: 'Portfolio (annual snapshot)',
      incomeGridTitle: 'Asset Income — monthly archives',
      incomeGridSubtitle: 'Each cell creates a PDF of the month\'s expected income (source: Budget > Asset Income). Stored for 7 years, same as the Transactions grid.',
      monthCol: 'Month',
      emailDialogTitle: 'Send the archive by email',
      emailDialogDesc: 'The PDF will be sent as an attachment. Ideal to share with your accountant, associate or family.',
      recipientLabel: 'Recipient',
      exampleEmail: 'accountant@example.com',
      sending: 'Sending...',
      send: 'Send',
      invalidEmail: 'Invalid email address',
      sentTo: 'Archive sent to {email}',
      yearCol: 'Year',
      sendFailed: 'Send failed'
    },
    marketAnalysis: {
      loading: 'Loading analysis…',
      tipTitle: 'Analysis of your portfolio',
      tipBody: 'Auto-Gère analyzes the fundamentals (P/E, ROE, debt, margin) of each of your stocks and assigns a grade from A to F. You also see the analyst consensus. Click Summary for a detailed synthesis. Tip: the monthly report can be sent directly to your inbox.',
      analyzedSuffix: 'stock(s) analyzed from your portfolio.',
      sortLabel: 'Sort by:',
      sortNone: 'None',
      autogereGrade: 'Auto-Gère grade',
      sortBest: 'Best (A → F)',
      sortWorst: 'Worst (F → A)',
      optgroupSignal: 'Market Signal (Mid-Term)',
      sortBull: 'Bullish first',
      sortHold: 'Hold / Neutral first',
      sortBear: 'Bearish first',
      filterAll: 'All',
      buy: 'Buy',
      hold: 'Hold',
      sell: 'Sell',
      reco_hold2: 'Hold',
      reco_sell2: 'Sell',
      reco_strong_buy: 'Strong buy',
      reco_strong_sell: 'Strong sell',
      reco_underperform: 'Underperform',
      noneInCategory: 'No stock in this category for now:',
      sending: 'Sending…',
      sendReport: 'Send the monthly report',
      reportSent: 'Report sent to {r} ({n} stocks)',
      loadError: 'Could not load the portfolio analysis',
      progressiveLoading: 'Analysis in progress… {done}/{total} stocks analyzed — results appear as they come in.',
      legendTitle: 'Auto-Gère quality grades: A → F',
      legendIntro: 'Auto-Gère computes a score out of 100 by combining 4 equally weighted axes (25% each):',
      axisVal: 'Valuation — Price/earnings ratio (P/E). Lower = relatively cheaper.',
      axisRent: 'Profitability — Return on equity (ROE). Higher = profitable company.',
      axisDebt: 'Debt — Debt-to-equity ratio. Lower = healthier balance sheet.',
      axisMargin: 'Profit margin — Net margin. Higher = efficient company.',
      score: 'Score',
      gradeLabel_A: 'Excellent',
      gradeLabel_B: 'Good',
      gradeLabel_C: 'Average',
      gradeLabel_D: 'Weak',
      gradeLabel_E: 'Very weak',
      gradeLabel_F: 'Critical',
      gradeLabel_UNK: 'N/A',
      gradeDesc_A: 'Solid fundamentals on all axes. Reasonable valuation, high profitability, controlled debt, robust margin.',
      gradeDesc_B: 'Quality company with broadly positive fundamentals. One or two minor weaknesses without major risk.',
      gradeDesc_C: 'Mixed profile. Some indicators are solid, others weak. To be monitored depending on risk tolerance.',
      gradeDesc_D: 'Several warning signs (high valuation, low profitability, heavy debt or thin margins).',
      gradeDesc_E: 'Deteriorated financial profile. Significant risk to sustainability or future performance.',
      gradeDesc_F: 'Severely deteriorated fundamentals. High probability of losses or restructuring.',
      yahooNote: 'Data comes from Yahoo Finance. The grade does not constitute financial advice.',
      fundamentals: 'Fundamentals',
      hintPE: 'Price/Earnings (TTM). Lower = relatively cheaper.',
      hintFwdPE: 'Projected P/E for the coming year.',
      hintROE: 'Return on Equity: profitability of shareholders\' equity.',
      labelMargin: 'Profit margin',
      hintMargin: 'Net margin.',
      labelDebt: 'Debt/Eq.',
      hintDebt: 'Debt to Equity (in %). < 100 = healthy.',
      hintBeta: 'Volatility vs market. 1 = like the market.',
      labelYield: 'Div. yield',
      hintYield: 'Annual dividend / current price.',
      hintPayout: '% of earnings paid out as dividends.',
      recosTitle: 'Analyst recommendations',
      noRecos: 'Analyst recommendations: N/A',
      totalAnalysts: 'Total: {n} analysts',
      estimate: ' (estimate)',
      consensus: 'Consensus:',
      targetMean: 'Average target:',
      summary: 'Summary',
      chart: 'Chart',
      chartTitle: 'TradingView chart',
      tvNote: 'Data provided by TradingView. For information only — does not constitute financial advice.',
      signalsTitle: 'Auto-Gère Market Signals',
      signalsDisclaimer: 'Based on RSI · MACD · MA · MFI · OBV. Does not constitute financial advice.',
      computing: 'Computing technical indicators…',
      horizon_short_term: 'Short-Term',
      horizonSub_short_term: '1-2 wks',
      horizon_mid_term: 'Mid-Term',
      horizonSub_mid_term: '1-3 months',
      horizon_long_term: 'Long-Term',
      horizonSub_long_term: '6 months+',
      signal_strong_bull: 'Strong bullish signal',
      signal_bull: 'Bullish signal',
      signal_neutral: 'Neutral',
      signal_bear: 'Bearish signal',
      signal_strong_bear: 'Strong bearish signal'
    },
    globalAlerts: {
      button: 'General alert',
      buttonTip: 'Email alert on ALL your holdings: % change vs previous day close',
      title: 'General alert',
      scopePortfolio: 'Portfolio',
      scopeWatchlist: 'Watchlist',
      description: 'One rule applied to all your holdings: you receive an email as soon as any of them moves beyond your thresholds versus the previous day close.',
      enable: 'Enable general alert',
      upLabel: 'Gain of',
      downLabel: 'Drop of',
      optional: 'optional',
      antiSpamNote: 'One email per holding per day when a threshold is crossed. Holdings triggered at the same time are grouped into a single email. Checked every 15 minutes.',
      save: 'Save',
      saved: 'General alert saved',
      saveError: 'Error while saving',
    },
    budgetTable: {
      amountViewTip: 'Change the amount display period (yearly, monthly, every 2 weeks, weekly)',
      viewMonthly: 'Monthly (÷12)',
      viewBiweekly: 'Every 2 wks (÷26)',
      viewWeekly: 'Weekly (÷52)',
      viewShort_monthly: 'month',
      viewShort_biweekly: '2 wks',
      viewShort_weekly: 'week',
      periodTip: 'The entered amount will be converted to annual based on the chosen period',
      periodAnnual: 'Per year (×1)',
      periodMonthly: 'Per month (×12)',
      periodBiweekly: 'Every 2 wks (×26)',
      periodWeekly: 'Per week (×52)',
      emailAlert: 'Email alert',
      emailAlertOnTip: 'Email reminders enabled for this line — click to disable',
      emailAlertOffTip: 'Email reminders disabled for this line — click to enable',
      markDone: 'Mark as done',
      markUndone: 'Mark as not done',
      done: 'done',
      removeDate: 'Remove this date',
      addDateTip: 'Add a date manually (free entry)',
      addDate: 'Add date',
      presets: 'Presets:',
      weeklyTip: 'Generates 52 weekly payments (1 per week over the year) — ideal for weekly rent, groceries, pay-aligned subscriptions',
      weekly: 'Weekly (52×)',
      monthlyTip: 'Generates 12 monthly payments (January → December) — ideal for mortgage, rent, subscriptions',
      monthly: 'Monthly (12×)',
      quarterlyTip: 'Generates 4 quarterly payments (January, April, July, October) — ideal for municipal/school taxes',
      quarterly: 'Quarterly (4×)',
      semiTip: 'Generates 2 semi-annual payments (January + July) — ideal for home/auto insurance',
      semi: 'Semi-annual (2×)',
      annualTip: 'Generates 1 single annual payment at the pivot date — ideal for annual subscription, one-off property tax',
      annual: 'Annual (1×)',
      freqWeeklyLabel: 'weekly (52×/yr)',
      freqMonthlyLabel: 'monthly (Jan → Dec)',
      freqQuarterlyLabel: 'quarterly (4×/yr, Jan/Apr/Jul/Oct)',
      freqSemiLabel: 'semi-annual (2×/yr, Jan/Jul)',
      freqAnnualLabel: 'annual (1×/yr)',
      paymentsGenerated: '{n} {label} payments generated',
      payPeriodError: 'Could not save the pay period',
      noUnpaidForDate: 'No unpaid payment scheduled on {date}.',
      net: 'Net:',
      received: 'received',
      paid: 'paid',
      receivedPl: 'received',
      paidPl: 'paid',
      deficitTip: 'past-due month(s) not received — switches to expense',
      totalIncome: 'TOTAL INCOME',
      totalExpense: 'TOTAL EXPENSES',
      annualFixed: 'Annual fixed expenses',
      totalCap: 'TOTAL',
      netToTransfer: 'NET TO TRANSFER',
      surplus: 'SURPLUS',
      depAbbr: 'exp.',
      defAbbr: 'def.',
      perYourPeriod: 'Based on your period:',
      payPeriodTip: 'To change the pay period, use the green card at the very top of the table ("My pay period").',
      rentBehindTip: 'Past-due unreceived rents — switch to expense in the real Net',
      newAssetHeader: 'New asset (header) — e.g. "777 de la Noé", "Condo Verdun", "Duplex Ahuntsic"…',
      newAssetDesc: 'First create the header of your property. You can then add 💵 income sections (rents) AND/OR 💸 expense sections (taxes, mortgage, maintenance…) below it.',
      assetNamePh: 'Asset name...',
      createAsset: 'Create the asset',
      addSectionToAsset: 'Add a section to an asset (💵 income or 💸 expense)',
      parentAsset: 'Parent asset',
      yes: 'Yes',
      no: 'No',
      addLineIn: 'Add a line in',
      assetBadge: 'Asset',
      sections: 'section(s)',
      receivedCap: 'Received',
      paidCap: 'Paid',
      incomeBadge: 'Income',
      expenseBadge: 'Expense',
      netIncomeCap: 'NET INCOME',
      deficitCap: 'DEFICIT',
      deficitWord: 'deficit',
      realNetLabel: 'Real net (with deficit)',
      expectedAssetIncome: 'Expected asset income'
    },
    accountant: {
      title: 'Accounting sheet',
      subtitle: 'Tax summary ready to hand to your accountant',
      exportPdf: 'Export PDF',
      exportExcel: 'Export Excel',
      netResult: 'Net Result',
      monthCol: 'Month',
      incomeCol: 'Income',
      expenseCol: 'Expenses',
      resultCol: 'Result',
      categoryCol: 'Category',
      txCount: 'No. of transactions',
      loadError: 'Loading error',
      downloaded: 'Accounting sheet {fmt} downloaded',
      exportError: 'Export failed'
    },
    authFlow: {
      verifying: 'Verifying…',
      waitFew: 'Please wait a few seconds.',
      emailVerified: 'Email verified!',
      addressLabel: 'The address',
      nowActive: 'is now active.',
      canAccessAll: 'You can now access all Auto-Gère features and subscribe to a Premium plan.',
      login: 'Log in',
      linkExpired: 'Link expired',
      expiredBody: 'This activation link has expired (24 h max). Log in to receive a new one.',
      alreadyActivated: 'Account already activated',
      alreadyUsedBody: 'This link has already been used. Your account is activated and ready to use.',
      loginNormally: 'Log in normally to access Auto-Gère.',
      linkInvalid: 'Invalid link',
      invalidBody: 'This activation link is invalid or has already been used.',
      goToLogin: 'Go to login',
      pwdMin8: 'The password must be at least 8 characters.',
      pwdMismatch: 'The two passwords do not match.',
      pwdResetDone: 'Password reset',
      resetFailed: 'Reset failed',
      resetLinkInvalidBody: 'This reset link is incomplete or expired.',
      backToLogin: 'Back to login',
      pwdResetTitle: 'Password reset ✓',
      redirecting: 'Redirecting to the login page…',
      newPwd: 'New password',
      choosePwd: 'Choose a new secure password for your Auto-Gère account.',
      min8: 'At least 8 characters',
      confirmPwd: 'Confirm password',
      resetting: 'Resetting…',
      resetBtn: 'Reset password',
      activationRequired: 'ACTIVATION REQUIRED',
      verifyYourEmail: 'Verify your email address',
      hello: 'Hello',
      clickLinkSentTo: 'To activate your Auto-Gère account, click the link we just sent to:',
      dontSeeEmail: 'Don\'t see the email?',
      checkSpam: 'Check your spam / junk folder. If you still can\'t find it after a few minutes, click "Resend email" below to continue.',
      addContact: 'Add support@autogere.ca to your contacts to ensure you receive our messages.',
      resendSuccess: 'Activation email resent. Check your inbox and spam folder.',
      resendError: 'Send failed. Try again in a few minutes.',
      statusRefreshed: 'Status refreshed.',
      sendingNow: 'Sending…',
      resendEmail: 'Resend email',
      checkingBtn: 'Checking…',
      iClicked: 'I clicked — refresh',
      wrongAddress: 'Wrong address? Log out and create a new account.',
      logoutBtn: 'Log out',
      noCharge: 'No charge will be made until you have activated your account and chosen a plan.'
    },
    ideas: {
      scrDividend: 'Dividend',
      scrHighDiv: 'High dividends (undervalued large caps)',
      scrUndervaluedGrowth: 'Undervalued growth',
      scrDayGainers: 'Day gainers',
      scrDayLosers: 'Day losers',
      scrMostActive: 'Most active',
      scrGrowthTech: 'Growth tech',
      scrSmallCaps: 'Aggressive small caps',
      scrMostShorted: 'Most shorted',
      scrMorningstar: 'Morningstar 5 stars',
      scrLargestCap: 'Largest market caps',
      scr52Gainers: '52-wk gainers',
      scr52Losers: '52-wk losers',
      sortRelevance: 'Relevance',
      sortGrade: 'Grade (A → F)',
      sortDivDollar: 'Dividend $/yr (all)',
      sortDivYield: 'Yield %',
      sortDivM: 'Monthly div. (M) only',
      sortDivT: 'Quarterly div. (Q) only',
      sortDivS: 'Semi-annual div. (S) only',
      sortDivA: 'Annual div. (A) only',
      sortPriceAsc: 'Price ascending',
      sortSymbol: 'Symbol (A → Z)',
      sortCountry: 'Nationality (CA → US → EU → AS)',
      sortMarketCap: 'Market cap (large → small)',
      sortPriceDesc: 'Price descending (expensive → cheap)',
      sortPriceAsc2: 'Price ascending (cheap → expensive)',
      noResultsCur: 'No results in {cur} for this screener.',
      noResultsScreener: 'No results — Yahoo returned nothing for this screener.',
      searchUnavailable: 'Search unavailable — try again later',
      aiUnavailable: 'AI search unavailable — try again later',
      tipTitle: 'Stock & crypto search',
      tipDemoBody: 'Discover stocks and cryptos via real-time Yahoo Finance screeners or via our AI. Filters: high yield, growth, dividend, day gainers, etc.',
      premiumFeature: 'Premium feature',
      premiumBody: 'Dynamic stock & crypto search (Yahoo Screener + AI) is reserved for Premium. In demo mode this feature is disabled.',
      goPremium: 'Go Premium',
      tipSearchBody: 'Pick a Yahoo screener (real-time results) or type a free search — the AI will suggest matching stocks or cryptos. Add your favorites to the Basket.',
      stocks: 'Stocks',
      cryptos: 'Cryptos',
      allCurrencies: 'All',
      aiPlaceholderCrypto: "Free AI search: 'high-potential DeFi tokens', 'profitable PoS cryptos'…",
      aiPlaceholderStocks: "Free AI search: 'Canadian pipelines', 'monthly high-dividend REIT'…",
      searchBtn: 'Search',
      screenersCrypto: 'Yahoo Crypto screeners (live):',
      screenersStocks: 'Yahoo Stock screeners (live):',
      source: 'source',
      sortBy: 'Sort by',
      added: 'Added',
      basketBtn: 'Basket',
      annualDiv: 'Annual div.',
      perShare: '/share',
      payment: 'Payment',
      yield: 'Yield',
      noneOption: '(none)',
      emptyStateStocks: 'Pick a stock screener or type a free search to get started.',
      emptyStateCrypto: 'Pick a crypto screener or type a free search to get started.'
    },
    basket: {
      clearConfirm: 'Completely empty the basket?',
      cleared: 'Basket emptied',
      premiumTitle: 'Premium Basket',
      premiumBody: 'The basket lets you collect ideas before adding them to your portfolio. Reserved for Premium users.',
      tipTitle: 'Your idea basket',
      tipBody: 'The securities you added from the Ideas tab appear here. Click Add to portfolio to transfer a security to your portfolio (quantity and price to enter). The basket is saved locally in your browser.',
      empty: 'Your basket is empty.',
      emptyHint: 'Go to the Ideas tab to find securities to add.',
      addToPortfolio: 'Add to portfolio',
      pending: 'pending item',
      pendingPl: 'pending items'
    },
    tools: {
      converterTitle: 'Currency converter',
      amountLabel: 'Amount to convert',
      invert: 'Swap',
      result: 'Result',
      rateInEffect: 'Current rate:',
      tipTitle: 'Calculation tools',
      tipBody: 'This space gathers practical utilities for your financial decisions. The currency converter uses real-time rates loaded at login. Other tools (compound dividend calculator, withdrawal simulator, etc.) will be added here progressively.'
    },
    pwa: {
      installed: 'App installed',
      installedTip: 'You are using Auto-Gère from the installed app',
      installBtn: 'Install the app',
      installTip: 'Install Auto-Gère as an app on your computer (desktop shortcut + dedicated window)',
      previewBanner1: 'You are on the TEST environment. Go to',
      previewBanner2: 'for the real application.'
    }
  },
  es: {
    confirmDelete: {
      title: 'Confirmar eliminación',
      description: 'Esta acción no se puede deshacer.',
      confirm: 'Eliminar',
      cancel: 'Cancelar'
    },
    // Navigation
    nav: {
      login: 'Iniciar sesión',
      signup: 'Crear mi cuenta',
      dashboard: 'Panel',
      transactions: 'Estado de operaciones',
      budget: 'Presupuestos',
      portfolio: 'Cartera',
      market: 'Mercado',
      reports: 'Informes',
      archive: 'Archivo',
      settings: 'Ajustes',
      logout: 'Cerrar sesión'
    },
    // Landing Page
    landing: {
      title: 'Domina tus finanzas e inversiones en un solo lugar',
      subtitle: 'Una plataforma completa para gestionar tu presupuesto, seguir gastos y optimizar tu cartera de inversiones.',
      getStarted: 'Comenzar gratis',
      tryDemo: '🎬 Probar la demo — sin registro',
      demoLoading: 'Abriendo la demo…',
      demoSubtext: 'Explora la aplicación completa con datos de ejemplo, sin crear una cuenta.',
      demoBannerText: 'Modo demo — datos de ejemplo compartidos, reiniciados cada día.',
      demoBannerCta: 'Crear mi cuenta gratis',
      trackingOnlyTitle: 'Plataforma de seguimiento únicamente',
      trackingOnlyBody: 'Auto-Gère no ejecuta ninguna transacción financiera: sin compra ni venta de valores, sin conexión con sus cuentas bancarias o de corretaje. Usted ingresa sus datos, la aplicación los organiza y les da seguimiento — sus fondos siempre permanecen en su institución.',
      launchCounter: 'Oferta de lanzamiento: ya {count} suscriptores — ¡solo quedan {left} plazas al precio reducido, congelado de por vida!',
      launchPriceHero: 'Precio de lanzamiento: {monthly} $/mes o {yearly} $/año — ¡congelado de por vida!',
      midCtaTitle: '¿Convencido? Su cuenta gratuita está lista en 30 segundos.',
      pricingBadge: 'Precios',
      pricingTitle: 'Un precio simple, sin sorpresas',
      pricingSubtitle: 'Comience gratis y pase a Premium cuando esté listo. Cancelable en cualquier momento.',
      pricingFreeTitle: 'Gratis',
      pricingFreeSub: 'Sin tarjeta de crédito',
      pricingFree1: 'Panel y presupuesto completos',
      pricingFree2: '2 activos en cartera',
      pricingFree3: '1 importación de extracto (CSV/Excel)',
      pricingFreeCta: 'Crear mi cuenta gratis',
      pricingLaunchBadge: 'Oferta de lanzamiento — primeros 100',
      pricingMonthlyTitle: 'Premium mensual',
      pricingPerMonth: '/mes',
      pricingPerYear: '/año',
      pricingFrozen: 'Precio congelado de por vida mientras siga suscrito',
      pricingPrem1: 'Activos e importaciones ilimitados',
      pricingPrem2: 'Seguimiento completo de dividendos (calendario, historial, totales)',
      pricingPrem3: 'Alertas por correo e informes mensuales PDF',
      pricingPrem4: 'Mercados en tiempo real y multidivisa',
      pricingPremiumCta: 'Ser miembro fundador',
      pricingYearlyTitle: 'Premium anual',
      pricingYearlySave: '2 meses gratis frente al mensual',
      pricingNote: 'Precios en dólares canadienses (CAD). Pago seguro con PayPal. Cancelación en un clic, sin cargos ocultos.',
      launchPriceHeroSub: 'Reservado a los 100 primeros suscriptores (precio regular: {standard} $/mes después). Prueba gratuita incluida.',
      learnMore: 'Más información',
      features: 'Funciones potentes para tu éxito financiero',
      feature1Title: 'Seguimiento de gastos',
      feature1Desc: 'Rastrea todas tus transacciones y categoriza gastos automáticamente.',
      feature2Title: 'Gestión de presupuesto',
      feature2Desc: 'Crea presupuestos personalizados y recibe alertas antes de excederlos.',
      feature3Title: 'Cartera de inversión',
      feature3Desc: 'Gestiona tus acciones y criptomonedas con precios en tiempo real.',
      feature4Title: 'Alertas inteligentes',
      feature4Desc: 'Recibe notificaciones para eventos financieros importantes.',
      feature5Title: 'Seguridad máxima',
      feature5Desc: 'Tus datos están encriptados y protegidos según estándares bancarios.',
      feature6Title: 'Informes detallados',
      feature6Desc: 'Visualiza tus finanzas con gráficos e informes completos.',
      cta: '¿Listo para tomar el control de tus finanzas?',
      ctaSubtitle: 'Comienza gratis hoy. No se requiere tarjeta de crédito.',
      ctaButton: 'Crear mi cuenta gratis',
      footer: '© 2026 Auto-Gère. Todos los derechos reservados.',
      // === Landing page v2 (rediseño 2026) ===
      heroBadge: 'Novedades 2026 · Importación auto · Multidivisa · Presupuesto Excel',
      heroTitleMain: 'Domina tus finanzas e inversiones',
      heroTitleAccent: 'en un solo lugar',
      heroSubtitle: 'Seguimiento de gastos, presupuesto estilo Excel, cartera multidivisa e informes PDF — importe sus extractos (CSV/Excel) en un clic, sin conexión bancaria.',
      reassureEncryption: 'Cifrado bancario',
      reassureEncryptionSub: 'JWT + 2FA TOTP',
      reassureRealtime: 'Datos en tiempo real',
      reassureRealtimeSub: 'Yahoo Finance · CoinGecko',
      reassureAlerts: 'Alertas por email',
      reassureAlertsSub: 'Watchlist y umbrales',
      reassureFree: 'Gratis para empezar',
      reassureFreeSub: '1 carga de extracto · 2 activos',
      slidesBadge: 'Visita guiada',
      slidesTitle: 'Descubra Auto-Gère pantalla por pantalla',
      slidesSubtitle: 'Una vista real de cada pestaña — panel, presupuesto, cartera, mercado y más.',
      slide_dashboard: 'Panel — todas sus finanzas de un vistazo',
      slide_transactions: 'Transacciones — ingresos y gastos clasificados',
      slide_budget: 'Presupuestos — fechas de pago, recordatorios y progreso en vivo',
      slide_portfolio: 'Cartera — acciones y cripto en tiempo real, multidivisa',
      slide_market: 'Mercado — vigilancia, alertas de precio y capitalización',
      slide_reports: 'Informes — exportaciones PDF/Excel a medida',
      slide_archive: 'Archivo — 7 años de historial PDF, envío por correo',
      slide_settings: 'Configuración — seguridad 2FA y suscripción flexible',
      videoBadge: 'Demo en video',
      videoTitle: 'Descubra Auto-Gère en video',
      videoSubtitle: 'Un recorrido guiado por el software: panel, presupuesto, cartera, informes — vea todo lo que Auto-Gère puede hacer por sus finanzas.',
      videoTabFull: 'Presentación completa',
      videoTabTransactions: 'Transacciones',
      videoPlayCta: 'Reproducir el video',
      videoNoSound: 'Demostración visual · sin narración',
      sectionTitle: 'Todas las funciones, sin concesiones',
      sectionSubtitle: 'Descubre lo que hace único a Auto-Gère: automatización inteligente, multidivisa nativo y herramientas dignas de una hoja de cálculo — todo en una interfaz fluida.',
      badgeNew: 'Nuevo',
      featAiImportTitle: 'Importación de extractos bancarios',
      featAiImportDesc: 'Arrastra tu extracto en PDF, CSV, OFX, QFX o incluso una foto: Auto-Gère extrae automáticamente tus transacciones, detecta la divisa y la categoría. El documento original nunca se guarda en nuestros servidores.',
      featBudgetExcelTitle: 'Presupuesto estilo Excel detallado',
      featBudgetExcelDesc: 'Vista de hoja con columnas "Auto-pagado" (verde / rojo), fechas de pago por nómina, cálculos dinámicos y periodos personalizables. La comodidad de Excel, la fluidez de la web.',
      featMultiCurrencyTitle: 'Cartera multidivisa',
      featMultiCurrencyDesc: 'Sigue tus acciones de EE. UU., Canadá (.TO / .UN), Europa e India (.NS) con su bandera nacional y su divisa nativa (USD, CAD, EUR, INR…). Conversión automática al dólar canadiense (divisa principal por defecto).',
      featDashboardTitle: 'Panel enriquecido',
      featDashboardDesc: 'Tres gráficos circulares reordenables (Total, EE. UU., Canadá), seguimiento mensual de dividendos, beneficio no realizado en tiempo real y resumen "Importe a apartar por nómina".',
      featDividendsTitle: 'Seguimiento de dividendos',
      featDividendsDesc: 'Calendario de próximas fechas ex-dividendo, frecuencia visual (Mensual / Trimestral / Semestral / Anual), ajustes manuales y total anual por posición.',
      featAnalysisTitle: 'Análisis de cartera con notas A→F',
      featAnalysisDesc: 'Para cada acción: puntuación de calidad Auto-Gère de A a F basada en 4 ejes (P/E, ROE, deuda, margen), consenso de analistas (Comprar / Mantener / Vender), resumen sintético. Para valores sin cobertura, se genera automáticamente un análisis en profundidad.',
      featToolsTitle: 'Herramientas financieras integradas',
      featToolsDesc: 'Conversor de divisas en tiempo real (CAD · USD · EUR · GBP · CHF · JPY · INR) con tasa diaria, calculadoras inteligentes y más por venir. Disponible directamente en Mercado → Herramientas.',
      featReportsTitle: 'Informes y archivo anual',
      featReportsDesc: 'Exporta tus transacciones, presupuestos y cartera en PDF / Excel en cualquier momento. Recibe un informe mensual de rendimiento por email. Archiva tus años pasados con un clic.',
      portfolioBadge: 'Bolsas mundiales',
      portfolioTitlePart1: 'Tus acciones,',
      portfolioTitleAccent: 'su divisa',
      portfolioTitlePart2: ', tu visión global.',
      portfolioBullet1Strong: '200+ mercados',
      portfolioBullet1Rest: ' soportados: NYSE, NASDAQ, TSX, Euronext, LSE, NSE, Tokio…',
      portfolioBullet2Strong: 'Banderas nacionales',
      portfolioBullet2Rest: ' para reconocer de un vistazo el origen de cada valor',
      portfolioBullet3Strong: 'Ordenar por columna',
      portfolioBullet3Rest: ': precio, valor, ganancia, dividendo — sube o baja con un clic',
      portfolioBullet4Strong: 'Dividendos automáticos',
      portfolioBullet4Rest: ': próxima fecha, frecuencia, total mensual acumulado',
      portfolioCaption: 'Precio en divisa nativa · Valor convertido a CAD',
      ctaTitleNew: '¿Listo para retomar el control de tus finanzas?',
      ctaSubtitleNew: 'Empieza gratis en menos de un minuto. No se necesita tarjeta — pasa a Premium solo cuando estés convencido.',
      ctaButtonNew: 'Crear mi cuenta gratis',
      ctaTrust: '1 carga de extracto · 2 activos · 0 $ para empezar',
      footerFaq: 'FAQ',
      footerRefund: 'Política de reembolso',
      footerPrivacy: 'Política de privacidad',
      footerContact: 'Contacto'
    },
    // Auth Page
    auth: {
      welcome: '¡Bienvenido de nuevo!',
      emailPlaceholder: 'tu@ejemplo.com',
      createAccount: 'Crear cuenta',
      loginSubtitle: 'Inicia sesión para acceder a tu panel',
      registerSubtitle: 'Comienza a gestionar tus finanzas ahora',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      loginButton: 'Iniciar sesión',
      registerButton: 'Crear cuenta',
      legalConsentLabel: 'He leído y acepto',
      legalConsentLink: 'las condiciones legales',
      legalConsentRequired: 'Debes aceptar las condiciones legales para crear una cuenta.',
      privacyConsentLabel: 'Consiento la recopilación y el uso de mi información personal como se describe en la',
      privacyConsentLink: 'Política de privacidad',
      privacyConsentLaw: 'Ley 25, Quebec',
      privacyConsentRequired: 'Debes consentir la Política de privacidad (Ley 25) para crear una cuenta.',
      legalConsentSale: 'He leído y acepto las condiciones de venta (CGV)',
      legalConsentSaleRequired: 'Debes aceptar las CGV para suscribirte.',
      loading: 'Cargando...',
      noAccount: '¿No tienes cuenta? Registrarse',
      hasAccount: '¿Ya tienes cuenta? Iniciar sesión',
      loginSuccess: '¡Inicio de sesión exitoso!',
      registerSuccess: '¡Cuenta creada con éxito! Por favor, inicia sesión.',
      heroTitle: 'Tus finanzas, seguras',
      heroSubtitle: 'Cifrado bancario y autenticación de dos factores',
      twoFactorTitle: 'Verificación 2FA',
      twoFactorSubtitle: 'Introduce el código de 6 dígitos de tu aplicación de autenticación',
      twoFactorCodeLabel: 'Código 2FA',
      twoFactorHint: 'También puedes usar un código de recuperación',
      twoFactorVerify: 'Verificar',
      twoFactorVerifying: 'Verificando...',
      twoFactorBack: 'Volver al inicio de sesión',
      twoFactorPrompt: 'Introduce tu código de autenticación de dos factores',
      error: 'Ocurrió un error',
      trustBannerTitle: 'Conexión cifrada — estándar bancario',
      trustBannerDesc: 'Tu sesión está protegida con una cookie httpOnly, invisible para scripts y extensiones de terceros — protección conforme a las grandes instituciones financieras.',
      cookieHttpOnly: 'cookie httpOnly',
      activationEmailSent: 'Correo de activación enviado a:',
      activationSpamWarning: 'Si no lo ves:',
      activationSpamBody: 'Revisa tu carpeta de spam / correo no deseado. Si no llega después de unos minutos, haz clic en «Reenviar correo» para continuar.',
      resendActivation: 'Reenviar correo',
      forgotPassword: '¿Olvidaste tu contraseña?',
      forgotPasswordTitle: 'Restablecer contraseña',
      forgotPasswordDesc: 'Te enviaremos un enlace para crear una nueva contraseña.',
      forgotEmailLabel: 'Dirección de correo',
      forgotSubmit: 'Enviar enlace',
      forgotSuccess: 'Si existe una cuenta, se ha enviado un correo de restablecimiento.',
      forgotError: 'No se pudo enviar el correo de restablecimiento.',
      forgotRateLimit: 'Límite: 3 intentos por hora y por dirección de correo.',
      forgotSentTitle: '📨 Correo enviado',
      forgotSentBody: 'Revisa tu bandeja de entrada (y la carpeta spam / correo no deseado). El enlace caduca en 1 hora.',
      cancel: 'Cancelar'
    },
    dashboard: {
      title: 'Panel',
      welcome: 'Bienvenido',
      balance: 'Balance mensual',
      income: 'Ingresos',
      expenses: 'Gastos',
      portfolioValue: 'Cartera',
      assetIncome: 'Ingreso de activos',
      alerts: 'Alertas',
      recentTransactions: 'Transacciones recientes',
      noTransactions: 'Sin transacciones',
      subscription: 'Suscripción',
      currentPlan: 'Plan actual',
      upgradeToPremium: 'Actualiza a Premium para desbloquear todas las funciones avanzadas.',
      upgradeButton: 'Actualizar a Premium',
      loading: 'Cargando...',
      totalIncome: 'Ingreso total',
      totalSpent: 'Gasto total',
      txDistribution: 'Distribución de operaciones',
      portfolioDistribution: 'Distribución de la cartera',
      // v1.03.02 - i18n audit (Dashboard.jsx)
      amountPerPay: 'Monto a transferir por sueldo',
      accordingToPeriod: 'Según tu período',
      projectedAssetIncome: 'Ingreso previsto de activos',
      netBalance: 'Saldo neto (ingresos − gastos)',
      rentalDeficit: 'Déficit de alquiler detectado',
      distributionByAccount: 'Distribución por cuenta',
      mergeTables: 'Combinar tablas',
      checkingAccount: 'Cuenta corriente',
      account: 'Cuenta',
      income: 'Ingresos',
      expenses: 'Gastos',
      netBalanceShort: 'Saldo neto',
      txCountShort: '# TX',
      welcomeTitle: '¡Bienvenido a Auto-Gère!',
      welcomeBody: 'Tu panel agrupa todas tus finanzas. Haz clic en Actualizar arriba a la derecha para sincronizar los precios en tiempo real, y marca Combinar tablas en Distribución por cuenta para ver un total global.',
      rentalDeficitBody: 'Uno o más pagos previstos en Ingreso de activos aún no se han recibido (vencidos). Este monto se resta del ingreso neto real — como un gasto.',
      deficitGoTo: 'Ver en Ingreso de activos',
      dismissAlert: 'Ocultar esta advertencia',
      payPeriodWeekly: 'Semanal (×52)',
      payPeriodBiweekly: 'Quincenal (×26)',
      payPeriodSemimonthly: 'Bimensual (×24)',
      payPeriodMonthly: 'Mensual (×12)',
      payLabel: 'nóminas',
      noAsset: 'Sin activos',
      budgetAlert: 'Has alcanzado el 90 % de tu presupuesto para {category}',
      savingGoalReached: '¡Objetivo de ahorro alcanzado para {category}!',
      clearAllAlerts: 'Borrar todo',
      confirmClearAlerts: '¿Eliminar todas las alertas?',
      refresh: 'Actualizar',
      typeCol: 'Tipo',
      totalRow: 'Total',
      moveUp: 'Mover hacia arriba',
      moveDown: 'Mover hacia abajo',
      noUsStocks: 'Ninguna acción de EE. UU.'
    },
    transactions: {
      title: 'Estado de operaciones',
      subtitle: 'Gestiona tus ingresos y gastos',
      // v1.03.07 - Transactions + AccountTabs
      checkingAccount: 'Cuenta corriente',
      addCard: 'Añadir una tarjeta',
      addCardBtn: '+ Añadir una tarjeta',
      editCard: 'Editar tarjeta',
      addCreditCard: 'Añadir tarjeta de crédito',
      allTab: 'Todas',
      uncategorized: 'Sin categorizar',
      allPeriods: 'Todos los períodos',
      importBtn: 'Importar',
      exportBtn: 'Exportar',
      resetBtn: 'Restablecer',
      selectedCard: 'Tarjeta seleccionada',
      addTransaction: 'Agregar transacción',
      newTransaction: 'Nueva transacción',
      type: 'Tipo',
      income: 'Ingreso',
      expense: 'Gasto',
      saving: 'Ahorro',
      reimbursement: 'Reembolso',
      amount: 'Monto',
      category: 'Categoría',
      categoryPlaceholder: 'Ej: Comida, Salario, Transporte',
      description: 'Descripción',
      add: 'Agregar',
      date: 'Fecha',
      noTransactions: 'No hay transacciones registradas',
      addFirstTransaction: 'Agregar tu primera transacción',
      success: 'Transacción agregada con éxito',
      error: 'Error al agregar la transacción',
      scanReceipt: 'Escanear factura',
      scanInProgress: 'Analizando…',
      scanSuccess: '¡Factura analizada! Verifica los campos antes de guardar.',
      scanError: 'No se pudo escanear esta imagen',
      scanInvalidType: 'Formato no soportado (JPEG, PNG o WEBP únicamente)',
      scanTooLarge: 'Imagen demasiado grande (máx 8 MB)',
      raz: 'Reset',
      razTooltip: 'Reiniciar todas las transacciones',
      razConfirm: '⚠️ ATENCIÓN: Esta acción eliminará permanentemente TODAS tus transacciones y restablecerá tus presupuestos a cero.\n\n¿Seguro que deseas continuar?',
      razSuccess: 'Todas las transacciones se han eliminado',
      razError: 'Error al reiniciar',
      cardName: 'Nombre de la tarjeta',
      currencyLabel: 'Divisa',
      creditLimit: 'Límite de crédito',
      creditLimitTip: 'Introduce el límite tal como aparece en tu extracto — Auto-Gère convertirá automáticamente para las comparaciones multidivisa.',
      cycleDay: 'Día de fin de ciclo (1-31)',
      cycleDayTip: 'El saldo mostrado corresponde a las transacciones del ciclo en curso.',
      updateBtn: 'Actualizar',
      deleteCardTitle: '¿Eliminar esta tarjeta?',
      deleteCardBody: 'Las transacciones asociadas se reasignarán a la cuenta corriente, no se eliminarán.',
      nameRequired: 'El nombre es obligatorio',
      cycleDayRange: 'Día de ciclo entre 1 y 31',
      cardUpdated: 'Tarjeta actualizada',
      cardAdded: 'Tarjeta añadida',
      cardDeleted: 'Tarjeta eliminada — transacciones reasignadas a la cuenta corriente',
      cardDeleteError: 'Error al eliminar',
      useBtn: 'Usar',
      balanceDue: 'Saldo a pagar',
      actionsCol: 'Acciones',
      introTitle: 'Tus transacciones, de un vistazo',
      introBody: 'Haz clic en Importar para subir un extracto PDF / CSV / OFX (el escáner IA detecta las transacciones automáticamente). Usa el filtro Sin categorizar + el selector de mes para ponerte al día rápidamente. Cuando cambias una categoría manualmente, Auto-Gère propone aplicar la misma categoría a los duplicados.',
      deleteTxConfirm: '¿Eliminar esta transacción?',
      inCur: 'en'
    },
    budget: {
      title: 'Presupuestos',
      subtitle: 'Define y rastrea tus presupuestos',
      // v1.03.07 - Budget.jsx
      tabPersonal: 'Presupuesto personal',
      tabAssetIncome: 'Ingreso de activos',
      tabSavings: 'Ahorro / Gasto',
      tabEmailAlerts: 'Alertas por correo',
      rolloverBtn: 'Pasar al año siguiente',
      rolloverTitle: 'Pasar el Presupuesto al año siguiente',
      rolloverSubtitle: 'Archiva el año que termina y reinicia el progreso — su estructura (secciones, líneas, montos) se conserva.',
      rolloverYearLabel: 'Año a cerrar',
      rolloverStep1: 'Se crea un PDF «foto» del Presupuesto personal {year} y se guarda en Archivo',
      rolloverStep2: 'Todas las fechas de pago se desplazan de {year} a {next}',
      rolloverStep3: 'Las casillas «hecho» se desmarcan (progreso a 0%) — secciones, líneas y montos conservados',
      rolloverWarning: 'Acción irreversible (excepto el PDF archivado). Se procesan las pestañas Presupuesto personal Y Ingreso de Activos.',
      rolloverConfirmLabel: 'Para confirmar, escriba {year} abajo:',
      rolloverGo: 'Pasar al año siguiente',
      rolloverRunning: 'Procesando…',
      rolloverSuccess: '¡Presupuesto {year} archivado — bienvenido a {next}! Progreso reiniciado.',
      rolloverError: 'Error al pasar al año siguiente.',
      payPeriodTitle: 'Mi período de pago',
      payPeriodSub: 'Cambia la base de cálculo de la tabla y del monto a transferir.',
      emailReminderTitle: 'Recordatorio por correo · próximos pagos',
      emailReminderSub: 'Un único correo que agrupa todos los pagos (auto o manuales) del mismo día — enviado a las 9 a.m. hora del Este.',
      testEmailBtn: 'Probar envío',
      newSection: 'Nueva sección (ej : casa, auto, seguros…)',
      calcAsIncome: 'Calculada como ingreso',
      calcAsExpense: 'Calculada como gasto',
      sectionNamePlaceholder: 'Nombre de sección…',
      addSection: 'Añadir',
      colDescription: 'Descripción',
      colAutoPaid: 'Auto pagado',
      colPaymentDates: 'Fechas de pago',
      colAnnual: 'Año',
      colProgressionLive: 'Progreso en vivo',
      colActions: 'Acciones',
      yes: 'Sí',
      no: 'No',
      reminderDays1: '1 día antes',
      reminderDays2: '2 días antes',
      reminderDays3: '3 días antes',
      reminderDays7: '7 días antes',
      reminderNever: 'Nunca',
      reminderDisabled: 'Desactivado (sin correo)',
      reminderSameDay: 'El mismo día',
      total: 'Total',
      expense: 'Gasto',
      income: 'Ingreso',
      tooltipIncomeSection: 'Sección contada como INGRESO',
      tooltipExpenseSection: 'Sección contada como GASTO',
      addBudget: 'Crear presupuesto',
      newBudget: 'Nuevo presupuesto',
      category: 'Categoría',
      limit: 'Límite',
      period: 'Período',
      monthly: 'Mensual',
      spent: 'Gastado',
      remaining: 'Restante',
      noBudgets: 'No hay presupuestos definidos',
      createFirstBudget: 'Crear tu primer presupuesto',
      success: 'Presupuesto creado con éxito',
      error: 'Error al crear el presupuesto',
      tipDetailTitle: 'Presupuesto en porcentaje',
      tipDetailBody: 'Defina el porcentaje de sus ingresos mensuales que desea asignar a cada categoría (vivienda, alimentación, ahorro…). Auto-Gère calcula automáticamente los importes y le alerta cuando los supera.',
      tipIncomeTitle: 'Ingresos de Activos',
      tipIncomeBody: 'Dedicado a sus activos inmobiliarios personales (apartamentos en alquiler, edificios multivivienda…). Anote aquí los ingresos (alquileres cobrados) Y los gastos incurridos (impuestos municipales, mantenimiento, hipoteca, seguros…). El saldo neto se muestra al pie de la tabla para cada activo.'
    },
    portfolio: {
      title: 'Cartera',
      subtitle: 'Gestiona tus inversiones',
      addAsset: 'Agregar activo',
      newAsset: 'Nuevo activo',
      assetType: 'Tipo de activo',
      nextDividendDate: 'Próximo dividendo',
      noDividend: '—',
      stock: 'Acción',
      crypto: 'Criptomoneda',
      symbol: 'Símbolo',
      symbolPlaceholder: 'Ej: AAPL, bitcoin',
      quantity: 'Cantidad',
      targetQty: 'Objetivo',
      targetQtyOptional: 'opcional — número objetivo (ej.: 100)',
      sortByTargetQty: 'Ordenar por objetivo de compra',
      purchasePrice: 'Precio de compra',
      totalReceived: 'Total recibido ({year})',
      grandTotalReceived: 'Total de dividendos recibidos en {year}',
      importHistory: 'Importar historial',
      importHistoryTip: 'Importa los dividendos ya pagados desde la fecha de compra de cada activo (estimación: pago/acción × cantidad actual)',
      importHistoryLoading: 'Importando…',
      importHistoryConfirm: '¿Importar los dividendos pagados desde la fecha de compra de cada activo? La estimación usa la cantidad actual. Puede deshacer la importación en cualquier momento.',
      importHistoryDone: '{n} pagos importados al historial',
      undoImport: 'Deshacer importación',
      undoImportTip: 'Elimina todos los pagos importados automáticamente (los clics manuales «Dividendo recibido» se conservan)',
      undoImportConfirm: '¿Eliminar todos los pagos importados del historial? Los clics manuales «Dividendo recibido» se conservarán.',
      undoImportDone: '{n} pagos importados eliminados',
      yieldOnCost: 'RSC',
      currentPrice: 'Precio actual',
      totalValue: 'Valor total',
      gainLoss: 'Ganancia/Pérdida',
      noAssets: 'No hay activos en tu cartera',
      addFirstAsset: 'Agregar tu primer activo',
      delete: 'Eliminar',
      success: 'Activo agregado con éxito',
      deleteSuccess: 'Activo eliminado',
      error: 'Error al agregar el activo',
      dividendYield: 'Rendimiento de dividendo anual',
      dividendYieldPlaceholder: 'Ej: 3.5 (dejar vacío si no hay dividendo)',
      monthlyDividend: 'Dividendo mensual',
      annualDividend: 'Anual',
      unrealizedProfits: 'Beneficios no realizados',
      slowGrowth: 'Variación lenta (< 5 %)',
      totalMovement: 'Total ganancias + pérdidas',
      assetsShort: 'activo(s)',
      gains: 'Ganancias',
      losses: 'Pérdidas',
      netLatent: 'neto latente',
      vsSp500: 'Rendimiento vs S&P 500',
      vsSp500Empty: 'Datos históricos insuficientes. Añade activos a la cartera.',
      vsSp500Note: 'Ponderado por el valor de cada activo. Base 100 al inicio del período.',
      // v1.03.02 - i18n audit (Portfolio.jsx)
      stocksBought: 'Acciones compradas',
      titlesTotal: 'títulos en total',
      cryptoHeld: 'Cripto en cartera',
      unitsTotal: 'unidades en total',
      totalPurchase: 'Total precio de compra',
      capitalInvested: 'capital invertido',
      currentValue: 'Valor actual',
      freqMonthlyShort: 'Mensual (M)',
      freqQuarterlyShort: 'Trimestral (T)',
      freqSemiAnnualShort: 'Semestral (S)',
      freqAnnualShort: 'Anual (A)',
      dividendConfirm: 'Confirmación de dividendo',
      dividendReceived: '¿recibido?',
      globalDividendSharing: 'Reparto global de dividendos',
      totalCap: 'TOTAL',
      refresh: 'Actualizar',
      cancel: 'Cancelar',
      save: 'Guardar',
      close: 'Cerrar',
      disable: 'Desactivar',
      sharingBreakdownTitle: 'Reparto detallado de dividendos mensuales',
      titleCol: 'Símbolo',
      grossMonthly: 'Mensual bruto',
      monthlyTotal: 'Total mensual',
      annualTotal: 'Total anual',
      buildYourPortfolio: 'Construye tu cartera',
      forceUpdatePrices: 'Forzar la actualización de precios y dividendos desde Yahoo Finance',
      manageCoOwnership: 'Gestiona copropiedades y reparto de dividendos con tus socios',
      yourPortfolio: 'Tu cartera',
      outperforms: 'Supera al índice',
      underperforms: 'Por debajo del índice',
      distribution: 'Distribución de la cartera',
      totalValueLabel: 'Valor total',
      tabAll: 'Todos',
      tabStocks: 'Acciones',
      tabCrypto: 'Cripto',
      tabDividends: 'Dividendos',
      noDividendAssets: 'Sin activos con dividendo. Establezca un rendimiento > 0 al crear.',
      colYield: 'Rendimiento',
      colDivMonthly: 'Div. mensual',
      colDivAnnual: 'Div. anual',
      actions: 'Acciones',
      alsoInWatchlist: 'También seguido en Mercado — abre la watchlist para completar su ficha',
      inWatchlistShort: 'Mercado',
      toComplete: 'A completar',
      completeFieldsTooltip: 'Añadido desde Mercado — introduce la cantidad y el precio de compra',
      refreshing: 'Actualizando…',
      sharingBtn: 'Reparto',
      yieldDetected: 'Rendimiento {dy}% detectado para {symbol}',
      noDividendFor: '{symbol}: sin dividendo',
      specialDividendToast: '🎁 {symbol}: dividendo especial de {amount}$ detectado el {date}. No incluido en el cálculo anual recurrente.',
      yieldFetchError: 'No se pudo obtener el rendimiento',
      specialDividendDetected: 'Dividendo especial detectado',
      specialDividendNote: 'Estos pagos excepcionales no se incluyen en el cálculo del dividendo anual recurrente mostrado abajo.',
      dividendFrequency: 'Frecuencia del dividendo',
      autoDetecting: 'Detección automática…',
      detectedLabel: 'Detectado',
      fetchAuto: 'Obtener auto',
      freqAutoOption: 'Automático (según Yahoo Finance)',
      freqMonthly: 'Mensual',
      freqQuarterly: 'Trimestral',
      freqSemiAnnual: 'Semestral',
      freqAnnual: 'Anual',
      freqSemiAnnualLong: 'Semestral (S — cada 6 meses)',
      semiAnnualNote: '(cada 6 meses)',
      freqHelp: 'Deje en Automático para usar la frecuencia detectada por Yahoo Finance. Fuerce un valor solo si la detección es errónea.',
      dpsLabel: 'Dividendo por acción',
      dpsAuto: 'Auto',
      dpsForced: 'Forzado por usted',
      dpsRevertAuto: 'Volver a auto',
      dpsPlaceholderAuto: 'Deje vacío para usar auto: {value}',
      dpsPlaceholder: 'Deje vacío para el valor automático de Yahoo',
      dpsHelp: 'Introduzca un valor solo si el dato de Yahoo Finance es erróneo para este título. Si no, deje vacío.',
      nextDivDateLabel: 'Fecha del próximo dividendo',
      editableIfError: '— modificable si hay error',
      restoreYahooTooltip: 'Restaurar la fecha detectada automáticamente por Yahoo Finance',
      autoYahooBtn: 'Auto Yahoo',
      nextDivDateHelp: 'Si la fecha detectada por Yahoo Finance es incorrecta, puede corregirla aquí. Deje vacío para usar el valor automático.',
      enterSymbolFirst: 'Introduzca primero un símbolo',
      yahooDateRestored: 'Fecha de Yahoo restaurada: {date}',
      yahooNoDate: 'Yahoo Finance no proporciona fecha para este título',
      yahooDateError: 'No se pudo obtener la fecha de Yahoo',
      quarterlyDividend: 'Dividendo trimestral',
      annualDividendFull: 'Dividendo anual',
      dividendPeriodAria: 'Período de visualización del dividendo',
      sharingActiveTooltip: 'Reparto global activo — haga clic para modificar',
      sharingBreakdownTooltip: 'Haga clic para ver el desglose detallado por título',
      paymentTrackingTab: 'Seguimiento de pagos',
      paymentTrackingTooltip: 'Lista de dividendos cuya fecha prevista ha pasado — marque para confirmar la recepción',
      noPendingConfirmations: '🎉 ¡Ningún dividendo pendiente de confirmación! Todas sus fechas están por venir.',
      inFunction: 'en función',
      dividendWord: 'Dividendo',
      totalAnnualDividends: 'Total dividendos anuales:',
      sharingDesc: 'Este reparto se aplica al TOTAL de sus dividendos (todos los títulos). La 1.ª línea = su parte. Ej.: dividendo total 100 $/mes, Paul 75 % → usted ve 75 $/mes.',
      coOwnership: 'Copropiedad',
      enableSharing: '+ Activar el reparto',
      disableSharing: '× Desactivar',
      sharingDefaultNote: 'Por defecto usted recibe el 100 %. Active para compartir con socios (ej.: «Paul 75 %, Hijo 25 %»).',
      yourNamePlaceholder: 'Su nombre (ej.: Paul)',
      associateNamePlaceholder: 'Nombre del socio',
      removeAssociate: 'Quitar este socio',
      addAssociate: '+ Añadir un socio',
      sumComplete: 'Suma completa ✓',
      sumOver: 'Exceso: +{value} %',
      sumRemaining: 'Falta: {value} % por distribuir',
      needAtLeastTwo: 'Añada al menos 2 socios (usted + 1 más)',
      sumMustBe100: 'La suma debe ser 100 (actualmente {sum})',
      eachNeedsName: 'Cada socio debe tener un nombre',
      sharingSaved: 'Reparto de dividendos guardado',
      noDividendPayers: 'Ningún título paga actualmente dividendos en su cartera.',
      breakdownDesc: 'Desglose del dividendo mensual bruto de cada título según sus partes globales configuradas. La 1.ª columna = su parte, las siguientes = socios.',
      recipientLabel: 'Destinatario',
      exampleEmail: 'contable@ejemplo.com',
      sending: 'Enviando...',
      send: 'Enviar',
      exportPdf: 'Exportar en PDF',
      sendByEmail: 'Enviar por email',
      emailSentTo: 'Email enviado a {email}',
      sendFailed: 'Error en el envío',
      pdfExported: 'PDF exportado',
      dateRestored: 'Fecha restaurada',
      dateRestoreFailed: 'No se pudo restaurar la fecha anterior',
      nextDateSet: '{symbol} → {date} (use ↶ para deshacer si hay error)',
      noNextDateFound: 'No se encontró próxima fecha para {symbol}',
      refreshFailed: 'Error al actualizar',
      noPrevDateForAsset: 'No hay fecha anterior que restaurar para este activo',
      dateRestoredFor: 'Fecha restaurada para {symbol}',
      restoreFailed: 'Error en la restauración',
      restorePrevDate: '↶ Restaurar la fecha anterior ({date})',
      noPrevDate: 'No hay fecha anterior que restaurar',
      calcByFreq: 'Calculadas según la frecuencia "{freq}"',
      next3Dates: '🔮 Próximas 3 fechas estimadas:',
      portfolioIntroTip: 'Añada sus acciones y criptomonedas para seguir el valor en tiempo real, los dividendos esperados y las recomendaciones de analistas. Haga clic en Actualizar para sincronizar los precios bursátiles (Yahoo Finance) y cripto (CoinGecko).',
      refreshedToast: 'Cartera actualizada ({n} activos)',
      completeQtyPrice: 'Complete la cantidad y el precio para {symbol}',
      byNationality: 'por nacionalidad',
      tsxTipLabel: 'Consejo:',
      tsxTipBody: 'para una acción canadiense (TSX), añada .TO al final del símbolo (ej.: JEPI.TO, H.TO). Sin sufijo, el símbolo se tratará como una acción estadounidense.',
      nativeCurrencyNote: 'divisa nativa del activo',
      priceNativeTip: 'Introduzca el precio en {native} (no en {cur}) — la conversión a {cur} la hará automáticamente la aplicación.',
      priceModeNative: '{native} (nativa)',
      priceModeUser: '{cur} (mi divisa)',
      priceUserModeTip: 'Introduzca el precio pagado en {cur}, tal como lo indica su banco — la conversión a {native} se hará y el tipo de cambio quedará congelado al guardar.',
      pricePreviewConverted: '≈ {price} {native} · tipo actual: 1 {native} = {rate} {cur} — se congelará al guardar',
      priceFrozenRate: 'Tipo congelado: 1 {native} = {rate} {cur} · precio nativo conservado: {price} {native}',
      sortBySymbol: 'Ordenar por símbolo',
      sortByNextDate: 'Ordenar por próxima fecha de dividendo',
      sortByFreq: 'Ordenar por frecuencia (M→T→S→A)',
      sortByQty: 'Ordenar por cantidad',
      sortByBuyPrice: 'Ordenar por precio de compra',
      sortByCurPrice: 'Ordenar por precio actual',
      sortByTotalValue: 'Ordenar por valor total (divisa del usuario)',
      sortByDps: 'Ordenar por dividendo por acción',
      sortByMonthlyDiv: 'Ordenar por dividendo mensual medio',
      sortByGain: 'Ordenar por ganancia / pérdida',
      receivedHeaderTip: 'Marque cuando acabe de recibir su dividendo — Auto-Gère buscará la próxima fecha',
      confirmedTip: 'Dividendos confirmados para este activo',
      validateOnceTip: 'Haga clic UNA VEZ para validar que Yahoo Finance detecta bien los dividendos',
      receivedCheckTip: 'Marque cuando acabe de recibir su dividendo para que se busque la próxima fecha',
      firstCheckTip: 'Haga clic en "Por verificar" la primera vez para activar el seguimiento del dividendo'
    },
    market: {
      title: 'Datos de mercado',
      subtitle: 'Rastrea precios en tiempo real',
      tabWatchlist: 'Vigilancia',
      tabAnalysis: 'Análisis',
      tabTools: 'Herramientas',
      tabBasket: 'Cesta',
      tabIdeas: 'Ideas',
      importPortfolio: 'Importar cartera',
      importing: 'Importando…',
      search: 'Buscar',
      searchPlaceholder: 'Buscar acciones o cripto...',
      trending: 'Tendencias',
      price: 'Precio',
      change24h: 'Cambio 24h',
      marketCap: 'Capitalización',
      volume: 'Volumen',
      noData: 'No hay datos disponibles',
      newTitle: 'Nuevo seguimiento',
      editTitle: 'Editar seguimiento',
      addBtn: 'Añadir a la watchlist',
      errorLoading: 'Error al cargar la watchlist',
      testSent: 'Correo de prueba enviado',
      testError: 'Error al enviar la prueba',
      checkOk: 'Verificación completada',
      checkNoneTriggered: 'Ningún umbral nuevo superado por ahora',
      checkError: 'Error en la verificación',
      symbolRequired: 'Símbolo requerido',
      saveError: 'Error al guardar',
      empty: 'Sin símbolos. Añade tu primer símbolo a la watchlist.',
      noResults: 'Sin resultados para esta búsqueda.',
      testEmailBtn: 'Probar correo',
      testEmailTooltip: 'Enviar un correo de prueba a mi dirección',
      checkAlertsBtn: 'Verificar alertas',
      checkAlertsTooltip: 'Verificar umbrales ahora y enviar correos si se activan',
      refreshBtn: 'Actualizar',
      alertAbove: 'Alerta si precio ≥',
      alertBelow: 'Alerta si precio ≤',
      alertPctAbove: 'Alerta si subida ≥',
      alertPctBelow: 'Alerta si caída ≤',
      alertPctHint: 'Calculado desde el precio cuando se guardó la alerta. Dejar en blanco para desactivar.',
      alertPctTriggered: 'Variación desde la alerta:',
      setAlert: 'Alerta',
      setAlertTooltip: 'Configurar una alerta de precio o variación %',
      alertsConfigured: 'Alertas',
      alertsConfiguredTooltip: 'Alertas activas — haz clic para editar',
      sinceAlert: 'Desde la alerta:',
      resetReference: 'Reiniciar',
      resetReferenceTooltip: 'Reiniciar la referencia al precio actual',
      optional: 'Opcional',
      personalNote: 'Nota personal',
      notePlaceholder: 'Ej: Comprar bajo 150$, vigilar resultados Q4...',
      cryptoPlaceholder: 'Ej: bitcoin, ethereum',
      stockPlaceholder: 'Ej: AAPL, TSLA',
      legendCap: 'Capitalización bursátil (Cap.)',
      capSuffix_T: 'T$',
      capSuffix_B: 'Md$',
      capSuffix_M: 'M$',
      capLegend_T: 'Billones de dólares (1 T$ = 1 000 mil millones)',
      capLegend_B: 'Miles de millones de dólares',
      capLegend_M: 'Millones de dólares',
      importEmptyPortfolio: 'Su cartera está vacía. Agregue activos primero.',
      importAllPresent: 'Vigilancia ya sincronizada con la cartera.',
      importAdded: '{n} activo(s) agregado(s) a la vigilancia',
      importFailedSome: '({n} fallo(s))',
      importNoneAdded: 'No se pudo agregar ningún activo (¿límite del plan gratuito?)',
      importLoadError: 'No se pudo cargar la cartera',
      cleanupTitle: 'Títulos retirados de la cartera',
      cleanupDesc: '¿Estos títulos de su vigilancia ya no están en su cartera. Quiere retirarlos del Mercado? (Consérvelos si los vigila a propósito.)',
      cleanupRemoveBtn: 'Retirar {n} título(s)',
      cleanupKeepBtn: 'Conservar',
      cleanupDone: '{n} título(s) retirado(s) de la vigilancia',
      alertCurrencyLabel: 'Divisa de los umbrales',
      alertOneShotHint: 'Cada alerta envía un solo correo. Vuelva a guardar la alerta para rearmarla.',
      alertCurrencyHint: 'Sus umbrales alto/bajo se compararán con el precio convertido a esta divisa.',
      sortLabel: 'Ordenar',
      sortDefault: 'Por defecto (alertas primero)',
      sortCapDesc: 'Capitalización: alta → baja',
      sortCapAsc: 'Capitalización: baja → alta',
      capLabel: 'Cap.:',
      capTooltip: 'Capitalización bursátil (valor total de la empresa en bolsa)',
      priceUnavailable: 'Precio no disponible',
      removeTooltip: 'Retirar',
      alertTriggered: 'Alerta activada:',
      alertAboveMsg: 'Por encima de',
      alertBelowMsg: 'Por debajo de',
      thresholdHigh: 'Umbral alto:',
      thresholdLow: 'Umbral bajo:',
      noteLabel: 'Nota',
      removeTitle: '¿Retirar este símbolo?',
      removeDesc: 'El símbolo se retirará de tu watchlist. Puedes añadirlo de nuevo más tarde.',
      removeConfirm: 'Retirar',
      alsoInPortfolio: 'Este activo también está en tu cartera',
      inPortfolioShort: 'Cartera',
      legendTitle: 'Leyenda de las insignias',
      legendBtn: 'Leyenda',
      qualityGrade: 'Nota de calidad',
      gradeLegend_A: 'Excelente',
      gradeLegend_B: 'Buena',
      gradeLegend_C: 'Media',
      gradeLegend_D: 'Mediocre',
      gradeLegend_E: 'Mala',
      gradeLegend_F: 'A evitar',
      legendCalc: 'Calculada a partir del P/E, ROE, endeudamiento y margen de beneficio.',
      legendFreq: 'Frecuencia de dividendo',
      freqLegend_M: 'Mensual',
      freqLegend_T: 'Trimestral',
      freqLegend_S: 'Semestral',
      freqLegend_A: 'Anual',
      importedNote: 'Importado de la cartera',
      notAdvice: 'Esto no es un consejo financiero',
      discTitle: 'Importante — Verifique antes de comprar',
      discMandatory: 'Aviso obligatorio',
      discP1: 'La información mostrada en la sección Mercado (precios, dividendos, frecuencias, recomendaciones de analistas, ideas de investigación, Señales de Mercado Auto-Gère) proviene de fuentes públicas y gratuitas (Yahoo Finance e IA Gemini).',
      discP2: 'Las Señales de Mercado Auto-Gère (Corto / Medio / Largo plazo) se calculan internamente a partir de 5 indicadores técnicos clásicos: RSI (momentum), MACD (convergencia/divergencia), MA (medias móviles 50/200), MFI (flujo monetario) y OBV (volumen acumulado). Metodología abierta: estas señales son una ayuda de lectura del mercado, nunca una garantía de rendimiento futuro.',
      discP3: 'Estos datos pueden contener errores, retrasos o información obsoleta. Una herramienta de verificación cruzada está integrada en el servidor, pero no sustituye en ningún caso una verificación directa.',
      discP4: 'Antes de cualquier transacción real, verifique sistemáticamente las cifras (precio, dividendo, frecuencia, señales técnicas) en la plataforma oficial de su bróker o directamente en el sitio del emisor.',
      discSecTitle: 'Auto-Gère es un software externo',
      discSecBody: 'No tenemos ningún acceso a sus cuentas bancarias reales, su bróker o sus tarjetas. Sin conexión bancaria directa — por tanto, sin riesgo de robo de identidad bancaria. Usted mismo introduce sus transacciones y posiciones únicamente con fines de seguimiento.',
      discInfo: 'Auto-Gère es una herramienta de información y seguimiento — no constituye ni un consejo financiero, ni una recomendación de inversión, ni una solicitud de compra o venta. Las Señales de Mercado, las notas Auto-Gère y las recomendaciones mostradas se proporcionan únicamente a título indicativo. Consulte a un asesor de inversiones autorizado antes de cualquier decisión de inversión vinculante.',
      dontShowAgain: 'No volver a mostrar esta advertencia',
      dontShowNote: '(reaparece si reactiva los Consejos en Ajustes)',
      moreInfoAria: 'Más información sobre la advertencia',
      moreInfo: 'Más información',
      footerDisclaimer: 'Auto-Gère es una herramienta de gestión y seguimiento de sus inversiones. Los análisis, notas Auto-Gère, Señales de Mercado (Corto/Medio/Largo plazo) basadas en 5 indicadores técnicos — RSI, MACD, MA, MFI, OBV — y resúmenes de IA se proporcionan con fines estrictamente informativos y no constituyen en ningún caso una recomendación de compra, venta o conservación. Consulte a un asesor financiero cualificado antes de cualquier decisión de inversión.',
      importTooltip: 'Añade automáticamente todos los activos de su cartera a su vigilancia'
    },
    categories: {
      added: 'Categoría añadida',
      modified: 'Categoría modificada',
      deleted: 'Categoría eliminada',
      confirmDelete: '¿Eliminar esta categoría?',
      errorAdd: 'Error al añadir',
      errorModify: 'Error al modificar',
      errorDelete: 'Error al eliminar',
      manage: 'Gestionar categorías',
      newPlaceholder: 'Nueva categoría...',
      none: 'Sin categorías',
      defaultBadge: '(predeterminada)',
      choose: 'Elegir una categoría'
    },
    settings: {
      passwordChanged: 'Contraseña modificada con éxito',
      passwordError: 'Error al cambiar la contraseña',
      passwordRequired: 'Contraseña requerida',
      accountDeleted: 'Cuenta eliminada. ¡Hasta pronto!',
      accountDeleteError: 'Error al eliminar la cuenta',
      deletingBtn: 'Eliminando…',
      deletePermanentlyBtn: 'Eliminar definitivamente',
      changingPasswordBtn: 'Modificando…',
      changePasswordBtn: 'Cambiar contraseña',
      twoFactorError: 'Error de configuración 2FA',
      title: 'Ajustes',
      subtitle: 'Gestiona la seguridad y tu cuenta',
      appearanceTitle: 'Apariencia',
      appearanceDesc: 'Personaliza el color de acento de la interfaz',
      themeLabel: 'Tema de color',
      themeCurrent: 'Tema activo',
      passwordTitle: 'Contraseña',
      passwordDesc: 'Cambia tu contraseña con regularidad para reforzar la seguridad de tu cuenta',
      changeMyPasswordBtn: 'Cambiar mi contraseña',
      changePasswordDialogTitle: 'Cambiar mi contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirmar nueva contraseña',
      passwordHelp: 'Mín. 8 caracteres. Usa mayúsculas, dígitos y símbolos.',
      passwordMismatch: 'Las contraseñas no coinciden',
      twoFactorTitle: 'Autenticación de dos factores (2FA)',
      twoFactorDesc: 'Añade una capa extra de seguridad con Google Authenticator, Microsoft Authenticator o Authy',
      enabled: 'Activado',
      disabled: 'Desactivado',
      enable2faBtn: 'Activar 2FA',
      disable2faBtn: 'Desactivar 2FA',
      setup2faTitle: 'Configurar autenticación de dos factores',
      manualCode: 'Clave secreta (entrada manual):',
      recoveryCodes: 'Códigos de recuperación',
      enter6DigitCode: 'Introduce el código de 6 dígitos que muestra tu aplicación',
      verifyingBtn: 'Verificando...',
      disable2faTitle: 'Desactivar 2FA',
      sixDigitLabel: 'Código de 6 dígitos',
      accountInfo: 'Información de la cuenta',
      emailLabel: 'Correo',
      fullName: 'Nombre completo',
      addressTitle: 'Dirección postal',
      addressStreet: 'Calle',
      addressCity: 'Ciudad',
      addressPostalCode: 'Código postal',
      addressProvince: 'Provincia / Estado',
      addressCountry: 'País',
      addressEmpty: 'Sin dirección registrada',
      editProfileBtn: 'Modificar mi información',
      editProfileTitle: 'Modificar mi información',
      editProfileDesc: 'Actualiza tu nombre, dirección y correo. El cambio de correo requiere confirmación por enlace.',
      saveBtn: 'Guardar',
      saving: 'Guardando…',
      profileUpdated: 'Perfil actualizado',
      emailChangePending: 'Cambio en espera',
      emailChangePendingDesc: 'Se envió un enlace de confirmación a',
      emailChangeExpiresAt: 'El enlace expira',
      emailChangeCancel: 'Cancelar cambio',
      emailChangeCanceled: 'Solicitud de cambio cancelada',
      emailChangeRequested: 'Enlace de confirmación enviado a {email}. Pincha en él en menos de 1 hora para validar.',
      emailUnchanged: 'Sin cambio de correo — la nueva dirección es la misma que la actual.',
      emailAlreadyUsed: 'Este correo ya está siendo usado por otra cuenta.',
      emailVerifySuccess: '¡Correo actualizado! Ya puedes iniciar sesión con tu nueva dirección.',
      emailVerifyExpired: 'Enlace expirado. Solicita un nuevo cambio.',
      emailVerifyInvalid: 'Enlace inválido o ya utilizado.',
      subscriptionTier: 'Plan de suscripción',
      mySuggestions: 'Mis sugerencias',
      noSuggestionsYet: 'Sin sugerencias enviadas todavía',
      newSuggestion: 'Nueva sugerencia',
      suggCategory: 'Categoría',
      suggCategoryFeature: 'Nueva funcionalidad',
      suggCategoryImprovement: 'Mejora',
      suggCategoryBug: 'Reportar un error',
      suggCategoryGeneral: 'General',
      suggTitle: 'Título',
      suggTitlePlaceholder: 'Ej: Añadir un gráfico de evolución',
      suggDescription: 'Descripción',
      suggDescriptionPlaceholder: 'Describe tu idea en detalle...',
      sendingBtn: 'Enviando...',
      sendSuggestionBtn: 'Enviar sugerencia',
      dangerZone: 'Zona peligrosa',
      dangerZoneSubtitle: 'Acciones irreversibles sobre tu cuenta',
      dangerBullet1: 'Eliminar tu cuenta es',
      dangerBullet1Strong: 'definitivo e irreversible',
      dangerBullet2: 'Todos tus datos serán eliminados: transacciones, presupuestos, cartera, watchlist, facturas',
      dangerBullet3: 'Tu suscripción Premium activa será cancelada sin renovación',
      deleteAccountFinal: 'Esta acción es',
      deleteAccountFinalStrong: 'permanente',
      deleteAccountFinalSuffix: 'y no se puede deshacer.',
      willBeDeleted: 'Se eliminarán definitivamente:',
      itemTxBudgets: 'Tus transacciones y presupuestos',
      itemPfWatchlist: 'Tu cartera y watchlist',
      itemInvoices: 'Tus facturas e historial de pagos',
      itemSuggAlerts: 'Tus sugerencias y alertas',
      typeDeletePrompt: 'para confirmar',
      typePasswordPlaceholder: 'Introduce tu contraseña',
      tipsTitle: 'Consejos guiados',
      tipsDesc: 'Muestra pequeñas burbujas de consejos en las páginas clave para acompañarte en tus primeros pasos.',
      enabledPlural: 'Activados',
      disabledPlural: 'Desactivados',
      tipsNoneClosed: 'Aún no se ha cerrado ningún consejo.',
      tipsClosedCount: 'Has cerrado {count} consejo(s).',
      tipsResetBtn: 'Volver a mostrar todos los consejos',
      appUpdateTitle: 'Actualización de la aplicación',
      appUpdateDesc: 'Auto-Gère ya no comprueba automáticamente las nuevas versiones en segundo plano. Haz clic aquí para comprobar ahora y recibir las últimas mejoras. Versión actual:',
      checkingBtn: 'Comprobando…',
      updateBtn: 'Actualizar',
      budgetAlertTitle: 'Alertas por email · Presupuesto',
      budgetAlertDesc: 'Recibe un email cuando una de tus categorías Ahorro / Gasto alcance el 90 % de su límite (gasto) o el 100 % de su objetivo (ahorro). La campana del panel sigue activa en todos los casos.',
      alertsEnabled: 'Alertas por email activadas',
      marketReportTitle: 'Informe de lo más destacado',
      marketReportDesc: 'Reciba por correo los ganadores y las pérdidas del día entre los títulos de su cartera, después del cierre de los mercados.',
      marketReportFreq_off: 'Desactivado',
      marketReportFreq_daily: 'Cada día',
      marketReportFreq_weekly: 'Cada semana (viernes)',
      marketReportFreq_monthly: 'Cada mes',
      marketReportSaved: 'Frecuencia del informe guardada',
      marketReportError: 'Error al guardar',
      marketReportHint: 'Enviado alrededor de las 17 h (hora del Este) tras el cierre de los mercados de EE. UU., en días bursátiles.',
      alertsDisabled: 'Alertas por email desactivadas',
      alertsPrefError: 'No se pudo actualizar la preferencia',
      extraRecipientsTitle: 'Destinatarios adicionales',
      extraRecipientsDesc: 'Estas personas recibirán las mismas alertas que tú (presupuesto, exceso…) además de tu buzón principal. Ideal para avisar a un cónyuge, contable o socio.',
      removeBtn: 'Quitar',
      addBtn: 'Añadir',
      recipientPlaceholder: 'conyuge@ejemplo.com',
      invalidEmail: 'Dirección de email no válida',
      alreadyPrimary: 'Ya recibes las alertas en tu email principal',
      alreadyInList: 'Esta dirección ya está en la lista',
      maxRecipients: 'Máximo 5 destinatarios adicionales',
      addedToAlerts: '{email} añadido a las alertas',
      recipientRemoved: 'Destinatario eliminado',
      cannotSave: 'No se pudo guardar'
    },
    paypalExtra: {
      cancelled: 'Renovación automática cancelada',
      cancelError: 'Error al cancelar',
      paypalError: 'Error PayPal. Intenta más tarde.',
      promoFirstCycleTitle: 'Descuento aplicado a tu primer pago',
      promoFirstCycleDesc: 'El código {code} te da {percent}% de descuento en tu primer pago. Las renovaciones siguientes se facturarán al precio regular.',
      promoNoteBanner: 'El descuento se aplica a tu primer pago (con o sin renovación automática). Las renovaciones siguientes son al precio regular.',
      cancelledByUser: 'Pago cancelado'
    },
    exportExtra: {
      error: 'Error al exportar',
      downloaded: 'Exportación descargada'
    },
    common: {
      save: 'Guardar',
      saveChanges: 'Guardar cambios',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      search: 'Buscar',
      filter: 'Filtrar',
      export: 'Exportar',
      import: 'Importar',
      add: 'Añadir',
      confirm: 'Confirmar',
      loading: 'Cargando…',
      error: 'Error',
      errorLoading: 'Error al cargar',
      errorSaving: 'Error al guardar',
      errorDeleting: 'Error al eliminar',
      errorAdding: 'Error al añadir',
      errorUpdating: 'Error al modificar',
      success: 'Éxito',
      deleted: 'Eliminado',
      added: 'Añadido',
      modified: 'Modificado',
      monthly: 'Mensual',
      yearly: 'Anual',
      clickToHide: 'Clic para ocultar'
    },
    premium: {
      title: 'Cambiar a Premium',
      autoRenewTitle: 'Renovación automática',
      autoRenewReactivated: 'Renovación automática reactivada',
      reactivateFailed: 'Reactivación imposible',
      activeBadge: 'Activo',
      disabledBadge: 'Desactivado',
      nextBilling: 'Próxima facturación:',
      noRenewal: 'Sin renovación. Su Premium expira el {date}.',
      expiryWarning: 'Atención: al expirar, ya no podrá añadir nueva información (transacciones, posiciones, presupuestos). Sus datos existentes seguirán accesibles en modo de solo lectura.',
      activeTitle: 'Suscripción Premium activa',
      subtitle: 'Desbloquea todas las funciones sin límites',
      reservedTitle: 'Solo Premium',
      reservedDesc: 'Pasa a Premium para desbloquear esta función.',
      upgradeNow: 'Pasar a Premium',
      expiresOn: 'Expira el',
      included: 'Incluido en Premium',
      monthly: 'Mensual',
      yearly: 'Anual',
      saveBadge: 'AHORRA',
      perMonth: 'por mes · sin compromiso',
      monthlyEquiv: 'es decir,',
      autoRenew: 'Renovación automática',
      autoRenewOn: 'Tu suscripción se renovará automáticamente. Cancelable en cualquier momento.',
      autoRenewOff: 'Pago único. Deberás renovar manualmente cuando expire.',
      autoRenewActive: 'Renovación automática: ACTIVADA',
      autoRenewInactive: 'Renovación automática: DESACTIVADA',
      nextBilling: 'Próximo cobro el',
      noRenewal: 'Tu Premium expirará al final del período actual sin renovación.',
      cancelRenewal: 'Cancelar renovación',
      confirmCancelTitle: '¿Cancelar la renovación automática?',
      keepRenewal: 'Mantener renovación',
      confirmCancel: 'Sí, cancelar',
      payWithPaypal: 'Pago seguro vía PayPal',
      testMode: '(modo prueba)',
      processing: 'Procesando pago…',
      myInvoices: 'Mis facturas',
      paid: '✓ Pagada',
      billedIn: 'Facturado',
      notConfigured: 'Pago PayPal no configurado.',
      confirmCancelDescPrefix: 'Tu suscripción Premium seguirá activa hasta el',
      confirmCancelDescSuffix: 'No se hará ningún cobro adicional. Puedes reactivarla en cualquier momento.',
      autoRenewedBadge: 'Auto-renovación',
      subActivated: '¡Suscripción activada! Factura {invoice} enviada por correo.',
      activationError: 'Error de activación',
      captureSuccess: '¡Pago realizado! Factura {invoice} enviada por correo.',
      captureError: 'Error al procesar el pago',
      planIdMissing: 'Falta Plan ID',
      features: {
        unlimitedTransactions: 'Transacciones ilimitadas',
        unlimitedAssets: 'Cartera sin límite de activos',
        priceAlerts: 'Alertas de precio por correo',
        realTimeData: 'Datos de mercado en tiempo real',
        exports: 'Exportaciones PDF y Excel ilimitadas',
        multiCurrency: 'Multi-divisas (15 monedas)',
        twoFactor: 'Autenticación 2FA',
        prioritySupport: 'Soporte prioritario'
      }
    },
    budgetExtra: {
      typeLabel: 'Tipo de objetivo',
      expenseType: 'Límite de gasto',
      expenseDesc: 'Limitar los gastos',
      savingType: 'Objetivo de ahorro',
      savingDesc: 'Ahorrar una cantidad',
      goalAmount: 'Monto objetivo',
      manageCategories: 'Gestionar categorías',
      saved: 'Ahorrado',
      target: 'Objetivo',
      leftToSave: 'Falta por ahorrar',
      badgeSaving: '🎯 Ahorro',
      badgeExpense: '💸 Gasto',
      goalReached: '✓ ¡Objetivo alcanzado!',
      overBudget: '⚠ Presupuesto superado o cerca del límite',
      approachingLimit: '⚠ Acercándose al límite',
      editTooltip: 'Editar este presupuesto',
      deleteTooltip: 'Eliminar este presupuesto',
      moveUpTooltip: 'Mover hacia arriba',
      moveDownTooltip: 'Mover hacia abajo',
      farFromGoal: '⚠ Lejos de tu objetivo — empieza a ahorrar',
      gettingStarted: '↗ Acabas de empezar a ahorrar'
    },
    reports: {
      title: 'Informes y exportaciones',
      subtitle: 'Resumen de tus finanzas y descargas en PDF / Excel.',
      summaryIncome: 'Ingresos totales',
      summaryExpense: 'Gastos totales',
      summaryBalance: 'Saldo neto',
      summaryPortfolio: 'Valor de la cartera',
      netCumulative: 'Acumulado ingresos − gastos',
      entries: 'registros',
      assets: 'activos',
      exportsTitle: 'Exportaciones rápidas',
      exportsSubtitle: 'Descarga tus datos en el formato que prefieras.',
      transactionsTitle: 'Transacciones',
      transactionsDesc: 'Lista detallada de todas tus transacciones con categorías.',
      budgetsTitle: 'Presupuestos',
      budgetsDesc: 'Estado de todos tus presupuestos de gasto y ahorro.',
      portfolioTitle: 'Cartera',
      portfolioDesc: 'Composición y rendimiento de tu cartera.',
      downloadPdf: 'Descargar PDF',
      downloadExcel: 'Descargar Excel',
      downloading: 'Descargando…',
      downloadOk: 'Exportación descargada',
      archiveBudget: 'Archivar el Presupuesto Personal del año en PDF',
      archiveIncome: 'Archivar el Ingreso de Activos de un mes en PDF',
      archivePortfolio: 'Archivar la Cartera del año en PDF',
      archivePortfolioDesc: 'Genera una foto anual completa de su cartera (activos, cantidades, valores, distribución). Guardada en la página «Archivo». Una nueva generación reemplaza la del mismo año.',
      archivePortfolioOk: 'Archivo de Cartera {year} generado y guardado en Archivo.',
      year: 'Año',
      month: 'Mes',
      createPdf: 'Crear PDF',
      archiveYear: 'Archivar el año',
      archiveMonth: 'Archivar el mes',
      yearToArchive: 'Año a archivar',
      downloadError: 'Error al descargar',
      activeBudgetsTitle: 'Presupuestos activos',
      budgetsCount: 'presupuesto(s) activo(s)',
      colCategory: 'Categoría',
      colType: 'Tipo',
      colSpent: 'Real',
      colLimit: 'Objetivo',
      colProgress: 'Progreso',
      typeSaving: '🎯 Ahorro',
      typeExpense: '💸 Gasto',
      chartIncomeVsExpense: 'Ingresos vs Gastos',
      chartTopExpenses: 'Top gastos por categoría',
      chartMonthlyEvolution: 'Evolución mensual (últimos 12 meses)',
      chartPortfolio: 'Distribución de la cartera',
      archiveYearBtn: 'Archivar el año',
      archiveYearTooltip: 'Genera un PDF anual consolidado (transacciones + presupuestos + cartera)',
      confirmArchive: '¿Generar el informe anual consolidado para {year}?\n\nIncluirá todas tus transacciones, presupuestos y cartera del año. El PDF estará disponible en la página Archivo.',
      archiveSuccess: 'Informe anual {year} archivado',
      archiveError: 'Error al archivar',
      archiving: 'Archivando…',
      monthlyTitle: 'Archivar las transacciones de un mes como PDF',
      monthlySubtitle: 'Genera un PDF mensual de las transacciones. El archivo aparecerá en la cuadrícula del año correspondiente en la página Archivo.',
      monthlyYearLabel: 'Año',
      monthlyMonthLabel: 'Mes',
      monthlyBtn: 'Crear PDF',
      monthlyOk: 'PDF mensual creado ({year}-{month})',
      monthlyError: 'Sin transacciones para este mes o error',
      budgetIncomeTitle: 'Ingresos de Activos',
      budgetIncomeDesc: 'Ingresos previstos (nómina, dividendos, asignaciones) por fuente.',
      selectYearBody: 'Seleccione el año a archivar. Se generará un informe PDF completo y se conservará en la sección Archivo. Si ya existe un archivo para ese año, podrá elegir sobrescribirlo.',
      archiveExists: 'El archivo ya existe',
      existsForYear: 'Ya existe un archivo para el año',
      overwriteQuestion: '¿Desea sobrescribirlo y generar una nueva versión?',
      keepOld: 'Conservar el antiguo',
      overwriting: 'Sobrescribiendo…',
      overwriteBtn: 'Sobrescribir y regenerar',
      specialPaymentsNote: 'Pagos excepcionales (especiales, extraordinarios) recibidos sobre sus acciones — además de los dividendos recurrentes.',
      annualGrowth: 'Crecimiento anual',
      cagrFull: 'CAGR (años completos)',
      inNYears: 'En {n} años',
      perYear: 'por año',
      projectionNote: 'Proyección basada en su CAGR histórico. Los rendimientos futuros pueden variar según las decisiones de las empresas (subidas/recortes de dividendos, recompras), la inflación y los movimientos del mercado. Úselo como indicador, no como garantía.',
      shareChartAria: 'Compartir mi gráfico de dividendos',
      create12Tip: 'Crea los 12 archivos PDF (enero → diciembre) para el año seleccionado'
    },
    archive: {
      title: 'Archivo',
      subtitle: 'Consulta las transacciones de años anteriores (solo lectura)',
      selectYear: 'Elige un año',
      income: 'Ingresos',
      expense: 'Gastos',
      balance: 'Saldo neto',
      transactionsTitle: 'Transacciones',
      readOnly: 'Las transacciones archivadas son solo de lectura.',
      noTx: 'Sin transacciones para este año.',
      emptyTitle: 'Sin archivo disponible',
      emptyDesc: 'Tus transacciones de años anteriores aparecerán aquí automáticamente.',
      gridTitle: 'Archivo de 7 años',
      gridSubtitle: 'Una columna por año — un PDF mensual cliqueable por celda.',
      generate: 'Generar',
      download: 'Descargar',
      generating: 'Creando…',
      monthlyArchiveSuccess: 'PDF mensual creado ({year}-{month})',
      monthlyArchiveError: 'No se pudo generar este PDF mensual',
      yearlyPdfBadge: 'Anual',
      monthlyPdfBadge: 'Mensual',
      savedFiles: 'Archivos guardados',
      noFilesForYear: 'Sin PDF archivado para {year}.',
      retentionNotice: 'Se recomienda encarecidamente conservar tus datos al menos 7 años antes de eliminarlos (obligaciones fiscales).',
      deleteWarning: '⚠️ ¿Seguro que quieres eliminar permanentemente el archivo {year}?\n\nSe RECOMIENDA ENCARECIDAMENTE conservar tus datos al menos 7 años (cumplimiento fiscal). Esta acción no se puede deshacer.',
      deleteSuccess: 'Archivo eliminado',
      expiredTitle: 'Datos expirados (fuera de la ventana de 7 años)',
      expiredDesc: 'Estos archivos superan los últimos 7 años. Serán eliminados automáticamente tras el plazo indicado, salvo que decidas conservarlos.',
      noExpired: 'Sin archivos expirados.',
      autoDeleteIn: 'Eliminación auto en {days} días',
      autoDeleteToday: 'Eliminación auto hoy',
      keepLonger: 'Conservar',
      keepSuccess: 'Eliminación automática cancelada',
      deleteNow: 'Eliminar ahora',
      monthShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      annualRowLabel: 'Anual',
      removeDialogTitle: '¿Qué quieres hacer con este archivo?',
      removeDialogDesc: 'Elige "Exportar" para descargar el PDF ahora, o "Marcar como expirado" para moverlo a "Datos expirados" (eliminación auto en 30 días salvo cancelación).',
      exportAction: 'Exportar (PDF)',
      expireAction: 'Marcar como expirado',
      cancel: 'Cancelar',
      expireSuccess: 'Archivo marcado como expirado — eliminación auto en 30 días',
      expireError: 'No se pudo marcar este archivo',
      sendByEmailTooltip: 'Enviar por email',
      budgetGridTitle: 'Presupuesto personal — archivos anuales',
      budgetGridSubtitle: 'Foto anual completa del Presupuesto personal (gastos, ahorros, cadencias). 1 PDF por año. Fuente: Presupuesto → Presupuesto personal.',
      annualSnapshot: 'Foto anual',
      portfolioSnapshot: 'Cartera (foto anual)',
      incomeGridTitle: 'Ingresos de Activos — archivos mensuales',
      incomeGridSubtitle: 'Cada celda crea un PDF de los ingresos previstos del mes (fuente: Presupuesto > Ingresos de Activos). Almacenado durante 7 años, igual que la cuadrícula de Transacciones.',
      monthCol: 'Mes',
      emailDialogTitle: 'Enviar el archivo por email',
      emailDialogDesc: 'El PDF se enviará como adjunto. Ideal para compartir con tu contable, socio o familiar.',
      recipientLabel: 'Destinatario',
      exampleEmail: 'contable@ejemplo.com',
      sending: 'Enviando...',
      send: 'Enviar',
      invalidEmail: 'Dirección de email no válida',
      sentTo: 'Archivo enviado a {email}',
      yearCol: 'Año',
      sendFailed: 'Error en el envío'
    },
    marketAnalysis: {
      loading: 'Cargando el análisis…',
      tipTitle: 'Análisis de su cartera',
      tipBody: 'Auto-Gère analiza los fundamentos (P/E, ROE, deuda, margen) de cada una de sus acciones y les asigna una nota de A a F. También ve el consenso de los analistas. Haga clic en Resumen para obtener una síntesis detallada. Consejo: el informe mensual puede enviarse directamente a su correo.',
      analyzedSuffix: 'acción(es) analizada(s) desde su cartera.',
      sortLabel: 'Ordenar por:',
      sortNone: 'Ninguno',
      autogereGrade: 'Nota Auto-Gère',
      sortBest: 'Mejor (A → F)',
      sortWorst: 'Peor (F → A)',
      optgroupSignal: 'Señal de Mercado (Medio plazo)',
      sortBull: 'Alcistas primero',
      sortHold: 'Mantener / Neutro primero',
      sortBear: 'Bajistas primero',
      filterAll: 'Todos',
      buy: 'Compra',
      hold: 'Mantener',
      sell: 'Venta',
      reco_hold2: 'Mantenido',
      reco_sell2: 'Vender',
      reco_strong_buy: 'Compra fuerte',
      reco_strong_sell: 'Venta fuerte',
      reco_underperform: 'Bajo rendimiento',
      noneInCategory: 'Ninguna acción en la categoría por ahora:',
      sending: 'Enviando…',
      sendReport: 'Enviar el informe mensual',
      reportSent: 'Informe enviado a {r} ({n} acciones)',
      loadError: 'No se pudo cargar el análisis de la cartera',
      progressiveLoading: 'Análisis en curso… {done}/{total} títulos analizados — los resultados aparecen a medida que llegan.',
      legendTitle: 'Notas de calidad Auto-Gère: A → F',
      legendIntro: 'Auto-Gère calcula una puntuación sobre 100 combinando 4 ejes ponderados a partes iguales (25 % cada uno):',
      axisVal: 'Valoración — Ratio precio/beneficio (P/E). Más bajo = relativamente más barato.',
      axisRent: 'Rentabilidad — Rentabilidad de los fondos propios (ROE). Más alto = empresa rentable.',
      axisDebt: 'Endeudamiento — Ratio deuda / fondos propios. Más bajo = balance más sano.',
      axisMargin: 'Margen de beneficio — Margen neto. Más alto = empresa eficiente.',
      score: 'Puntuación',
      gradeLabel_A: 'Excelente',
      gradeLabel_B: 'Bueno',
      gradeLabel_C: 'Medio',
      gradeLabel_D: 'Débil',
      gradeLabel_E: 'Muy débil',
      gradeLabel_F: 'Crítico',
      gradeLabel_UNK: 'N/D',
      gradeDesc_A: 'Fundamentos sólidos en todos los ejes. Valoración razonable, alta rentabilidad, deuda controlada, margen robusto.',
      gradeDesc_B: 'Empresa de calidad con fundamentos globalmente positivos. Una o dos debilidades menores sin riesgo mayor.',
      gradeDesc_C: 'Perfil mixto. Algunos indicadores son sólidos, otros débiles. A vigilar según la tolerancia al riesgo.',
      gradeDesc_D: 'Varias señales de alerta (valoración alta, rentabilidad baja, deuda importante o márgenes estrechos).',
      gradeDesc_E: 'Perfil financiero degradado. Riesgo significativo para la sostenibilidad o el rendimiento futuro.',
      gradeDesc_F: 'Fundamentos muy deteriorados. Alta probabilidad de pérdidas o de reestructuración.',
      yahooNote: 'Los datos provienen de Yahoo Finance. La nota no constituye un consejo financiero.',
      fundamentals: 'Fundamentos',
      hintPE: 'Price/Earnings (TTM). Inferior = relativamente más barato.',
      hintFwdPE: 'P/E proyectado para el próximo año.',
      hintROE: 'Return on Equity: rentabilidad de los fondos propios.',
      labelMargin: 'Margen benef.',
      hintMargin: 'Margen neto.',
      labelDebt: 'Deuda/Cap.',
      hintDebt: 'Debt to Equity (en %). < 100 = sano.',
      hintBeta: 'Volatilidad vs mercado. 1 = como el mercado.',
      labelYield: 'Rend. div.',
      hintYield: 'Dividendo anual / precio actual.',
      hintPayout: '% del beneficio repartido en dividendos.',
      recosTitle: 'Recomendaciones de analistas',
      noRecos: 'Recomendaciones de analistas: N/A',
      totalAnalysts: 'Total: {n} analistas',
      estimate: ' (estimación)',
      consensus: 'Consenso:',
      targetMean: 'Objetivo medio:',
      summary: 'Resumen',
      chart: 'Gráfico',
      chartTitle: 'Gráfico TradingView',
      tvNote: 'Datos proporcionados por TradingView. Solo con fines informativos — no constituye un consejo financiero.',
      signalsTitle: 'Señales de Mercado Auto-Gère',
      signalsDisclaimer: 'Basado en RSI · MACD · MA · MFI · OBV. No constituye un consejo financiero.',
      computing: 'Calculando indicadores técnicos…',
      horizon_short_term: 'Corto plazo',
      horizonSub_short_term: '1-2 sem.',
      horizon_mid_term: 'Medio plazo',
      horizonSub_mid_term: '1-3 meses',
      horizon_long_term: 'Largo plazo',
      horizonSub_long_term: '6 meses+',
      signal_strong_bull: 'Señal alcista fuerte',
      signal_bull: 'Señal alcista',
      signal_neutral: 'Neutro',
      signal_bear: 'Señal bajista',
      signal_strong_bear: 'Señal bajista fuerte'
    },
    globalAlerts: {
      button: 'Alerta general',
      buttonTip: 'Alerta por correo en TODOS sus títulos: % de variación vs cierre del día anterior',
      title: 'Alerta general',
      scopePortfolio: 'Cartera',
      scopeWatchlist: 'Seguimiento',
      description: 'Una sola regla aplicada a todos sus títulos: recibirá un correo cuando un título varíe más allá de sus umbrales respecto al cierre del día anterior.',
      enable: 'Activar la alerta general',
      upLabel: 'Subida de',
      downLabel: 'Bajada de',
      optional: 'opcional',
      antiSpamNote: 'Un solo correo por título y por día cuando se cruza un umbral. Los títulos activados al mismo tiempo se agrupan en un solo correo. Verificación cada 15 minutos.',
      save: 'Guardar',
      saved: 'Alerta general guardada',
      saveError: 'Error al guardar',
    },
    budgetTable: {
      amountViewTip: 'Cambiar el período de visualización del monto (anual, mensual, cada 2 semanas, semanal)',
      viewMonthly: 'Al mes (÷12)',
      viewBiweekly: 'Cada 2 sem. (÷26)',
      viewWeekly: 'A la sem. (÷52)',
      viewShort_monthly: 'mes',
      viewShort_biweekly: '2 sem.',
      viewShort_weekly: 'sem.',
      periodTip: 'El monto ingresado se convertirá a anual según el período elegido',
      periodAnnual: 'Por año (×1)',
      periodMonthly: 'Por mes (×12)',
      periodBiweekly: 'Cada 2 sem. (×26)',
      periodWeekly: 'Por sem. (×52)',
      emailAlert: 'Alerta por correo',
      emailAlertOnTip: 'Recordatorios por correo activados para esta línea — haga clic para desactivar',
      emailAlertOffTip: 'Recordatorios por correo desactivados para esta línea — haga clic para activar',
      markDone: 'Marcar como hecho',
      markUndone: 'Marcar como no hecho',
      done: 'hecho',
      removeDate: 'Quitar esta fecha',
      addDateTip: 'Añadir una fecha manualmente (entrada libre)',
      addDate: 'Añadir fecha',
      presets: 'Preajustes:',
      weeklyTip: 'Genera 52 pagos semanales (1 por semana durante el año) — ideal para alquiler semanal, compra, suscripciones alineadas con la paga',
      weekly: 'Semanal (52×)',
      monthlyTip: 'Genera 12 pagos mensuales (enero → diciembre) — ideal para hipoteca, alquiler, suscripciones',
      monthly: 'Mensual (12×)',
      quarterlyTip: 'Genera 4 pagos trimestrales (enero, abril, julio, octubre) — ideal para impuestos municipales/escolares',
      quarterly: 'Trimestral (4×)',
      semiTip: 'Genera 2 pagos semestrales (enero + julio) — ideal para seguros de hogar/auto',
      semi: 'Semestral (2×)',
      annualTip: 'Genera 1 solo pago anual en la fecha pivote — ideal para suscripción anual, impuesto único',
      annual: 'Anual (1×)',
      freqWeeklyLabel: 'semanales (52×/año)',
      freqMonthlyLabel: 'mensuales (ene. → dic.)',
      freqQuarterlyLabel: 'trimestrales (4×/año, ene./abr./jul./oct.)',
      freqSemiLabel: 'semestrales (2×/año, ene./jul.)',
      freqAnnualLabel: 'anual (1×/año)',
      paymentsGenerated: '{n} pagos {label} generados',
      payPeriodError: 'No se pudo guardar el período de pago',
      noUnpaidForDate: 'Ningún pago pendiente previsto el {date}.',
      net: 'Neto:',
      received: 'recibido',
      paid: 'pagado',
      receivedPl: 'recibidos',
      paidPl: 'pagados',
      deficitTip: 'mes(es) vencido(s) no recibido(s) — pasa a gasto',
      totalIncome: 'TOTAL INGRESOS',
      totalExpense: 'TOTAL GASTOS',
      annualFixed: 'Gastos fijos anuales',
      totalCap: 'TOTAL',
      netToTransfer: 'NETO A TRANSFERIR',
      surplus: 'SUPERÁVIT',
      depAbbr: 'gas.',
      defAbbr: 'déf.',
      perYourPeriod: 'Según su período:',
      payPeriodTip: 'Para cambiar el período de pago, use la tarjeta verde en la parte superior de la tabla («Mi período de pago»).',
      rentBehindTip: 'Alquileres vencidos no recibidos — pasa a gasto en el Neto real',
      newAssetHeader: 'Nuevo activo (encabezado) — ej.: «777 de la Noé», «Condo Verdun», «Duplex Ahuntsic»…',
      newAssetDesc: 'Cree primero el encabezado de su propiedad. Después podrá añadir debajo secciones de 💵 ingresos (alquileres) Y/O 💸 gastos (impuestos, hipoteca, mantenimiento…).',
      assetNamePh: 'Nombre del activo...',
      createAsset: 'Crear el activo',
      addSectionToAsset: 'Añadir una sección a un activo (💵 ingreso o 💸 gasto)',
      parentAsset: 'Activo padre',
      yes: 'Sí',
      no: 'No',
      addLineIn: 'Añadir una línea en',
      assetBadge: 'Activo',
      sections: 'sección(es)',
      receivedCap: 'Recibidos',
      paidCap: 'Pagados',
      incomeBadge: 'Ingreso',
      expenseBadge: 'Gasto',
      netIncomeCap: 'INGRESO NETO',
      deficitCap: 'DÉFICIT',
      deficitWord: 'déficit',
      realNetLabel: 'Neto real (con déficit)',
      expectedAssetIncome: 'Ingreso previsto de los activos'
    },
    accountant: {
      title: 'Hoja contable',
      subtitle: 'Resumen fiscal listo para entregar a su contable',
      exportPdf: 'Exportar PDF',
      exportExcel: 'Exportar Excel',
      netResult: 'Resultado Neto',
      monthCol: 'Mes',
      incomeCol: 'Ingresos',
      expenseCol: 'Gastos',
      resultCol: 'Resultado',
      categoryCol: 'Categoría',
      txCount: 'N.º de transacciones',
      loadError: 'Error al cargar',
      downloaded: 'Hoja contable {fmt} descargada',
      exportError: 'Error al exportar'
    },
    authFlow: {
      verifying: 'Verificando…',
      waitFew: 'Espere unos segundos.',
      emailVerified: '¡Email verificado!',
      addressLabel: 'La dirección',
      nowActive: 'ya está activa.',
      canAccessAll: 'Ahora puede acceder a todas las funcionalidades de Auto-Gère y suscribirse a un plan Premium.',
      login: 'Iniciar sesión',
      linkExpired: 'Enlace caducado',
      expiredBody: 'Este enlace de activación ha caducado (24 h máx.). Inicie sesión para recibir uno nuevo.',
      alreadyActivated: 'Cuenta ya activada',
      alreadyUsedBody: 'Este enlace ya se ha utilizado. Su cuenta está activada y lista para usar.',
      loginNormally: 'Inicie sesión normalmente para acceder a Auto-Gère.',
      linkInvalid: 'Enlace no válido',
      invalidBody: 'Este enlace de activación no es válido o ya se ha utilizado.',
      goToLogin: 'Ir al inicio de sesión',
      pwdMin8: 'La contraseña debe tener al menos 8 caracteres.',
      pwdMismatch: 'Las dos contraseñas no coinciden.',
      pwdResetDone: 'Contraseña restablecida',
      resetFailed: 'Error al restablecer',
      resetLinkInvalidBody: 'Este enlace de restablecimiento está incompleto o caducado.',
      backToLogin: 'Volver al inicio de sesión',
      pwdResetTitle: 'Contraseña restablecida ✓',
      redirecting: 'Redirigiendo a la página de inicio de sesión…',
      newPwd: 'Nueva contraseña',
      choosePwd: 'Elija una nueva contraseña segura para su cuenta Auto-Gère.',
      min8: 'Al menos 8 caracteres',
      confirmPwd: 'Confirmar la contraseña',
      resetting: 'Restableciendo…',
      resetBtn: 'Restablecer la contraseña',
      activationRequired: 'ACTIVACIÓN REQUERIDA',
      verifyYourEmail: 'Verifique su dirección de email',
      hello: 'Hola',
      clickLinkSentTo: 'Para activar su cuenta Auto-Gère, haga clic en el enlace que acabamos de enviar a:',
      dontSeeEmail: '¿No ve el email?',
      checkSpam: 'Revise su carpeta de spam / correo no deseado. Si sigue sin encontrarlo después de unos minutos, haga clic en «Reenviar el email» más abajo para continuar.',
      addContact: 'Añada support@autogere.ca a sus contactos para garantizar la buena recepción de nuestros mensajes.',
      resendSuccess: 'Email de activación reenviado. Revise su bandeja de entrada y su spam.',
      resendError: 'Error en el envío. Inténtelo de nuevo en unos minutos.',
      statusRefreshed: 'Estado actualizado.',
      sendingNow: 'Enviando…',
      resendEmail: 'Reenviar el email',
      checkingBtn: 'Verificando…',
      iClicked: 'Hice clic — actualizar',
      wrongAddress: '¿Dirección incorrecta? Cierre sesión y cree una nueva cuenta.',
      logoutBtn: 'Cerrar sesión',
      noCharge: 'No se realizará ningún cargo hasta que haya activado su cuenta y elegido un plan.'
    },
    ideas: {
      scrDividend: 'Dividendo',
      scrHighDiv: 'Altos dividendos (large caps infravaloradas)',
      scrUndervaluedGrowth: 'Crecimiento infravalorado',
      scrDayGainers: 'Ganadores del día',
      scrDayLosers: 'Perdedores del día',
      scrMostActive: 'Más activas',
      scrGrowthTech: 'Tecnología en crecimiento',
      scrSmallCaps: 'Small caps agresivas',
      scrMostShorted: 'Más en corto',
      scrMorningstar: 'Morningstar 5 estrellas',
      scrLargestCap: 'Mayores capitalizaciones',
      scr52Gainers: 'Ganadores 52 sem.',
      scr52Losers: 'Perdedores 52 sem.',
      sortRelevance: 'Relevancia',
      sortGrade: 'Nota (A → F)',
      sortDivDollar: 'Dividendo $/año (todos)',
      sortDivYield: 'Rendimiento %',
      sortDivM: 'Div. mensual (M) solamente',
      sortDivT: 'Div. trimestral (T) solamente',
      sortDivS: 'Div. semestral (S) solamente',
      sortDivA: 'Div. anual (A) solamente',
      sortPriceAsc: 'Precio ascendente',
      sortSymbol: 'Símbolo (A → Z)',
      sortCountry: 'Nacionalidad (CA → US → EU → AS)',
      sortMarketCap: 'Capitalización (grande → pequeña)',
      sortPriceDesc: 'Precio descendente (cara → barata)',
      sortPriceAsc2: 'Precio ascendente (barata → cara)',
      noResultsCur: 'Sin resultados en {cur} para este screener.',
      noResultsScreener: 'Sin resultados — Yahoo no devolvió nada para este screener.',
      searchUnavailable: 'Búsqueda no disponible — inténtelo más tarde',
      aiUnavailable: 'Búsqueda IA no disponible — inténtelo más tarde',
      tipTitle: 'Búsqueda de títulos y criptos',
      tipDemoBody: 'Descubra acciones y criptos mediante los screeners de Yahoo Finance en tiempo real o mediante nuestra IA. Filtros: alto rendimiento, crecimiento, dividendo, ganadores del día, etc.',
      premiumFeature: 'Funcionalidad Premium',
      premiumBody: 'La búsqueda dinámica de títulos y criptos (Yahoo Screener + IA) está reservada a Premium. En modo demo esta funcionalidad está desactivada.',
      goPremium: 'Pasar a Premium',
      tipSearchBody: 'Elija un screener de Yahoo (resultados en tiempo real) o escriba una búsqueda libre — la IA propondrá títulos o criptos correspondientes. Añada sus favoritos a la Cesta.',
      stocks: 'Acciones',
      cryptos: 'Criptos',
      allCurrencies: 'Todas',
      aiPlaceholderCrypto: "Búsqueda libre IA: 'tokens DeFi con alto potencial', 'criptos PoS rentables'…",
      aiPlaceholderStocks: "Búsqueda libre IA: 'oleoductos canadienses', 'REIT mensual de alto dividendo'…",
      searchBtn: 'Buscar',
      screenersCrypto: 'Screeners Yahoo Cripto (en vivo):',
      screenersStocks: 'Screeners Yahoo Acciones (en vivo):',
      source: 'fuente',
      sortBy: 'Ordenar por',
      added: 'Añadido',
      basketBtn: 'Cesta',
      annualDiv: 'Div. anual',
      perShare: '/acción',
      payment: 'Pago',
      yield: 'Rendimiento',
      noneOption: '(ninguna)',
      emptyStateStocks: 'Elija un screener de acciones o escriba una búsqueda libre para empezar.',
      emptyStateCrypto: 'Elija un screener de criptos o escriba una búsqueda libre para empezar.'
    },
    basket: {
      clearConfirm: '¿Vaciar completamente la cesta?',
      cleared: 'Cesta vaciada',
      premiumTitle: 'Cesta Premium',
      premiumBody: 'La cesta le permite acumular ideas antes de añadirlas a su cartera. Reservada a los usuarios Premium.',
      tipTitle: 'Su cesta de ideas',
      tipBody: 'Los títulos que añadió desde la pestaña Búsqueda aparecen aquí. Haga clic en Añadir a la cartera para transferir un título a su cartera (cantidad y precio a introducir). La cesta se guarda localmente en su navegador.',
      empty: 'Su cesta está vacía.',
      emptyHint: 'Vaya a la pestaña Búsqueda para encontrar títulos que añadir.',
      addToPortfolio: 'Añadir a la cartera',
      pending: 'título pendiente',
      pendingPl: 'títulos pendientes'
    },
    tools: {
      converterTitle: 'Conversor de divisas',
      amountLabel: 'Importe a convertir',
      invert: 'Invertir',
      result: 'Resultado',
      rateInEffect: 'Tipo de cambio vigente:',
      tipTitle: 'Herramientas de cálculo',
      tipBody: 'Este espacio reúne utilidades prácticas para sus decisiones financieras. El conversor de divisas usa los tipos en tiempo real cargados al conectarse. Otras herramientas (calculadora de dividendos compuestos, simulador de retiradas, etc.) se añadirán aquí progresivamente.'
    },
    pwa: {
      installed: 'App instalada',
      installedTip: 'Está usando Auto-Gère desde la aplicación instalada',
      installBtn: 'Instalar la app',
      installTip: 'Instale Auto-Gère como app en su ordenador (acceso directo + ventana dedicada)',
      previewBanner1: 'Está en el entorno de PRUEBA. Vaya a',
      previewBanner2: 'para la aplicación real.'
    }
  }
};

